import { jsx as b, jsxs as Q, Fragment as It } from "react/jsx-runtime";
import * as y from "react";
import { useState as te, useEffect as ae, createElement as Me, useImperativeHandle as Vc, createContext as qc, Children as Jr, useMemo as In, useContext as Hc, useRef as Re, useCallback as W, useLayoutEffect as Jc, forwardRef as Xc } from "react";
import { AlertBox as Dt, Icon as Xr, Input as kt, Button as Bt, Tooltip as zc } from "@iwoca/orion";
import se from "classnames";
const Gn = (e) => {
  try {
    return JSON.parse(e).errors[0];
  } catch {
  }
  return null;
}, Qc = (e) => {
  try {
    const t = JSON.parse(e.message).errors[0], n = new URLSearchParams(window.location.search);
    return t.code === "TwoFactorSetupRequired" ? (n.set("k", t.meta.authentication_token), {
      action: "setup",
      url: `/login/two-factor/setup/?${decodeURIComponent(
        n.toString()
      )}`,
      authToken: t.meta.authentication_token
    }) : t.code === "TwoFactorAuthenticationRequired" ? (n.set("k", t.meta.authentication_token), {
      action: "authenticate",
      url: `/login/two-factor/authenticate/?${decodeURIComponent(
        n.toString()
      )}`,
      authToken: t.meta.authentication_token
    }) : {
      action: "none",
      url: null,
      authToken: null
    };
  } catch {
    return {
      action: "none",
      url: null,
      authToken: null
    };
  }
}, zr = ({
  lapiError: e,
  email: t,
  submitNotification: n
}) => {
  try {
    if (JSON.parse(e.message).errors[0].code === "MultipleIwocaPaySellers") {
      if (sessionStorage.notifyBrokenAccount) return;
      sessionStorage.notifyBrokenAccount = !0, n({
        data: {
          type: "broken-account",
          attributes: { email: t }
        }
      });
    }
  } catch {
  }
}, x_ = ({
  loginMethod: e = "passwordless",
  redirectURL: t,
  onSuccessfulLogin: n,
  onSuccessfulLinkSent: r,
  copy: i = {},
  styles: o = {}
}) => {
  const [c, l] = te(e), [s, f] = te();
  ae(() => {
    l(e);
  }, [e]);
  const h = () => {
    l(c === "password" ? "passwordless" : "password");
  }, O = (d) => {
    const { action: m, url: _, authToken: T } = Qc(d);
    m === "authenticate" ? f(T) : m === "setup" && _ && (window.location.href = _);
  };
  return s ? /* @__PURE__ */ b(
    J_,
    {
      authToken: s,
      copy: i.mfa,
      onSuccessfulLogin: n
    }
  ) : c === "password" ? /* @__PURE__ */ b(
    _u,
    {
      copy: i,
      styles: o.password,
      onSuccessfulLogin: n,
      isTwoFactorRequired: O,
      switchLoginMethod: h
    }
  ) : /* @__PURE__ */ b(
    hu,
    {
      copy: i,
      styles: o.passwordless,
      redirectURL: t,
      onSuccessfulLinkSent: r,
      isTwoFactorRequired: O,
      switchLoginMethod: h
    }
  );
};
function Qr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var fn = {}, re = {}, tr;
function nr() {
  if (tr) return re;
  tr = 1;
  var e = re && re.__awaiter || function(d, m, _, T) {
    function I(E) {
      return E instanceof _ ? E : new _(function(S) {
        S(E);
      });
    }
    return new (_ || (_ = Promise))(function(E, S) {
      function C(R) {
        try {
          p(T.next(R));
        } catch (L) {
          S(L);
        }
      }
      function P(R) {
        try {
          p(T.throw(R));
        } catch (L) {
          S(L);
        }
      }
      function p(R) {
        R.done ? E(R.value) : I(R.value).then(C, P);
      }
      p((T = T.apply(d, m || [])).next());
    });
  };
  Object.defineProperty(re, "__esModule", { value: !0 }), re.fetchLendingAPI = re.fetchLendingAPIJSON = re.LapiError = re.API_AUTH_TOKEN = void 0, re.API_AUTH_TOKEN = "Token iwoca-9e4606290c6294a6b40e15c9bb75cd2daf0";
  class t extends Error {
    constructor(m, _) {
      super(_), this.name = "LapiError", this.statusCode = m;
    }
  }
  re.LapiError = t;
  function n(d, { method: m = "get", query: _, body: T, overrideHeaders: I } = {}) {
    return e(this, void 0, void 0, function* () {
      const E = yield r(d, {
        method: m,
        query: _,
        body: T,
        overrideHeaders: I
      });
      if (!E.ok)
        throw new t(E.status, yield E.text());
      return yield E.json();
    });
  }
  re.fetchLendingAPIJSON = n;
  function r(d, { method: m = "get", query: _, body: T, overrideHeaders: I } = {}) {
    return e(this, void 0, void 0, function* () {
      const E = i(_), S = `${d}${E}`, C = yield c(m)({
        url: S,
        body: T,
        headers: I
      });
      if (!C.ok)
        throw new t(C.status, yield C.text());
      return C;
    });
  }
  re.fetchLendingAPI = r;
  function i(d) {
    if (!d)
      return "";
    const m = o(d);
    return `?${new URLSearchParams(m).toString()}`;
  }
  function o(d) {
    const m = Object.entries(d).filter(([_, T]) => T != null).map(([_, T]) => Array.isArray(T) ? [_, T.join(",")] : [_, String(T)]);
    return Object.fromEntries(m);
  }
  function c(d) {
    switch (d) {
      case "get":
        return l;
      case "post":
        return s;
      case "put":
        return f;
      case "delete":
        return h;
    }
  }
  function l({ url: d, headers: m }) {
    return fetch(d, {
      credentials: "same-origin",
      headers: Object.assign({ "Content-Type": "application/json;charset=UTF-8" }, m)
    });
  }
  function s({ url: d, body: m, headers: _ }) {
    return fetch(d, Object.assign({ method: "POST", credentials: "same-origin", headers: Object.assign({ "Content-Type": "application/json;charset=UTF-8", "x-csrftoken": O("csrftoken") }, _) }, m && { body: JSON.stringify(m) }));
  }
  function f({ url: d, body: m, headers: _ }) {
    return fetch(d, {
      method: "PUT",
      credentials: "same-origin",
      headers: Object.assign({ "Content-Type": "application/json;charset=UTF-8", "x-csrftoken": O("csrftoken") }, _),
      body: JSON.stringify(m)
    });
  }
  function h({ url: d, body: m, headers: _ }) {
    return fetch(d, {
      method: "DELETE",
      credentials: "same-origin",
      headers: Object.assign({ "Content-Type": "application/json;charset=UTF-8", "x-csrftoken": O("csrftoken") }, _),
      body: JSON.stringify(m)
    });
  }
  function O(d) {
    var m, _;
    const I = `; ${document.cookie}`.split(`; ${d}=`);
    if (I.length === 2)
      return (_ = (m = I == null ? void 0 : I.pop()) === null || m === void 0 ? void 0 : m.split(";")) === null || _ === void 0 ? void 0 : _.shift();
  }
  return re;
}
var rr;
function Zc() {
  return rr || (rr = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_RECOVERY_LOAN_KEY = e.fetchGetDrawDownRepaymentScheduleIwocapay = e.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_IWOCAPAY_KEY = e.fetchGetDrawDownRepaymentScheduleFlexi24 = e.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_FLEXI_24_KEY = e.fetchGetDrawDownRepaymentScheduleCreditFacility = e.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_CREDIT_FACILITY_KEY = e.fetchPutDocumentUpload = e.PUT_DOCUMENT_UPLOAD_KEY = e.fetchPostDocumentUpload = e.POST_DOCUMENT_UPLOAD_KEY = e.fetchGetDocumentUpload = e.GET_DOCUMENT_UPLOAD_KEY = e.fetchGetDocumentFeedback = e.GET_DOCUMENT_FEEDBACK_KEY = e.fetchGetDirectorSearch = e.GET_DIRECTOR_SEARCH_KEY = e.fetchGetContext = e.GET_CONTEXT_KEY = e.fetchGetContextByStateKey = e.GET_CONTEXT_BY_STATE_KEY_KEY = e.fetchGetCompanySearch = e.GET_COMPANY_SEARCH_KEY = e.fetchGetAssociatedPeople = e.GET_ASSOCIATED_PEOPLE_KEY = e.fetchGetApplicationsOffers = e.GET_APPLICATIONS_OFFERS_KEY = e.fetchPostApplicationRefresh = e.POST_APPLICATION_REFRESH_KEY = e.fetchPostApplicationDefer = e.POST_APPLICATION_DEFER_KEY = e.fetchPostApplicationDecline = e.POST_APPLICATION_DECLINE_KEY = e.fetchPostApplicationCustomerConfirmedProvidingDocs = e.POST_APPLICATION_CUSTOMER_CONFIRMED_PROVIDING_DOCS_KEY = e.fetchGetApplicationCustomerConfirmedProvidingDocs = e.GET_APPLICATION_CUSTOMER_CONFIRMED_PROVIDING_DOCS_KEY = e.fetchPutApplication = e.PUT_APPLICATION_KEY = e.fetchPostApplication = e.POST_APPLICATION_KEY = e.fetchGetApplication = e.GET_APPLICATION_KEY = e.fetchPostAnonymisedDataEvaluation = e.POST_ANONYMISED_DATA_EVALUATION_KEY = e.fetchGetAccounts = e.GET_ACCOUNTS_KEY = e.LapiError = e.fetchLendingAPIJSON = e.fetchLendingAPI = void 0, e.POST_FORMAL_OFFERS_FLEXI_24_COMMISSION_CONSENT_KEY = e.fetchGetFormalOffersFlexi24CommissionConsent = e.GET_FORMAL_OFFERS_FLEXI_24_COMMISSION_CONSENT_KEY = e.fetchPutFormalOffersCreditFacilityConfiguration = e.PUT_FORMAL_OFFERS_CREDIT_FACILITY_CONFIGURATION_KEY = e.fetchGetFormalOffersCreditFacilityConfiguration = e.GET_FORMAL_OFFERS_CREDIT_FACILITY_CONFIGURATION_KEY = e.fetchPostFormalOffersCreditFacilityCommissionConsent = e.POST_FORMAL_OFFERS_CREDIT_FACILITY_COMMISSION_CONSENT_KEY = e.fetchGetFormalOffersCreditFacilityCommissionConsent = e.GET_FORMAL_OFFERS_CREDIT_FACILITY_COMMISSION_CONSENT_KEY = e.fetchPutFormalOffersCbilsConfiguration = e.PUT_FORMAL_OFFERS_CBILS_CONFIGURATION_KEY = e.fetchGetFormalOffersCbilsConfiguration = e.GET_FORMAL_OFFERS_CBILS_CONFIGURATION_KEY = e.fetchPostFormalOffersCbilsCommissionConsent = e.POST_FORMAL_OFFERS_CBILS_COMMISSION_CONSENT_KEY = e.fetchGetFormalOffersCbilsCommissionConsent = e.GET_FORMAL_OFFERS_CBILS_COMMISSION_CONSENT_KEY = e.fetchPutFormalOffersBusinessLoanConfiguration = e.PUT_FORMAL_OFFERS_BUSINESS_LOAN_CONFIGURATION_KEY = e.fetchGetFormalOffersBusinessLoanConfiguration = e.GET_FORMAL_OFFERS_BUSINESS_LOAN_CONFIGURATION_KEY = e.fetchPostFormalOffersBusinessLoanCommissionConsent = e.POST_FORMAL_OFFERS_BUSINESS_LOAN_COMMISSION_CONSENT_KEY = e.fetchGetFormalOffersBusinessLoanCommissionConsent = e.GET_FORMAL_OFFERS_BUSINESS_LOAN_COMMISSION_CONSENT_KEY = e.fetchPostFormalOffers = e.POST_FORMAL_OFFERS_KEY = e.fetchGetFormalOffers = e.GET_FORMAL_OFFERS_KEY = e.fetchPostFormalIndicativeOffers = e.POST_FORMAL_INDICATIVE_OFFERS_KEY = e.fetchGetFormalIndicativeOffers = e.GET_FORMAL_INDICATIVE_OFFERS_KEY = e.fetchGetExampleRepaymentSchedule = e.GET_EXAMPLE_REPAYMENT_SCHEDULE_KEY = e.fetchGetEmailAvailability = e.GET_EMAIL_AVAILABILITY_KEY = e.fetchPostEcommerceSellerOrder = e.POST_ECOMMERCE_SELLER_ORDER_KEY = e.fetchGetEcommerceOrder = e.GET_ECOMMERCE_ORDER_KEY = e.fetchDeleteEcommerceOrder = e.DELETE_ECOMMERCE_ORDER_KEY = e.fetchPostEarlyRepaymentTruelayer = e.POST_EARLY_REPAYMENT_TRUELAYER_KEY = e.fetchGetEarlyRepaymentSimulation = e.GET_EARLY_REPAYMENT_SIMULATION_KEY = e.fetchGetDrawDownRepaymentScheduleRecoveryLoan = void 0, e.GET_FUNDING_REQUIREMENTS_CREDIT_FACILITY_KEY = e.fetchGetFundingRequirementsCbils = e.GET_FUNDING_REQUIREMENTS_CBILS_KEY = e.fetchGetFundingRequirementsBusinessLoan = e.GET_FUNDING_REQUIREMENTS_BUSINESS_LOAN_KEY = e.fetchPostFundingRequestRecoveryLoan = e.POST_FUNDING_REQUEST_RECOVERY_LOAN_KEY = e.fetchPostFundingRequestMerchantCashAdvance = e.POST_FUNDING_REQUEST_MERCHANT_CASH_ADVANCE_KEY = e.fetchPostFundingRequestIwocapay = e.POST_FUNDING_REQUEST_IWOCAPAY_KEY = e.fetchPostFundingRequestFlexi24 = e.POST_FUNDING_REQUEST_FLEXI_24_KEY = e.fetchPostFundingRequestCreditFacility = e.POST_FUNDING_REQUEST_CREDIT_FACILITY_KEY = e.fetchPostFundingRequestCbils = e.POST_FUNDING_REQUEST_CBILS_KEY = e.fetchPostFundingRequestBusinessLoan = e.POST_FUNDING_REQUEST_BUSINESS_LOAN_KEY = e.fetchPostFundSellerRequest = e.POST_FUND_SELLER_REQUEST_KEY = e.fetchPutFormalOffersRecoveryLoanConfiguration = e.PUT_FORMAL_OFFERS_RECOVERY_LOAN_CONFIGURATION_KEY = e.fetchGetFormalOffersRecoveryLoanConfiguration = e.GET_FORMAL_OFFERS_RECOVERY_LOAN_CONFIGURATION_KEY = e.fetchPostFormalOffersRecoveryLoanCommissionConsent = e.POST_FORMAL_OFFERS_RECOVERY_LOAN_COMMISSION_CONSENT_KEY = e.fetchGetFormalOffersRecoveryLoanCommissionConsent = e.GET_FORMAL_OFFERS_RECOVERY_LOAN_COMMISSION_CONSENT_KEY = e.fetchPutFormalOffersMerchantCashAdvanceConfiguration = e.PUT_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_CONFIGURATION_KEY = e.fetchGetFormalOffersMerchantCashAdvanceConfiguration = e.GET_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_CONFIGURATION_KEY = e.fetchPostFormalOffersMerchantCashAdvanceCommissionConsent = e.POST_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_COMMISSION_CONSENT_KEY = e.fetchGetFormalOffersMerchantCashAdvanceCommissionConsent = e.GET_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_COMMISSION_CONSENT_KEY = e.fetchPutFormalOffersIwocapayConfiguration = e.PUT_FORMAL_OFFERS_IWOCAPAY_CONFIGURATION_KEY = e.fetchGetFormalOffersIwocapayConfiguration = e.GET_FORMAL_OFFERS_IWOCAPAY_CONFIGURATION_KEY = e.fetchPostFormalOffersIwocapayCommissionConsent = e.POST_FORMAL_OFFERS_IWOCAPAY_COMMISSION_CONSENT_KEY = e.fetchGetFormalOffersIwocapayCommissionConsent = e.GET_FORMAL_OFFERS_IWOCAPAY_COMMISSION_CONSENT_KEY = e.fetchPutFormalOffersFlexi24Configuration = e.PUT_FORMAL_OFFERS_FLEXI_24_CONFIGURATION_KEY = e.fetchGetFormalOffersFlexi24Configuration = e.GET_FORMAL_OFFERS_FLEXI_24_CONFIGURATION_KEY = e.fetchPostFormalOffersFlexi24CommissionConsent = void 0, e.GET_IWOCAPAY_PAY_LINK_PACKAGE_KEY = e.fetchPostIwocapayNotifications = e.POST_IWOCAPAY_NOTIFICATIONS_KEY = e.fetchPostIwocapayBuyerSpendingLimitRequest = e.POST_IWOCAPAY_BUYER_SPENDING_LIMIT_REQUEST_KEY = e.fetchGetIwocapayBuyerSpendingLimitRequest = e.GET_IWOCAPAY_BUYER_SPENDING_LIMIT_REQUEST_KEY = e.fetchPostIwocapayBuyerRefreshSpendingLimit = e.POST_IWOCAPAY_BUYER_REFRESH_SPENDING_LIMIT_KEY = e.fetchGetIwocapayBuyerPayLinks = e.GET_IWOCAPAY_BUYER_PAY_LINKS_KEY = e.fetchGetIwocapayBuyerPayLinkPackage = e.GET_IWOCAPAY_BUYER_PAY_LINK_PACKAGE_KEY = e.fetchPostIntroducerLinkOpenBankingEmail = e.POST_INTRODUCER_LINK_OPEN_BANKING_EMAIL_KEY = e.fetchGetIntroducerContext = e.GET_INTRODUCER_CONTEXT_KEY = e.fetchGetIntroducerContextByIntroducerId = e.GET_INTRODUCER_CONTEXT_BY_INTRODUCER_ID_KEY = e.fetchGetIntroducerApplications = e.GET_INTRODUCER_APPLICATIONS_KEY = e.fetchGetIntroducerApplicationRejectOfferReasons = e.GET_INTRODUCER_APPLICATION_REJECT_OFFER_REASONS_KEY = e.fetchPutIntroducerApplicationOfferWithdrawalFeeRate = e.PUT_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = e.fetchGetIntroducerApplicationOfferWithdrawalFeeRate = e.GET_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = e.fetchGetIntroducerApplicationOfferFundingRequirements = e.GET_INTRODUCER_APPLICATION_OFFER_FUNDING_REQUIREMENTS_KEY = e.fetchPutIntroducerApplicationOfferEntityToContact = e.PUT_INTRODUCER_APPLICATION_OFFER_ENTITY_TO_CONTACT_KEY = e.fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates = e.GET_INTRODUCER_APPLICATION_OFFER_ALLOWED_WITHDRAWAL_FEE_RATES_KEY = e.fetchGetIntroducerApplication = e.GET_INTRODUCER_APPLICATION_KEY = e.fetchGetIntroducer = e.GET_INTRODUCER_KEY = e.fetchGetIntroducerRepaymentSimulator = e.GET_INTRODUCER_REPAYMENT_SIMULATOR_KEY = e.fetchPostIntroducer = e.POST_INTRODUCER_KEY = e.fetchGetFundingRequirementsRecoveryLoan = e.GET_FUNDING_REQUIREMENTS_RECOVERY_LOAN_KEY = e.fetchGetFundingRequirementsMerchantCashAdvance = e.GET_FUNDING_REQUIREMENTS_MERCHANT_CASH_ADVANCE_KEY = e.fetchGetFundingRequirementsIwocapay = e.GET_FUNDING_REQUIREMENTS_IWOCAPAY_KEY = e.fetchGetFundingRequirementsFlexi24 = e.GET_FUNDING_REQUIREMENTS_FLEXI_24_KEY = e.fetchGetFundingRequirementsCreditFacility = void 0, e.GET_IWOCAPAY_SHOPIFY_INSTALL_KEY = e.fetchPostIwocapayShopifyGdprRetrieveCustomer = e.POST_IWOCAPAY_SHOPIFY_GDPR_RETRIEVE_CUSTOMER_KEY = e.fetchPostIwocapayShopifyGdprRedactShop = e.POST_IWOCAPAY_SHOPIFY_GDPR_REDACT_SHOP_KEY = e.fetchPostIwocapayShopifyGdprRedactCustomer = e.POST_IWOCAPAY_SHOPIFY_GDPR_REDACT_CUSTOMER_KEY = e.fetchPostIwocapaySellerOnboardingAnswers = e.POST_IWOCAPAY_SELLER_ONBOARDING_ANSWERS_KEY = e.fetchGetIwocapaySellerOnboardingAnswers = e.GET_IWOCAPAY_SELLER_ONBOARDING_ANSWERS_KEY = e.fetchGetIwocapaySellerSpendingLimitRequest = e.GET_IWOCAPAY_SELLER_SPENDING_LIMIT_REQUEST_KEY = e.fetchPostIwocapaySellerResendInvite = e.POST_IWOCAPAY_SELLER_RESEND_INVITE_KEY = e.fetchPutIwocapaySellerPaymentCapturedFund = e.PUT_IWOCAPAY_SELLER_PAYMENT_CAPTURED_FUND_KEY = e.fetchPutIwocapaySellerPaymentCapturedCancel = e.PUT_IWOCAPAY_SELLER_PAYMENT_CAPTURED_CANCEL_KEY = e.fetchPostIwocapaySellerEcommerceCredentials = e.POST_IWOCAPAY_SELLER_ECOMMERCE_CREDENTIALS_KEY = e.fetchGetIwocapaySellerEcommerceCredentials = e.GET_IWOCAPAY_SELLER_ECOMMERCE_CREDENTIALS_KEY = e.fetchGetIwocapaySellerConnection = e.GET_IWOCAPAY_SELLER_CONNECTION_KEY = e.fetchGetIwocapaySellerBranding = e.GET_IWOCAPAY_SELLER_BRANDING_KEY = e.fetchPostIwocapaySellerAccessUsers = e.POST_IWOCAPAY_SELLER_ACCESS_USERS_KEY = e.fetchGetIwocapaySellerAccessUsers = e.GET_IWOCAPAY_SELLER_ACCESS_USERS_KEY = e.fetchPutIwocapaySellerAccessUser = e.PUT_IWOCAPAY_SELLER_ACCESS_USER_KEY = e.fetchDeleteIwocapaySellerAccessUser = e.DELETE_IWOCAPAY_SELLER_ACCESS_USER_KEY = e.fetchGetIwocapayReferrer = e.GET_IWOCAPAY_REFERRER_KEY = e.fetchGetIwocapayReferrals = e.GET_IWOCAPAY_REFERRALS_KEY = e.fetchGetIwocapayReferral = e.GET_IWOCAPAY_REFERRAL_KEY = e.fetchPostIwocapayPaymentLater = e.POST_IWOCAPAY_PAYMENT_LATER_KEY = e.fetchGetIwocapayPaymentLater = e.GET_IWOCAPAY_PAYMENT_LATER_KEY = e.fetchGetIwocapayPaymentCaptured = e.GET_IWOCAPAY_PAYMENT_CAPTURED_KEY = e.fetchPostIwocapayPayLinkPackage = e.POST_IWOCAPAY_PAY_LINK_PACKAGE_KEY = e.fetchGetIwocapayPayLinkPackage = void 0, e.GET_ONLINE_ACCOUNT_KEY = e.fetchPostOnfidoToken = e.POST_ONFIDO_TOKEN_KEY = e.fetchPostOnfidoStart = e.POST_ONFIDO_START_KEY = e.fetchPostOnfidoChecks = e.POST_ONFIDO_CHECKS_KEY = e.fetchPostOnfidoCheck = e.POST_ONFIDO_CHECK_KEY = e.fetchGetOnfidoCheck = e.GET_ONFIDO_CHECK_KEY = e.fetchPostOffersSelect = e.POST_OFFERS_SELECT_KEY = e.fetchGetMcaEstimatedSchedule = e.GET_MCA_ESTIMATED_SCHEDULE_KEY = e.fetchPostLogout = e.POST_LOGOUT_KEY = e.fetchGetLoginLink = e.GET_LOGIN_LINK_KEY = e.fetchGetLoanDocumentsUnsigned = e.GET_LOAN_DOCUMENTS_UNSIGNED_KEY = e.fetchGetLoanDocumentsSigned = e.GET_LOAN_DOCUMENTS_SIGNED_KEY = e.fetchPostLoanDocumentsSigned = e.POST_LOAN_DOCUMENTS_SIGNED_KEY = e.fetchGetLoanDocumentsRequiredRecoveryLoan = e.GET_LOAN_DOCUMENTS_REQUIRED_RECOVERY_LOAN_KEY = e.fetchGetLoanDocumentsRequiredMerchantCashAdvance = e.GET_LOAN_DOCUMENTS_REQUIRED_MERCHANT_CASH_ADVANCE_KEY = e.fetchGetLoanDocumentsRequiredIwocapay = e.GET_LOAN_DOCUMENTS_REQUIRED_IWOCAPAY_KEY = e.fetchGetLoanDocumentsRequiredFlexi24 = e.GET_LOAN_DOCUMENTS_REQUIRED_FLEXI_24_KEY = e.fetchGetLoanDocumentsRequiredCreditFacility = e.GET_LOAN_DOCUMENTS_REQUIRED_CREDIT_FACILITY_KEY = e.fetchGetLoanDocumentsRequiredCbils = e.GET_LOAN_DOCUMENTS_REQUIRED_CBILS_KEY = e.fetchGetLoanDocumentsRequiredBusinessLoan = e.GET_LOAN_DOCUMENTS_REQUIRED_BUSINESS_LOAN_KEY = e.fetchGetLoanDocuments = e.GET_LOAN_DOCUMENTS_KEY = e.fetchGetIwocapayShopifySellerShop = e.GET_IWOCAPAY_SHOPIFY_SELLER_SHOP_KEY = e.fetchGetIwocapayShopifyPostGrant = e.GET_IWOCAPAY_SHOPIFY_POST_GRANT_KEY = e.fetchPostIwocapayShopifyPaymentRefund = e.POST_IWOCAPAY_SHOPIFY_PAYMENT_REFUND_KEY = e.fetchPostIwocapayShopifyPayment = e.POST_IWOCAPAY_SHOPIFY_PAYMENT_KEY = e.fetchGetIwocapayShopifyInstall = void 0, e.POST_QUICKBOOKS_WEBHOOK_KEY = e.fetchPostQuickbooksDisconnect = e.POST_QUICKBOOKS_DISCONNECT_KEY = e.fetchGetQuickbooksAuthorizationRedirect = e.GET_QUICKBOOKS_AUTHORIZATION_REDIRECT_KEY = e.fetchGetQuickbooksAuthorizationCallback = e.GET_QUICKBOOKS_AUTHORIZATION_CALLBACK_KEY = e.fetchGetProfile = e.GET_PROFILE_KEY = e.fetchGetProductOffers = e.GET_PRODUCT_OFFERS_KEY = e.fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation = e.GET_PRODUCT_OFFERS_BY_RESTRICTED_EXTERNAL_DATA_SYNCS_AUTHORISATION_KEY = e.fetchGetPostcodeLookup = e.GET_POSTCODE_LOOKUP_KEY = e.fetchPutPaymentMethod = e.PUT_PAYMENT_METHOD_KEY = e.fetchDeletePaymentMethod = e.DELETE_PAYMENT_METHOD_KEY = e.fetchPostPaymentMethod = e.POST_PAYMENT_METHOD_KEY = e.fetchGetPaymentMethod = e.GET_PAYMENT_METHOD_KEY = e.fetchPostPayLinkApplication = e.POST_PAY_LINK_APPLICATION_KEY = e.fetchGetPayLink = e.GET_PAY_LINK_KEY = e.fetchGetPayLinkGo = e.GET_PAY_LINK_GO_KEY = e.fetchPostPasswordlessEmailLogin = e.POST_PASSWORDLESS_EMAIL_LOGIN_KEY = e.fetchPostPasswordlessEmail = e.POST_PASSWORDLESS_EMAIL_KEY = e.fetchPostPasswordResetVerify = e.POST_PASSWORD_RESET_VERIFY_KEY = e.fetchPostPasswordResetSetPassword = e.POST_PASSWORD_RESET_SET_PASSWORD_KEY = e.fetchPostPasswordReset = e.POST_PASSWORD_RESET_KEY = e.fetchPostPasswordLogin = e.POST_PASSWORD_LOGIN_KEY = e.fetchPostPartnerDeveloper = e.POST_PARTNER_DEVELOPER_KEY = e.fetchGetPartnerBrokers = e.GET_PARTNER_BROKERS_KEY = e.fetchPostPageView = e.POST_PAGE_VIEW_KEY = e.fetchDeleteOnlineAccount = e.DELETE_ONLINE_ACCOUNT_KEY = e.fetchGetOnlineAccount = void 0, e.PUT_STATE_KEY = e.fetchGetState = e.GET_STATE_KEY = e.fetchGetStateByStateKey = e.GET_STATE_BY_STATE_KEY_KEY = e.fetchPostState = e.POST_STATE_KEY = e.fetchGetSplitTest = e.GET_SPLIT_TEST_KEY = e.fetchGetSingleImmediatePayment = e.GET_SINGLE_IMMEDIATE_PAYMENT_KEY = e.fetchGetSignupBranding = e.GET_SIGNUP_BRANDING_KEY = e.fetchGetSellerOnboardingRequirements = e.GET_SELLER_ONBOARDING_REQUIREMENTS_KEY = e.fetchPutSellerAgreementDocumentSign = e.PUT_SELLER_AGREEMENT_DOCUMENT_SIGN_KEY = e.fetchGetSellerAgreementDocumentDownload = e.GET_SELLER_AGREEMENT_DOCUMENT_DOWNLOAD_KEY = e.fetchGetSellerAgreementDocument = e.GET_SELLER_AGREEMENT_DOCUMENT_KEY = e.fetchPostSellerIntegrationsRegisterInterest = e.POST_SELLER_INTEGRATIONS_REGISTER_INTEREST_KEY = e.fetchGetSellerIntegrationsRegisterInterest = e.GET_SELLER_INTEGRATIONS_REGISTER_INTEREST_KEY = e.fetchPostSellerHandle = e.POST_SELLER_HANDLE_KEY = e.fetchPutSellerEnabledProducts = e.PUT_SELLER_ENABLED_PRODUCTS_KEY = e.fetchGetSellerEnabledProducts = e.GET_SELLER_ENABLED_PRODUCTS_KEY = e.fetchPostSeller = e.POST_SELLER_KEY = e.fetchGetSeller = e.GET_SELLER_KEY = e.fetchGetSellerHandleAvailability = e.GET_SELLER_HANDLE_AVAILABILITY_KEY = e.fetchGetSellerHandle = e.GET_SELLER_HANDLE_KEY = e.fetchGetSelectPaymentProcessor = e.GET_SELECT_PAYMENT_PROCESSOR_KEY = e.fetchPostRepaymentRegisterRepaymentMethod = e.POST_REPAYMENT_REGISTER_REPAYMENT_METHOD_KEY = e.fetchPostRepaymentPaymentMethod = e.POST_REPAYMENT_PAYMENT_METHOD_KEY = e.fetchGetRepaymentPaymentMethod = e.GET_REPAYMENT_PAYMENT_METHOD_KEY = e.fetchPostRepaymentPaymentIntent = e.POST_REPAYMENT_PAYMENT_INTENT_KEY = e.fetchPostQuickbooksWebhook = void 0, e.fetchPutXeroOrganisationAccount = e.PUT_XERO_ORGANISATION_ACCOUNT_KEY = e.fetchPostXeroOrganisationAccount = e.POST_XERO_ORGANISATION_ACCOUNT_KEY = e.fetchGetXeroOrganisationAccount = e.GET_XERO_ORGANISATION_ACCOUNT_KEY = e.fetchPostXeroLogin = e.POST_XERO_LOGIN_KEY = e.fetchGetXeroLogin = e.GET_XERO_LOGIN_KEY = e.fetchPostXeroIwocapaySellerBrandingThemesPaymentServices = e.POST_XERO_IWOCAPAY_SELLER_BRANDING_THEMES_PAYMENT_SERVICES_KEY = e.fetchGetXeroIwocapaySellerBrandingThemes = e.GET_XERO_IWOCAPAY_SELLER_BRANDING_THEMES_KEY = e.fetchPutXeroIwocapaySellerAccount = e.PUT_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = e.fetchPostXeroIwocapaySellerAccount = e.POST_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = e.fetchGetXeroIwocapaySellerAccount = e.GET_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = e.fetchGetXeroConnections = e.GET_XERO_CONNECTIONS_KEY = e.fetchDeleteXeroConnections = e.DELETE_XERO_CONNECTIONS_KEY = e.fetchPostXeroConnect = e.POST_XERO_CONNECT_KEY = e.fetchGetXeroCallback = e.GET_XERO_CALLBACK_KEY = e.fetchGetXeroAccounts = e.GET_XERO_ACCOUNTS_KEY = e.fetchPostTwoFactorSetup = e.POST_TWO_FACTOR_SETUP_KEY = e.fetchGetTwoFactorSetup = e.GET_TWO_FACTOR_SETUP_KEY = e.fetchPostTwoFactorAuthenticate = e.POST_TWO_FACTOR_AUTHENTICATE_KEY = e.fetchGetTruelayerPayment = e.GET_TRUELAYER_PAYMENT_KEY = e.fetchPostTruelayerBankAuthenticationUrl = e.POST_TRUELAYER_BANK_AUTHENTICATION_URL_KEY = e.fetchPostTruelayerAuthorizationUrl = e.POST_TRUELAYER_AUTHORIZATION_URL_KEY = e.fetchPutThreatmetrixEvent = e.PUT_THREATMETRIX_EVENT_KEY = e.fetchPostThreatmetrixEvent = e.POST_THREATMETRIX_EVENT_KEY = e.fetchGetStatements = e.GET_STATEMENTS_KEY = e.fetchPutState = void 0;
    const t = nr();
    var n = nr();
    Object.defineProperty(e, "fetchLendingAPI", { enumerable: !0, get: function() {
      return n.fetchLendingAPI;
    } }), Object.defineProperty(e, "fetchLendingAPIJSON", { enumerable: !0, get: function() {
      return n.fetchLendingAPIJSON;
    } }), Object.defineProperty(e, "LapiError", { enumerable: !0, get: function() {
      return n.LapiError;
    } }), e.GET_ACCOUNTS_KEY = "getAccounts";
    function r({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/accounts/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetAccounts = r, e.POST_ANONYMISED_DATA_EVALUATION_KEY = "postAnonymisedDataEvaluation";
    function i({ body: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/anonymised_data_evaluation/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostAnonymisedDataEvaluation = i, e.GET_APPLICATION_KEY = "getApplication";
    function o({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/application/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetApplication = o, e.POST_APPLICATION_KEY = "postApplication";
    function c({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/application/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostApplication = c, e.PUT_APPLICATION_KEY = "putApplication";
    function l({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/application/${a}/`, {
        method: "put",
        body: u
      });
    }
    e.fetchPutApplication = l, e.GET_APPLICATION_CUSTOMER_CONFIRMED_PROVIDING_DOCS_KEY = "getApplicationCustomerConfirmedProvidingDocs";
    function s({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/application/${a}/customer_confirmed_providing_docs/`, {
        method: "get"
      });
    }
    e.fetchGetApplicationCustomerConfirmedProvidingDocs = s, e.POST_APPLICATION_CUSTOMER_CONFIRMED_PROVIDING_DOCS_KEY = "postApplicationCustomerConfirmedProvidingDocs";
    function f({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/application/${a}/customer_confirmed_providing_docs/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostApplicationCustomerConfirmedProvidingDocs = f, e.POST_APPLICATION_DECLINE_KEY = "postApplicationDecline";
    function h({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/application/${a}/decline/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostApplicationDecline = h, e.POST_APPLICATION_DEFER_KEY = "postApplicationDefer";
    function O({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/application/${a}/defer/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostApplicationDefer = O, e.POST_APPLICATION_REFRESH_KEY = "postApplicationRefresh";
    function d({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/application/${a}/refresh/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostApplicationRefresh = d, e.GET_APPLICATIONS_OFFERS_KEY = "getApplicationsOffers";
    function m({ applicationId: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/applications/${a}/offers/`, {
        method: "get"
      });
    }
    e.fetchGetApplicationsOffers = m, e.GET_ASSOCIATED_PEOPLE_KEY = "getAssociatedPeople";
    function _({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/associated_people/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetAssociatedPeople = _, e.GET_COMPANY_SEARCH_KEY = "getCompanySearch";
    function T({ query: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/company_search/", {
        method: "get",
        query: a
      });
    }
    e.fetchGetCompanySearch = T, e.GET_CONTEXT_BY_STATE_KEY_KEY = "getContextByStateKey";
    function I({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/context/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetContextByStateKey = I, e.GET_CONTEXT_KEY = "getContext";
    function E({}) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/context/", {
        method: "get"
      });
    }
    e.fetchGetContext = E, e.GET_DIRECTOR_SEARCH_KEY = "getDirectorSearch";
    function S({ companyNumber: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/director_search/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetDirectorSearch = S, e.GET_DOCUMENT_FEEDBACK_KEY = "getDocumentFeedback";
    function C({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/document_feedback/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetDocumentFeedback = C, e.GET_DOCUMENT_UPLOAD_KEY = "getDocumentUpload";
    function P({ stateKey: a, query: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/document_upload/${a}/`, {
        method: "get",
        query: u
      });
    }
    e.fetchGetDocumentUpload = P, e.POST_DOCUMENT_UPLOAD_KEY = "postDocumentUpload";
    function p({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/document_upload/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostDocumentUpload = p, e.PUT_DOCUMENT_UPLOAD_KEY = "putDocumentUpload";
    function R({ stateKey: a, documentId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/document_upload/${a}/${u}/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutDocumentUpload = R, e.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_CREDIT_FACILITY_KEY = "getDrawDownRepaymentScheduleCreditFacility";
    function L({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/draw_down_repayment_schedule/${a}/credit_facility/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetDrawDownRepaymentScheduleCreditFacility = L, e.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_FLEXI_24_KEY = "getDrawDownRepaymentScheduleFlexi24";
    function U({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/draw_down_repayment_schedule/${a}/flexi24/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetDrawDownRepaymentScheduleFlexi24 = U, e.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_IWOCAPAY_KEY = "getDrawDownRepaymentScheduleIwocapay";
    function Y({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/draw_down_repayment_schedule/${a}/iwocapay/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetDrawDownRepaymentScheduleIwocapay = Y, e.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_RECOVERY_LOAN_KEY = "getDrawDownRepaymentScheduleRecoveryLoan";
    function H({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/draw_down_repayment_schedule/${a}/recovery_loan/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetDrawDownRepaymentScheduleRecoveryLoan = H, e.GET_EARLY_REPAYMENT_SIMULATION_KEY = "getEarlyRepaymentSimulation";
    function K({ stateKey: a, accountId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/early_repayment_simulation/${a}/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetEarlyRepaymentSimulation = K, e.POST_EARLY_REPAYMENT_TRUELAYER_KEY = "postEarlyRepaymentTruelayer";
    function ne({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/early_repayment_truelayer/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostEarlyRepaymentTruelayer = ne, e.DELETE_ECOMMERCE_ORDER_KEY = "deleteEcommerceOrder";
    function J({ orderId: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/ecommerce/order/${a}/`, {
        method: "delete",
        body: u
      });
    }
    e.fetchDeleteEcommerceOrder = J, e.GET_ECOMMERCE_ORDER_KEY = "getEcommerceOrder";
    function oe({ orderId: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/ecommerce/order/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetEcommerceOrder = oe, e.POST_ECOMMERCE_SELLER_ORDER_KEY = "postEcommerceSellerOrder";
    function Qe({ sellerId: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/ecommerce/seller/${a}/order/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostEcommerceSellerOrder = Qe, e.GET_EMAIL_AVAILABILITY_KEY = "getEmailAvailability";
    function ft({ query: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/email_availability/", {
        method: "get",
        query: a
      });
    }
    e.fetchGetEmailAvailability = ft, e.GET_EXAMPLE_REPAYMENT_SCHEDULE_KEY = "getExampleRepaymentSchedule";
    function dt({ query: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/example_repayment_schedule/", {
        method: "get",
        query: a
      });
    }
    e.fetchGetExampleRepaymentSchedule = dt, e.GET_FORMAL_INDICATIVE_OFFERS_KEY = "getFormalIndicativeOffers";
    function ve({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_indicative_offers/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetFormalIndicativeOffers = ve, e.POST_FORMAL_INDICATIVE_OFFERS_KEY = "postFormalIndicativeOffers";
    function Ze({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_indicative_offers/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostFormalIndicativeOffers = Ze, e.GET_FORMAL_OFFERS_KEY = "getFormalOffers";
    function we({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetFormalOffers = we, e.POST_FORMAL_OFFERS_KEY = "postFormalOffers";
    function Pe({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostFormalOffers = Pe, e.GET_FORMAL_OFFERS_BUSINESS_LOAN_COMMISSION_CONSENT_KEY = "getFormalOffersBusinessLoanCommissionConsent";
    function fe({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/business_loan/${u}/commission_consent/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFormalOffersBusinessLoanCommissionConsent = fe, e.POST_FORMAL_OFFERS_BUSINESS_LOAN_COMMISSION_CONSENT_KEY = "postFormalOffersBusinessLoanCommissionConsent";
    function xe({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/business_loan/${u}/commission_consent/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFormalOffersBusinessLoanCommissionConsent = xe, e.GET_FORMAL_OFFERS_BUSINESS_LOAN_CONFIGURATION_KEY = "getFormalOffersBusinessLoanConfiguration";
    function be({ stateKey: a, offerId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/business_loan/${u}/configuration/`, {
        method: "get"
      });
    }
    e.fetchGetFormalOffersBusinessLoanConfiguration = be, e.PUT_FORMAL_OFFERS_BUSINESS_LOAN_CONFIGURATION_KEY = "putFormalOffersBusinessLoanConfiguration";
    function de({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/business_loan/${u}/configuration/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutFormalOffersBusinessLoanConfiguration = de, e.GET_FORMAL_OFFERS_CBILS_COMMISSION_CONSENT_KEY = "getFormalOffersCbilsCommissionConsent";
    function et({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/cbils/${u}/commission_consent/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFormalOffersCbilsCommissionConsent = et, e.POST_FORMAL_OFFERS_CBILS_COMMISSION_CONSENT_KEY = "postFormalOffersCbilsCommissionConsent";
    function Ge({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/cbils/${u}/commission_consent/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFormalOffersCbilsCommissionConsent = Ge, e.GET_FORMAL_OFFERS_CBILS_CONFIGURATION_KEY = "getFormalOffersCbilsConfiguration";
    function tt({ stateKey: a, offerId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/cbils/${u}/configuration/`, {
        method: "get"
      });
    }
    e.fetchGetFormalOffersCbilsConfiguration = tt, e.PUT_FORMAL_OFFERS_CBILS_CONFIGURATION_KEY = "putFormalOffersCbilsConfiguration";
    function nt({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/cbils/${u}/configuration/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutFormalOffersCbilsConfiguration = nt, e.GET_FORMAL_OFFERS_CREDIT_FACILITY_COMMISSION_CONSENT_KEY = "getFormalOffersCreditFacilityCommissionConsent";
    function rt({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/credit_facility/${u}/commission_consent/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFormalOffersCreditFacilityCommissionConsent = rt, e.POST_FORMAL_OFFERS_CREDIT_FACILITY_COMMISSION_CONSENT_KEY = "postFormalOffersCreditFacilityCommissionConsent";
    function Ye({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/credit_facility/${u}/commission_consent/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFormalOffersCreditFacilityCommissionConsent = Ye, e.GET_FORMAL_OFFERS_CREDIT_FACILITY_CONFIGURATION_KEY = "getFormalOffersCreditFacilityConfiguration";
    function v({ stateKey: a, offerId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/credit_facility/${u}/configuration/`, {
        method: "get"
      });
    }
    e.fetchGetFormalOffersCreditFacilityConfiguration = v, e.PUT_FORMAL_OFFERS_CREDIT_FACILITY_CONFIGURATION_KEY = "putFormalOffersCreditFacilityConfiguration";
    function Ie({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/credit_facility/${u}/configuration/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutFormalOffersCreditFacilityConfiguration = Ie, e.GET_FORMAL_OFFERS_FLEXI_24_COMMISSION_CONSENT_KEY = "getFormalOffersFlexi24CommissionConsent";
    function ye({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/flexi24/${u}/commission_consent/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFormalOffersFlexi24CommissionConsent = ye, e.POST_FORMAL_OFFERS_FLEXI_24_COMMISSION_CONSENT_KEY = "postFormalOffersFlexi24CommissionConsent";
    function it({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/flexi24/${u}/commission_consent/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFormalOffersFlexi24CommissionConsent = it, e.GET_FORMAL_OFFERS_FLEXI_24_CONFIGURATION_KEY = "getFormalOffersFlexi24Configuration";
    function nn({ stateKey: a, offerId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/flexi24/${u}/configuration/`, {
        method: "get"
      });
    }
    e.fetchGetFormalOffersFlexi24Configuration = nn, e.PUT_FORMAL_OFFERS_FLEXI_24_CONFIGURATION_KEY = "putFormalOffersFlexi24Configuration";
    function rn({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/flexi24/${u}/configuration/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutFormalOffersFlexi24Configuration = rn, e.GET_FORMAL_OFFERS_IWOCAPAY_COMMISSION_CONSENT_KEY = "getFormalOffersIwocapayCommissionConsent";
    function an({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/iwocapay/${u}/commission_consent/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFormalOffersIwocapayCommissionConsent = an, e.POST_FORMAL_OFFERS_IWOCAPAY_COMMISSION_CONSENT_KEY = "postFormalOffersIwocapayCommissionConsent";
    function ht({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/iwocapay/${u}/commission_consent/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFormalOffersIwocapayCommissionConsent = ht, e.GET_FORMAL_OFFERS_IWOCAPAY_CONFIGURATION_KEY = "getFormalOffersIwocapayConfiguration";
    function on({ stateKey: a, offerId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/iwocapay/${u}/configuration/`, {
        method: "get"
      });
    }
    e.fetchGetFormalOffersIwocapayConfiguration = on, e.PUT_FORMAL_OFFERS_IWOCAPAY_CONFIGURATION_KEY = "putFormalOffersIwocapayConfiguration";
    function cn({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/iwocapay/${u}/configuration/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutFormalOffersIwocapayConfiguration = cn, e.GET_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_COMMISSION_CONSENT_KEY = "getFormalOffersMerchantCashAdvanceCommissionConsent";
    function A({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/merchant_cash_advance/${u}/commission_consent/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFormalOffersMerchantCashAdvanceCommissionConsent = A, e.POST_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_COMMISSION_CONSENT_KEY = "postFormalOffersMerchantCashAdvanceCommissionConsent";
    function N({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/merchant_cash_advance/${u}/commission_consent/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFormalOffersMerchantCashAdvanceCommissionConsent = N, e.GET_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_CONFIGURATION_KEY = "getFormalOffersMerchantCashAdvanceConfiguration";
    function F({ stateKey: a, offerId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/merchant_cash_advance/${u}/configuration/`, {
        method: "get"
      });
    }
    e.fetchGetFormalOffersMerchantCashAdvanceConfiguration = F, e.PUT_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_CONFIGURATION_KEY = "putFormalOffersMerchantCashAdvanceConfiguration";
    function w({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/merchant_cash_advance/${u}/configuration/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutFormalOffersMerchantCashAdvanceConfiguration = w, e.GET_FORMAL_OFFERS_RECOVERY_LOAN_COMMISSION_CONSENT_KEY = "getFormalOffersRecoveryLoanCommissionConsent";
    function G({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/recovery_loan/${u}/commission_consent/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFormalOffersRecoveryLoanCommissionConsent = G, e.POST_FORMAL_OFFERS_RECOVERY_LOAN_COMMISSION_CONSENT_KEY = "postFormalOffersRecoveryLoanCommissionConsent";
    function D({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/recovery_loan/${u}/commission_consent/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFormalOffersRecoveryLoanCommissionConsent = D, e.GET_FORMAL_OFFERS_RECOVERY_LOAN_CONFIGURATION_KEY = "getFormalOffersRecoveryLoanConfiguration";
    function V({ stateKey: a, offerId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${a}/recovery_loan/${u}/configuration/`, {
        method: "get"
      });
    }
    e.fetchGetFormalOffersRecoveryLoanConfiguration = V, e.PUT_FORMAL_OFFERS_RECOVERY_LOAN_CONFIGURATION_KEY = "putFormalOffersRecoveryLoanConfiguration";
    function ce({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/formal_offers/${a}/recovery_loan/${u}/configuration/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutFormalOffersRecoveryLoanConfiguration = ce, e.POST_FUND_SELLER_REQUEST_KEY = "postFundSellerRequest";
    function _t({ stateKey: a, offerId: u, payLinkId: g, body: le }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/fund_seller_request/${a}/${u}/${g}/`, {
        method: "post",
        body: le
      });
    }
    e.fetchPostFundSellerRequest = _t, e.POST_FUNDING_REQUEST_BUSINESS_LOAN_KEY = "postFundingRequestBusinessLoan";
    function Et({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/funding_request/${a}/business_loan/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFundingRequestBusinessLoan = Et, e.POST_FUNDING_REQUEST_CBILS_KEY = "postFundingRequestCbils";
    function un({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/funding_request/${a}/cbils/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFundingRequestCbils = un, e.POST_FUNDING_REQUEST_CREDIT_FACILITY_KEY = "postFundingRequestCreditFacility";
    function sn({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/funding_request/${a}/credit_facility/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFundingRequestCreditFacility = sn, e.POST_FUNDING_REQUEST_FLEXI_24_KEY = "postFundingRequestFlexi24";
    function Lt({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/funding_request/${a}/flexi24/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFundingRequestFlexi24 = Lt, e.POST_FUNDING_REQUEST_IWOCAPAY_KEY = "postFundingRequestIwocapay";
    function ln({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/funding_request/${a}/iwocapay/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFundingRequestIwocapay = ln, e.POST_FUNDING_REQUEST_MERCHANT_CASH_ADVANCE_KEY = "postFundingRequestMerchantCashAdvance";
    function Zi({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/funding_request/${a}/merchant_cash_advance/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFundingRequestMerchantCashAdvance = Zi, e.POST_FUNDING_REQUEST_RECOVERY_LOAN_KEY = "postFundingRequestRecoveryLoan";
    function xi({ stateKey: a, offerId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/funding_request/${a}/recovery_loan/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostFundingRequestRecoveryLoan = xi, e.GET_FUNDING_REQUIREMENTS_BUSINESS_LOAN_KEY = "getFundingRequirementsBusinessLoan";
    function ea({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${a}/business_loan/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFundingRequirementsBusinessLoan = ea, e.GET_FUNDING_REQUIREMENTS_CBILS_KEY = "getFundingRequirementsCbils";
    function ta({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${a}/cbils/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFundingRequirementsCbils = ta, e.GET_FUNDING_REQUIREMENTS_CREDIT_FACILITY_KEY = "getFundingRequirementsCreditFacility";
    function na({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${a}/credit_facility/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFundingRequirementsCreditFacility = na, e.GET_FUNDING_REQUIREMENTS_FLEXI_24_KEY = "getFundingRequirementsFlexi24";
    function ra({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${a}/flexi24/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFundingRequirementsFlexi24 = ra, e.GET_FUNDING_REQUIREMENTS_IWOCAPAY_KEY = "getFundingRequirementsIwocapay";
    function ia({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${a}/iwocapay/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFundingRequirementsIwocapay = ia, e.GET_FUNDING_REQUIREMENTS_MERCHANT_CASH_ADVANCE_KEY = "getFundingRequirementsMerchantCashAdvance";
    function aa({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${a}/merchant_cash_advance/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFundingRequirementsMerchantCashAdvance = aa, e.GET_FUNDING_REQUIREMENTS_RECOVERY_LOAN_KEY = "getFundingRequirementsRecoveryLoan";
    function oa({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${a}/recovery_loan/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetFundingRequirementsRecoveryLoan = oa, e.POST_INTRODUCER_KEY = "postIntroducer";
    function ca({ body: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/introducer/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostIntroducer = ca, e.GET_INTRODUCER_REPAYMENT_SIMULATOR_KEY = "getIntroducerRepaymentSimulator";
    function ua({ query: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/introducer/repayment_simulator/", {
        method: "get",
        query: a
      });
    }
    e.fetchGetIntroducerRepaymentSimulator = ua, e.GET_INTRODUCER_KEY = "getIntroducer";
    function sa({ introducerId: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIntroducer = sa, e.GET_INTRODUCER_APPLICATION_KEY = "getIntroducerApplication";
    function la({ introducerId: a, applicationId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${a}/application/${u}/`, {
        method: "get"
      });
    }
    e.fetchGetIntroducerApplication = la, e.GET_INTRODUCER_APPLICATION_OFFER_ALLOWED_WITHDRAWAL_FEE_RATES_KEY = "getIntroducerApplicationOfferAllowedWithdrawalFeeRates";
    function fa({ introducerId: a, applicationId: u, offerId: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${a}/application/${u}/offer/${g}/allowed_withdrawal_fee_rates/`, {
        method: "get"
      });
    }
    e.fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates = fa, e.PUT_INTRODUCER_APPLICATION_OFFER_ENTITY_TO_CONTACT_KEY = "putIntroducerApplicationOfferEntityToContact";
    function da({ introducerId: a, applicationId: u, offerId: g, body: le }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/introducer/${a}/application/${u}/offer/${g}/entity_to_contact/`, {
        method: "put",
        body: le
      });
    }
    e.fetchPutIntroducerApplicationOfferEntityToContact = da, e.GET_INTRODUCER_APPLICATION_OFFER_FUNDING_REQUIREMENTS_KEY = "getIntroducerApplicationOfferFundingRequirements";
    function ha({ introducerId: a, applicationId: u, offerId: g, query: le }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${a}/application/${u}/offer/${g}/funding_requirements/`, {
        method: "get",
        query: le
      });
    }
    e.fetchGetIntroducerApplicationOfferFundingRequirements = ha, e.GET_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = "getIntroducerApplicationOfferWithdrawalFeeRate";
    function _a({ introducerId: a, applicationId: u, offerId: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${a}/application/${u}/offer/${g}/withdrawal_fee_rate/`, {
        method: "get"
      });
    }
    e.fetchGetIntroducerApplicationOfferWithdrawalFeeRate = _a, e.PUT_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = "putIntroducerApplicationOfferWithdrawalFeeRate";
    function Ea({ introducerId: a, applicationId: u, offerId: g, body: le }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/introducer/${a}/application/${u}/offer/${g}/withdrawal_fee_rate/`, {
        method: "put",
        body: le
      });
    }
    e.fetchPutIntroducerApplicationOfferWithdrawalFeeRate = Ea, e.GET_INTRODUCER_APPLICATION_REJECT_OFFER_REASONS_KEY = "getIntroducerApplicationRejectOfferReasons";
    function ma({ introducerId: a, applicationId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${a}/application/${u}/reject_offer_reasons/`, {
        method: "get"
      });
    }
    e.fetchGetIntroducerApplicationRejectOfferReasons = ma, e.GET_INTRODUCER_APPLICATIONS_KEY = "getIntroducerApplications";
    function ga({ introducerId: a, query: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${a}/applications/`, {
        method: "get",
        query: u
      });
    }
    e.fetchGetIntroducerApplications = ga, e.GET_INTRODUCER_CONTEXT_BY_INTRODUCER_ID_KEY = "getIntroducerContextByIntroducerId";
    function Oa({ introducerId: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${a}/context/`, {
        method: "get"
      });
    }
    e.fetchGetIntroducerContextByIntroducerId = Oa, e.GET_INTRODUCER_CONTEXT_KEY = "getIntroducerContext";
    function Sa({}) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/introducer/context/", {
        method: "get"
      });
    }
    e.fetchGetIntroducerContext = Sa, e.POST_INTRODUCER_LINK_OPEN_BANKING_EMAIL_KEY = "postIntroducerLinkOpenBankingEmail";
    function Aa({ introducerId: a, stateKey: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/introducer/${a}/link_open_banking_email/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostIntroducerLinkOpenBankingEmail = Aa, e.GET_IWOCAPAY_BUYER_PAY_LINK_PACKAGE_KEY = "getIwocapayBuyerPayLinkPackage";
    function pa({ payLinkPackageId: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/pay_link_package/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayBuyerPayLinkPackage = pa, e.GET_IWOCAPAY_BUYER_PAY_LINKS_KEY = "getIwocapayBuyerPayLinks";
    function Ta({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/${a}/pay_links/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayBuyerPayLinks = Ta, e.POST_IWOCAPAY_BUYER_REFRESH_SPENDING_LIMIT_KEY = "postIwocapayBuyerRefreshSpendingLimit";
    function Pa({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/${a}/refresh_spending_limit/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostIwocapayBuyerRefreshSpendingLimit = Pa, e.GET_IWOCAPAY_BUYER_SPENDING_LIMIT_REQUEST_KEY = "getIwocapayBuyerSpendingLimitRequest";
    function Ia({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/${a}/spending_limit_request/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayBuyerSpendingLimitRequest = Ia, e.POST_IWOCAPAY_BUYER_SPENDING_LIMIT_REQUEST_KEY = "postIwocapayBuyerSpendingLimitRequest";
    function ya({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/${a}/spending_limit_request/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostIwocapayBuyerSpendingLimitRequest = ya, e.POST_IWOCAPAY_NOTIFICATIONS_KEY = "postIwocapayNotifications";
    function Ra({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/iwocapay/notifications/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostIwocapayNotifications = Ra, e.GET_IWOCAPAY_PAY_LINK_PACKAGE_KEY = "getIwocapayPayLinkPackage";
    function Ca({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/pay_link_package/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayPayLinkPackage = Ca, e.POST_IWOCAPAY_PAY_LINK_PACKAGE_KEY = "postIwocapayPayLinkPackage";
    function Na({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/pay_link_package/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostIwocapayPayLinkPackage = Na, e.GET_IWOCAPAY_PAYMENT_CAPTURED_KEY = "getIwocapayPaymentCaptured";
    function La({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/payment/captured/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayPaymentCaptured = La, e.GET_IWOCAPAY_PAYMENT_LATER_KEY = "getIwocapayPaymentLater";
    function Fa({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/payment/later/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayPaymentLater = Fa, e.POST_IWOCAPAY_PAYMENT_LATER_KEY = "postIwocapayPaymentLater";
    function va({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/iwocapay/payment/later/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostIwocapayPaymentLater = va, e.GET_IWOCAPAY_REFERRAL_KEY = "getIwocapayReferral";
    function wa({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/referral/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayReferral = wa, e.GET_IWOCAPAY_REFERRALS_KEY = "getIwocapayReferrals";
    function ba({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/referrals/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayReferrals = ba, e.GET_IWOCAPAY_REFERRER_KEY = "getIwocapayReferrer";
    function Ga({ referralCode: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/referrer/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayReferrer = Ga, e.DELETE_IWOCAPAY_SELLER_ACCESS_USER_KEY = "deleteIwocapaySellerAccessUser";
    function Ya({ stateKey: a, accessUserUuid: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${a}/access_user/${u}/`, {
        method: "delete",
        body: g
      });
    }
    e.fetchDeleteIwocapaySellerAccessUser = Ya, e.PUT_IWOCAPAY_SELLER_ACCESS_USER_KEY = "putIwocapaySellerAccessUser";
    function Da({ stateKey: a, accessUserUuid: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${a}/access_user/${u}/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutIwocapaySellerAccessUser = Da, e.GET_IWOCAPAY_SELLER_ACCESS_USERS_KEY = "getIwocapaySellerAccessUsers";
    function $a({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${a}/access_users/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapaySellerAccessUsers = $a, e.POST_IWOCAPAY_SELLER_ACCESS_USERS_KEY = "postIwocapaySellerAccessUsers";
    function Ma({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${a}/access_users/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostIwocapaySellerAccessUsers = Ma, e.GET_IWOCAPAY_SELLER_BRANDING_KEY = "getIwocapaySellerBranding";
    function Ka({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${a}/branding/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapaySellerBranding = Ka, e.GET_IWOCAPAY_SELLER_CONNECTION_KEY = "getIwocapaySellerConnection";
    function Ua({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${a}/connection/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapaySellerConnection = Ua, e.GET_IWOCAPAY_SELLER_ECOMMERCE_CREDENTIALS_KEY = "getIwocapaySellerEcommerceCredentials";
    function ka({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${a}/ecommerce_credentials/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapaySellerEcommerceCredentials = ka, e.POST_IWOCAPAY_SELLER_ECOMMERCE_CREDENTIALS_KEY = "postIwocapaySellerEcommerceCredentials";
    function Ba({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${a}/ecommerce_credentials/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostIwocapaySellerEcommerceCredentials = Ba, e.PUT_IWOCAPAY_SELLER_PAYMENT_CAPTURED_CANCEL_KEY = "putIwocapaySellerPaymentCapturedCancel";
    function ja({ stateKey: a, payLinkId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${a}/payment/captured/${u}/cancel/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutIwocapaySellerPaymentCapturedCancel = ja, e.PUT_IWOCAPAY_SELLER_PAYMENT_CAPTURED_FUND_KEY = "putIwocapaySellerPaymentCapturedFund";
    function Wa({ stateKey: a, payLinkId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${a}/payment/captured/${u}/fund/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutIwocapaySellerPaymentCapturedFund = Wa, e.POST_IWOCAPAY_SELLER_RESEND_INVITE_KEY = "postIwocapaySellerResendInvite";
    function Va({ stateKey: a, accessUserUuid: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${a}/resend_invite/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostIwocapaySellerResendInvite = Va, e.GET_IWOCAPAY_SELLER_SPENDING_LIMIT_REQUEST_KEY = "getIwocapaySellerSpendingLimitRequest";
    function qa({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${a}/spending_limit_request/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapaySellerSpendingLimitRequest = qa, e.GET_IWOCAPAY_SELLER_ONBOARDING_ANSWERS_KEY = "getIwocapaySellerOnboardingAnswers";
    function Ha({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller_onboarding_answers/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapaySellerOnboardingAnswers = Ha, e.POST_IWOCAPAY_SELLER_ONBOARDING_ANSWERS_KEY = "postIwocapaySellerOnboardingAnswers";
    function Ja({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller_onboarding_answers/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostIwocapaySellerOnboardingAnswers = Ja, e.POST_IWOCAPAY_SHOPIFY_GDPR_REDACT_CUSTOMER_KEY = "postIwocapayShopifyGdprRedactCustomer";
    function Xa({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/iwocapay/shopify/gdpr/redact/customer/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostIwocapayShopifyGdprRedactCustomer = Xa, e.POST_IWOCAPAY_SHOPIFY_GDPR_REDACT_SHOP_KEY = "postIwocapayShopifyGdprRedactShop";
    function za({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/iwocapay/shopify/gdpr/redact/shop/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostIwocapayShopifyGdprRedactShop = za, e.POST_IWOCAPAY_SHOPIFY_GDPR_RETRIEVE_CUSTOMER_KEY = "postIwocapayShopifyGdprRetrieveCustomer";
    function Qa({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/iwocapay/shopify/gdpr/retrieve/customer/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostIwocapayShopifyGdprRetrieveCustomer = Qa, e.GET_IWOCAPAY_SHOPIFY_INSTALL_KEY = "getIwocapayShopifyInstall";
    function Za({ query: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/iwocapay/shopify/install/", {
        method: "get",
        query: a
      });
    }
    e.fetchGetIwocapayShopifyInstall = Za, e.POST_IWOCAPAY_SHOPIFY_PAYMENT_KEY = "postIwocapayShopifyPayment";
    function xa({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/iwocapay/shopify/payment/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostIwocapayShopifyPayment = xa, e.POST_IWOCAPAY_SHOPIFY_PAYMENT_REFUND_KEY = "postIwocapayShopifyPaymentRefund";
    function eo({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/iwocapay/shopify/payment/refund/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostIwocapayShopifyPaymentRefund = eo, e.GET_IWOCAPAY_SHOPIFY_POST_GRANT_KEY = "getIwocapayShopifyPostGrant";
    function to({ query: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/iwocapay/shopify/post_grant/", {
        method: "get",
        query: a
      });
    }
    e.fetchGetIwocapayShopifyPostGrant = to, e.GET_IWOCAPAY_SHOPIFY_SELLER_SHOP_KEY = "getIwocapayShopifySellerShop";
    function no({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/shopify/seller/${a}/shop/`, {
        method: "get"
      });
    }
    e.fetchGetIwocapayShopifySellerShop = no, e.GET_LOAN_DOCUMENTS_KEY = "getLoanDocuments";
    function ro({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetLoanDocuments = ro, e.GET_LOAN_DOCUMENTS_REQUIRED_BUSINESS_LOAN_KEY = "getLoanDocumentsRequiredBusinessLoan";
    function io({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/required/business_loan/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsRequiredBusinessLoan = io, e.GET_LOAN_DOCUMENTS_REQUIRED_CBILS_KEY = "getLoanDocumentsRequiredCbils";
    function ao({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/required/cbils/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsRequiredCbils = ao, e.GET_LOAN_DOCUMENTS_REQUIRED_CREDIT_FACILITY_KEY = "getLoanDocumentsRequiredCreditFacility";
    function oo({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/required/credit_facility/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsRequiredCreditFacility = oo, e.GET_LOAN_DOCUMENTS_REQUIRED_FLEXI_24_KEY = "getLoanDocumentsRequiredFlexi24";
    function co({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/required/flexi24/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsRequiredFlexi24 = co, e.GET_LOAN_DOCUMENTS_REQUIRED_IWOCAPAY_KEY = "getLoanDocumentsRequiredIwocapay";
    function uo({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/required/iwocapay/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsRequiredIwocapay = uo, e.GET_LOAN_DOCUMENTS_REQUIRED_MERCHANT_CASH_ADVANCE_KEY = "getLoanDocumentsRequiredMerchantCashAdvance";
    function so({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/required/merchant_cash_advance/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsRequiredMerchantCashAdvance = so, e.GET_LOAN_DOCUMENTS_REQUIRED_RECOVERY_LOAN_KEY = "getLoanDocumentsRequiredRecoveryLoan";
    function lo({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/required/recovery_loan/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsRequiredRecoveryLoan = lo, e.POST_LOAN_DOCUMENTS_SIGNED_KEY = "postLoanDocumentsSigned";
    function fo({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${a}/signed/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostLoanDocumentsSigned = fo, e.GET_LOAN_DOCUMENTS_SIGNED_KEY = "getLoanDocumentsSigned";
    function ho({ stateKey: a, documentId: u, query: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/loan_documents/${a}/signed/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsSigned = ho, e.GET_LOAN_DOCUMENTS_UNSIGNED_KEY = "getLoanDocumentsUnsigned";
    function _o({ stateKey: a, documentId: u, query: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/loan_documents/${a}/unsigned/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetLoanDocumentsUnsigned = _o, e.GET_LOGIN_LINK_KEY = "getLoginLink";
    function Eo({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/login_link/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetLoginLink = Eo, e.POST_LOGOUT_KEY = "postLogout";
    function mo({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/logout/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostLogout = mo, e.GET_MCA_ESTIMATED_SCHEDULE_KEY = "getMcaEstimatedSchedule";
    function go({ stateKey: a, offerId: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/mca_estimated_schedule/${a}/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetMcaEstimatedSchedule = go, e.POST_OFFERS_SELECT_KEY = "postOffersSelect";
    function Oo({ offerId: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/offers/${a}/select/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostOffersSelect = Oo, e.GET_ONFIDO_CHECK_KEY = "getOnfidoCheck";
    function So({ stateKey: a, personUid: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/onfido/check/${a}/${u}/`, {
        method: "get"
      });
    }
    e.fetchGetOnfidoCheck = So, e.POST_ONFIDO_CHECK_KEY = "postOnfidoCheck";
    function Ao({ stateKey: a, personUid: u, body: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/onfido/check/${a}/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostOnfidoCheck = Ao, e.POST_ONFIDO_CHECKS_KEY = "postOnfidoChecks";
    function po({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/onfido/checks/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostOnfidoChecks = po, e.POST_ONFIDO_START_KEY = "postOnfidoStart";
    function To({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/onfido/start/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostOnfidoStart = To, e.POST_ONFIDO_TOKEN_KEY = "postOnfidoToken";
    function Po({ body: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/onfido/token/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostOnfidoToken = Po, e.GET_ONLINE_ACCOUNT_KEY = "getOnlineAccount";
    function Io({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/online_account/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetOnlineAccount = Io, e.DELETE_ONLINE_ACCOUNT_KEY = "deleteOnlineAccount";
    function yo({ stateKey: a, onlineAccountId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/online_account/${a}/${u}/`, {
        method: "delete",
        body: g
      });
    }
    e.fetchDeleteOnlineAccount = yo, e.POST_PAGE_VIEW_KEY = "postPageView";
    function Ro({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/page_view/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostPageView = Ro, e.GET_PARTNER_BROKERS_KEY = "getPartnerBrokers";
    function Co({}) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/partner_brokers/", {
        method: "get"
      });
    }
    e.fetchGetPartnerBrokers = Co, e.POST_PARTNER_DEVELOPER_KEY = "postPartnerDeveloper";
    function No({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/partner_developer/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostPartnerDeveloper = No, e.POST_PASSWORD_LOGIN_KEY = "postPasswordLogin";
    function Lo({ body: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/password/login/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostPasswordLogin = Lo, e.POST_PASSWORD_RESET_KEY = "postPasswordReset";
    function Fo({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/password/reset/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostPasswordReset = Fo, e.POST_PASSWORD_RESET_SET_PASSWORD_KEY = "postPasswordResetSetPassword";
    function vo({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/password/reset/set-password/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostPasswordResetSetPassword = vo, e.POST_PASSWORD_RESET_VERIFY_KEY = "postPasswordResetVerify";
    function wo({ body: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/password/reset/verify/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostPasswordResetVerify = wo, e.POST_PASSWORDLESS_EMAIL_KEY = "postPasswordlessEmail";
    function bo({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/passwordless/email/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostPasswordlessEmail = bo, e.POST_PASSWORDLESS_EMAIL_LOGIN_KEY = "postPasswordlessEmailLogin";
    function Go({ body: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/passwordless/email/login/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostPasswordlessEmailLogin = Go, e.GET_PAY_LINK_GO_KEY = "getPayLinkGo";
    function Yo({ query: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/pay_link/go/", {
        method: "get",
        query: a
      });
    }
    e.fetchGetPayLinkGo = Yo, e.GET_PAY_LINK_KEY = "getPayLink";
    function Do({ payLinkId: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/pay_link/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetPayLink = Do, e.POST_PAY_LINK_APPLICATION_KEY = "postPayLinkApplication";
    function $o({ payLinkId: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/pay_link/${a}/application/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostPayLinkApplication = $o, e.GET_PAYMENT_METHOD_KEY = "getPaymentMethod";
    function Mo({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/payment_method/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetPaymentMethod = Mo, e.POST_PAYMENT_METHOD_KEY = "postPaymentMethod";
    function Ko({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/payment_method/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostPaymentMethod = Ko, e.DELETE_PAYMENT_METHOD_KEY = "deletePaymentMethod";
    function Uo({ stateKey: a, paymentMethodId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/payment_method/${a}/${u}/`, {
        method: "delete",
        body: g
      });
    }
    e.fetchDeletePaymentMethod = Uo, e.PUT_PAYMENT_METHOD_KEY = "putPaymentMethod";
    function ko({ stateKey: a, paymentMethodId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/payment_method/${a}/${u}/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutPaymentMethod = ko, e.GET_POSTCODE_LOOKUP_KEY = "getPostcodeLookup";
    function Bo({ query: a }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/postcode_lookup/", {
        method: "get",
        query: a
      });
    }
    e.fetchGetPostcodeLookup = Bo, e.GET_PRODUCT_OFFERS_BY_RESTRICTED_EXTERNAL_DATA_SYNCS_AUTHORISATION_KEY = "getProductOffersByRestrictedExternalDataSyncsAuthorisation";
    function jo({ stateKey: a, restrictedExternalDataSyncsAuthorisation: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/product_offers/${a}/${u}/`, {
        method: "get"
      });
    }
    e.fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation = jo, e.GET_PRODUCT_OFFERS_KEY = "getProductOffers";
    function Wo({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/product_offers/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetProductOffers = Wo, e.GET_PROFILE_KEY = "getProfile";
    function Vo({}) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/profile/", {
        method: "get"
      });
    }
    e.fetchGetProfile = Vo, e.GET_QUICKBOOKS_AUTHORIZATION_CALLBACK_KEY = "getQuickbooksAuthorizationCallback";
    function qo({}) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/quickbooks/authorization_callback/", {
        method: "get"
      });
    }
    e.fetchGetQuickbooksAuthorizationCallback = qo, e.GET_QUICKBOOKS_AUTHORIZATION_REDIRECT_KEY = "getQuickbooksAuthorizationRedirect";
    function Ho({ stateKey: a }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/quickbooks/authorization_redirect/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetQuickbooksAuthorizationRedirect = Ho, e.POST_QUICKBOOKS_DISCONNECT_KEY = "postQuickbooksDisconnect";
    function Jo({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/quickbooks/disconnect/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostQuickbooksDisconnect = Jo, e.POST_QUICKBOOKS_WEBHOOK_KEY = "postQuickbooksWebhook";
    function Xo({ body: a }) {
      return (0, t.fetchLendingAPI)("/api/lending/edge/quickbooks/webhook/", {
        method: "post",
        body: a
      });
    }
    e.fetchPostQuickbooksWebhook = Xo, e.POST_REPAYMENT_PAYMENT_INTENT_KEY = "postRepaymentPaymentIntent";
    function zo({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/repayment/${a}/payment_intent/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostRepaymentPaymentIntent = zo, e.GET_REPAYMENT_PAYMENT_METHOD_KEY = "getRepaymentPaymentMethod";
    function Qo({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/repayment/${a}/payment_method/`, {
        method: "get"
      });
    }
    e.fetchGetRepaymentPaymentMethod = Qo, e.POST_REPAYMENT_PAYMENT_METHOD_KEY = "postRepaymentPaymentMethod";
    function Zo({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/repayment/${a}/payment_method/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostRepaymentPaymentMethod = Zo, e.POST_REPAYMENT_REGISTER_REPAYMENT_METHOD_KEY = "postRepaymentRegisterRepaymentMethod";
    function xo({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/repayment/${a}/register_repayment_method/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostRepaymentRegisterRepaymentMethod = xo, e.GET_SELECT_PAYMENT_PROCESSOR_KEY = "getSelectPaymentProcessor";
    function ec({}) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/select_payment_processor/", {
        method: "get"
      });
    }
    e.fetchGetSelectPaymentProcessor = ec, e.GET_SELLER_HANDLE_KEY = "getSellerHandle";
    function tc({ sellerHandle: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/handle/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetSellerHandle = tc, e.GET_SELLER_HANDLE_AVAILABILITY_KEY = "getSellerHandleAvailability";
    function nc({ sellerHandle: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/handle/${a}/availability/`, {
        method: "get"
      });
    }
    e.fetchGetSellerHandleAvailability = nc, e.GET_SELLER_KEY = "getSeller";
    function rc({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetSeller = rc, e.POST_SELLER_KEY = "postSeller";
    function ic({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostSeller = ic, e.GET_SELLER_ENABLED_PRODUCTS_KEY = "getSellerEnabledProducts";
    function ac({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/${a}/enabled_products/`, {
        method: "get"
      });
    }
    e.fetchGetSellerEnabledProducts = ac, e.PUT_SELLER_ENABLED_PRODUCTS_KEY = "putSellerEnabledProducts";
    function oc({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/${a}/enabled_products/`, {
        method: "put",
        body: u
      });
    }
    e.fetchPutSellerEnabledProducts = oc, e.POST_SELLER_HANDLE_KEY = "postSellerHandle";
    function cc({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/${a}/handle/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostSellerHandle = cc, e.GET_SELLER_INTEGRATIONS_REGISTER_INTEREST_KEY = "getSellerIntegrationsRegisterInterest";
    function uc({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/${a}/integrations/register_interest/`, {
        method: "get"
      });
    }
    e.fetchGetSellerIntegrationsRegisterInterest = uc, e.POST_SELLER_INTEGRATIONS_REGISTER_INTEREST_KEY = "postSellerIntegrationsRegisterInterest";
    function sc({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller/${a}/integrations/register_interest/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostSellerIntegrationsRegisterInterest = sc, e.GET_SELLER_AGREEMENT_DOCUMENT_KEY = "getSellerAgreementDocument";
    function lc({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller_agreement_document/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetSellerAgreementDocument = lc, e.GET_SELLER_AGREEMENT_DOCUMENT_DOWNLOAD_KEY = "getSellerAgreementDocumentDownload";
    function fc({ stateKey: a, documentId: u, query: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/seller_agreement_document/${a}/download/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetSellerAgreementDocumentDownload = fc, e.PUT_SELLER_AGREEMENT_DOCUMENT_SIGN_KEY = "putSellerAgreementDocumentSign";
    function dc({ stateKey: a, documentId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/seller_agreement_document/${a}/sign/${u}/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutSellerAgreementDocumentSign = dc, e.GET_SELLER_ONBOARDING_REQUIREMENTS_KEY = "getSellerOnboardingRequirements";
    function hc({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/seller_onboarding_requirements/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetSellerOnboardingRequirements = hc, e.GET_SIGNUP_BRANDING_KEY = "getSignupBranding";
    function _c({ affiliateTag: a, query: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/signup_branding/${a}/`, {
        method: "get",
        query: u
      });
    }
    e.fetchGetSignupBranding = _c, e.GET_SINGLE_IMMEDIATE_PAYMENT_KEY = "getSingleImmediatePayment";
    function Ec({ paymentId: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/single_immediate_payment/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetSingleImmediatePayment = Ec, e.GET_SPLIT_TEST_KEY = "getSplitTest";
    function mc({ stateKey: a, experimentName: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/split_test/${a}/${u}/`, {
        method: "get"
      });
    }
    e.fetchGetSplitTest = mc, e.POST_STATE_KEY = "postState";
    function gc({ headers: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/state/", {
        method: "post",
        overrideHeaders: a,
        body: u
      });
    }
    e.fetchPostState = gc, e.GET_STATE_BY_STATE_KEY_KEY = "getStateByStateKey";
    function Oc({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/state/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetStateByStateKey = Oc, e.GET_STATE_KEY = "getState";
    function Sc({}) {
      return (0, t.fetchLendingAPIJSON)("/api/lending/edge/state/", {
        method: "get"
      });
    }
    e.fetchGetState = Sc, e.PUT_STATE_KEY = "putState";
    function Ac({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/state/${a}/`, {
        method: "put",
        body: u
      });
    }
    e.fetchPutState = Ac, e.GET_STATEMENTS_KEY = "getStatements";
    function pc({ stateKey: a, query: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/statements/${a}/`, {
        method: "get",
        query: u
      });
    }
    e.fetchGetStatements = pc, e.POST_THREATMETRIX_EVENT_KEY = "postThreatmetrixEvent";
    function Tc({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/threatmetrix/${a}/event/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostThreatmetrixEvent = Tc, e.PUT_THREATMETRIX_EVENT_KEY = "putThreatmetrixEvent";
    function Pc({ stateKey: a, tmSessionId: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/threatmetrix/${a}/event/${u}/`, {
        method: "put",
        body: g
      });
    }
    e.fetchPutThreatmetrixEvent = Pc, e.POST_TRUELAYER_AUTHORIZATION_URL_KEY = "postTruelayerAuthorizationUrl";
    function Ic({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/truelayer/authorization_url/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostTruelayerAuthorizationUrl = Ic, e.POST_TRUELAYER_BANK_AUTHENTICATION_URL_KEY = "postTruelayerBankAuthenticationUrl";
    function yc({ stateKey: a, providerId: u, body: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/truelayer/bank_authentication_url/${a}/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostTruelayerBankAuthenticationUrl = yc, e.GET_TRUELAYER_PAYMENT_KEY = "getTruelayerPayment";
    function Rc({ stateKey: a, paymentId: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/truelayer_payment/${a}/${u}/`, {
        method: "get"
      });
    }
    e.fetchGetTruelayerPayment = Rc, e.POST_TWO_FACTOR_AUTHENTICATE_KEY = "postTwoFactorAuthenticate";
    function Cc({ authenticationToken: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/two_factor/${a}/authenticate/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostTwoFactorAuthenticate = Cc, e.GET_TWO_FACTOR_SETUP_KEY = "getTwoFactorSetup";
    function Nc({ authenticationToken: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/two_factor/${a}/setup/`, {
        method: "get"
      });
    }
    e.fetchGetTwoFactorSetup = Nc, e.POST_TWO_FACTOR_SETUP_KEY = "postTwoFactorSetup";
    function Lc({ authenticationToken: a, body: u }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/two_factor/${a}/setup/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostTwoFactorSetup = Lc, e.GET_XERO_ACCOUNTS_KEY = "getXeroAccounts";
    function Fc({ reason: a, stateKey: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/xero/accounts/${a}/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetXeroAccounts = Fc, e.GET_XERO_CALLBACK_KEY = "getXeroCallback";
    function vc({ reason: a, query: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/callback/${a}/`, {
        method: "get",
        query: u
      });
    }
    e.fetchGetXeroCallback = vc, e.POST_XERO_CONNECT_KEY = "postXeroConnect";
    function wc({ reason: a, stateKey: u, body: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/connect/${a}/${u}/`, {
        method: "post",
        body: g
      });
    }
    e.fetchPostXeroConnect = wc, e.DELETE_XERO_CONNECTIONS_KEY = "deleteXeroConnections";
    function bc({ reason: a, stateKey: u, query: g, body: le }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/connections/${a}/${u}/`, {
        method: "delete",
        query: g,
        body: le
      });
    }
    e.fetchDeleteXeroConnections = bc, e.GET_XERO_CONNECTIONS_KEY = "getXeroConnections";
    function Gc({ reason: a, stateKey: u, query: g }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/xero/connections/${a}/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetXeroConnections = Gc, e.GET_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = "getXeroIwocapaySellerAccount";
    function Yc({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/xero/iwocapay_seller/account/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetXeroIwocapaySellerAccount = Yc, e.POST_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = "postXeroIwocapaySellerAccount";
    function Dc({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/iwocapay_seller/account/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostXeroIwocapaySellerAccount = Dc, e.PUT_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = "putXeroIwocapaySellerAccount";
    function $c({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/iwocapay_seller/account/${a}/`, {
        method: "put",
        body: u
      });
    }
    e.fetchPutXeroIwocapaySellerAccount = $c, e.GET_XERO_IWOCAPAY_SELLER_BRANDING_THEMES_KEY = "getXeroIwocapaySellerBrandingThemes";
    function Mc({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/xero/iwocapay_seller/branding_themes/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetXeroIwocapaySellerBrandingThemes = Mc, e.POST_XERO_IWOCAPAY_SELLER_BRANDING_THEMES_PAYMENT_SERVICES_KEY = "postXeroIwocapaySellerBrandingThemesPaymentServices";
    function Kc({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/iwocapay_seller/branding_themes/${a}/payment_services/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostXeroIwocapaySellerBrandingThemesPaymentServices = Kc, e.GET_XERO_LOGIN_KEY = "getXeroLogin";
    function Uc({ reason: a, stateKey: u, query: g }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/login/${a}/${u}/`, {
        method: "get",
        query: g
      });
    }
    e.fetchGetXeroLogin = Uc, e.POST_XERO_LOGIN_KEY = "postXeroLogin";
    function kc({ reason: a, stateKey: u, query: g, body: le }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/xero/login/${a}/${u}/`, {
        method: "post",
        query: g,
        body: le
      });
    }
    e.fetchPostXeroLogin = kc, e.GET_XERO_ORGANISATION_ACCOUNT_KEY = "getXeroOrganisationAccount";
    function Bc({ stateKey: a }) {
      return (0, t.fetchLendingAPIJSON)(`/api/lending/edge/xero/organisation/account/${a}/`, {
        method: "get"
      });
    }
    e.fetchGetXeroOrganisationAccount = Bc, e.POST_XERO_ORGANISATION_ACCOUNT_KEY = "postXeroOrganisationAccount";
    function jc({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/organisation/account/${a}/`, {
        method: "post",
        body: u
      });
    }
    e.fetchPostXeroOrganisationAccount = jc, e.PUT_XERO_ORGANISATION_ACCOUNT_KEY = "putXeroOrganisationAccount";
    function Wc({ stateKey: a, body: u }) {
      return (0, t.fetchLendingAPI)(`/api/lending/edge/xero/organisation/account/${a}/`, {
        method: "put",
        body: u
      });
    }
    e.fetchPutXeroOrganisationAccount = Wc;
  }(fn)), fn;
}
var Be = Zc();
function je(e) {
  const [t, n] = te(!1), [r, i] = te();
  return {
    post: async (c) => {
      i(void 0), n(!0);
      try {
        return await e({ body: c });
      } catch (l) {
        throw i(l), l;
      } finally {
        n(!1);
      }
    },
    isLoading: t,
    error: r
  };
}
function jt(e) {
  return !(!e || // email regex source: http://emailregex.com/
  // eslint-disable-next-line no-control-regex
  !/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i.test(
    e
  ));
}
function xc() {
  const e = Object.fromEntries(
    new URLSearchParams(window.location.search)
  ), { redirect_to: t, persist_params: n } = e;
  if (t)
    return n !== "1" ? t : eu(t);
}
const eu = (e) => {
  const {
    origin: t,
    pathname: n,
    searchParams: r
  } = new URL(
    e,
    window.location.origin
    // fallback if redirect_to doesn't contain origin
  ), i = tu(r), o = `${t}${n}`;
  return i ? `${o}${i}` : o;
}, tu = (e) => {
  const t = ru(), r = new URLSearchParams({
    ...Object.fromEntries(e),
    ...Object.fromEntries(t)
  }).toString();
  return r ? "?" + r : "";
}, nu = [
  "code",
  "hmac",
  "host",
  "shop",
  "state",
  "timestamp"
], ru = () => {
  const e = new URLSearchParams(window.location.search), t = new URLSearchParams();
  for (const n of nu) {
    const r = e.get(n);
    r && t.append(n, r);
  }
  return t;
}, iu = "_form_1u42i_1", au = "_link_1u42i_6", ou = "_forgottenPassword_1u42i_22", cu = "_hr_1u42i_26", uu = "_switchMethod_1u42i_32", su = "_passwordWrapper_1u42i_42", lu = "_viewPassword_1u42i_46", fu = "_errorGap_1u42i_52", du = "_trust_1u42i_56", z = {
  form: iu,
  link: au,
  forgottenPassword: ou,
  hr: cu,
  switchMethod: uu,
  passwordWrapper: su,
  viewPassword: lu,
  errorGap: fu,
  trust: du
}, Zr = ({
  error: e,
  copy: t
}) => {
  try {
    switch (JSON.parse(e.message).errors[0].code) {
      case "AuthenticationFailed":
        return /* @__PURE__ */ b(Dt, { variant: "failure", "data-testid": "error-message", children: (t == null ? void 0 : t.loginEmailOrPassWrong) || "The email or password you entered is incorrect" });
      case "MultipleIwocaPaySellers":
        return /* @__PURE__ */ b(Dt, { variant: "failure", "data-testid": "error-message", children: /* @__PURE__ */ Q("div", { children: [
          /* @__PURE__ */ b("p", { children: (t == null ? void 0 : t.iwocapayAccountProblem) || "Oops we've spotted a problem with your account." }),
          /* @__PURE__ */ b("p", { children: (t == null ? void 0 : t.iwocapayContact) || "A member of our iwocaPay team will be in touch to help fix this, or if you'd prefer you can call us on 0203 778 0549." })
        ] }) });
    }
  } catch {
  }
  return /* @__PURE__ */ b(Dt, { variant: "failure", "data-testid": "error-message", children: (t == null ? void 0 : t.loginError) || "Sorry, something’s gone wrong. Try again later?" });
}, hu = ({
  isTwoFactorRequired: e,
  switchLoginMethod: t,
  onSuccessfulLinkSent: n,
  redirectURL: r,
  copy: i,
  styles: o
}) => {
  const [c, l] = te(""), [s, f] = te(!1), { post: h } = je(Be.fetchPostIwocapayNotifications), { post: O, isLoading: d, error: m } = je(Be.fetchPostPasswordlessEmail), [_, T] = te(!1), I = async (P) => {
    P.preventDefault();
    const p = jt(c);
    if (p || f(!0), p)
      try {
        await O({
          data: { email: c, redirect_to: r || xc() }
        }), n == null || n(), T(!0);
      } catch (R) {
        const L = R;
        zr({ lapiError: L, email: c, submitNotification: h }), e(L);
      }
  }, E = () => d ? (S == null ? void 0 : S.sendingLink) || "Sending link..." : _ ? (S == null ? void 0 : S.retry) || "Retry" : (S == null ? void 0 : S.sendLink) || "Send me a login link", S = i == null ? void 0 : i.passwordless, C = i == null ? void 0 : i.error;
  return /* @__PURE__ */ Q(It, { children: [
    /* @__PURE__ */ Q(
      "form",
      {
        className: se(z.form, o == null ? void 0 : o.form),
        onSubmit: I,
        "data-testid": "login-link-form",
        children: [
          _ ? (S == null ? void 0 : S.sentLink) || /* @__PURE__ */ Q(Dt, { variant: "connect", "data-testid": "error-message", children: [
            /* @__PURE__ */ b(Xr, { icon: "checkCircleFilled", fill: "green" }),
            "Check your email inbox; we've sent a link"
          ] }) : null,
          /* @__PURE__ */ b(
            kt,
            {
              wrapperClassName: se(
                z.errorGap,
                o == null ? void 0 : o.emailInputWrapper
              ),
              className: o == null ? void 0 : o.emailInput,
              label: (S == null ? void 0 : S.emailLabel) || "Email",
              description: S == null ? void 0 : S.emailDescription,
              placeholder: (S == null ? void 0 : S.emailPlaceholder) || "name@provider.com",
              id: "email-input",
              onChange: (P) => {
                f(!1), l(P.target.value);
              },
              onBlur: () => {
                jt(c) || f(!0);
              },
              error: s ? (S == null ? void 0 : S.emailInvalid) || "Are you sure? This is not a valid email address" : void 0
            }
          ),
          /* @__PURE__ */ b(
            Bt,
            {
              disabled: s || d,
              type: "submit",
              variant: "primary",
              className: o == null ? void 0 : o.submitButton,
              children: E()
            }
          ),
          m ? /* @__PURE__ */ b(Zr, { copy: C, error: m }) : null
        ]
      }
    ),
    /* @__PURE__ */ b("hr", { className: z.hr }),
    /* @__PURE__ */ Q(
      "div",
      {
        className: se(z.switchMethod, o == null ? void 0 : o.switchMethod),
        "data-testid": "link-to-password",
        children: [
          (S == null ? void 0 : S.switchLoginMethodPre) || "Or",
          " ",
          /* @__PURE__ */ b(
            "button",
            {
              className: z.link,
              onClick: t,
              "data-ocularid": "switchMethod",
              children: (S == null ? void 0 : S.switchLoginMethod) || "login with password"
            }
          ),
          " ",
          (S == null ? void 0 : S.switchLoginMethodPost) || "instead."
        ]
      }
    )
  ] });
}, _u = ({
  onSuccessfulLogin: e,
  isTwoFactorRequired: t,
  switchLoginMethod: n,
  copy: r,
  styles: i
}) => {
  const [o, c] = te(""), [l, s] = te(!1), [f, h] = te(""), [O, d] = te(!1), [m, _] = te(!1), { post: T } = je(Be.fetchPostIwocapayNotifications), { post: I, isLoading: E, error: S } = je(Be.fetchPostPasswordLogin), C = async (R) => {
    R.preventDefault();
    const L = jt(o);
    if (L || s(!0), f || _(!0), L && f)
      try {
        const { data: U } = await I({ data: { email: o, password: f } });
        e == null || e(U);
      } catch (U) {
        const Y = U;
        zr({ lapiError: Y, email: o, submitNotification: T }), t(Y);
      }
  }, P = r == null ? void 0 : r.password, p = r == null ? void 0 : r.error;
  return /* @__PURE__ */ Q(It, { children: [
    /* @__PURE__ */ Q(
      "form",
      {
        className: se(z.form, i == null ? void 0 : i.form),
        "data-testid": "login-password-form",
        onSubmit: C,
        children: [
          /* @__PURE__ */ b(
            kt,
            {
              wrapperClassName: se(
                z.errorGap,
                i == null ? void 0 : i.emailInputWrapper
              ),
              className: se("fs-exclude", i == null ? void 0 : i.emailInput),
              label: (P == null ? void 0 : P.emailLabel) || "Email",
              description: P == null ? void 0 : P.emailDescription,
              "data-testid": "email-input",
              placeholder: (P == null ? void 0 : P.emailPlaceholder) || "name@provider.com",
              id: "email-input",
              onChange: (R) => {
                s(!1), c(R.target.value);
              },
              onBlur: () => {
                jt(o) || s(!0);
              },
              error: l ? (P == null ? void 0 : P.emailInvalid) || "Are you sure? This is not a valid email address" : void 0
            }
          ),
          /* @__PURE__ */ Q("div", { className: z.passwordWrapper, children: [
            /* @__PURE__ */ b(
              kt,
              {
                wrapperClassName: se(
                  z.errorGap,
                  i == null ? void 0 : i.passwordInputWrapper
                ),
                className: se("fs-exclude", i == null ? void 0 : i.passwordInput),
                label: (P == null ? void 0 : P.passwordLabel) || "Password",
                description: P == null ? void 0 : P.passwordDescription,
                "data-testid": "password-input",
                type: O ? "text" : "password",
                placeholder: (P == null ? void 0 : P.passwordPlaceholder) || "Password...",
                id: "password-input",
                onChange: (R) => {
                  _(!1), h(R.target.value);
                },
                onBlur: () => {
                  f || _(!0);
                },
                error: m ? (P == null ? void 0 : P.passwordInvalid) || "Please enter your password" : void 0
              }
            ),
            /* @__PURE__ */ b(
              Bt,
              {
                className: se(z.viewPassword, i == null ? void 0 : i.eyeButton),
                variant: "tertiary",
                onClick: (R) => d(!O),
                type: "button",
                children: /* @__PURE__ */ b(Xr, { icon: "eyeOutline" })
              }
            )
          ] }),
          /* @__PURE__ */ b(
            "a",
            {
              href: "/login/password/reset",
              className: se(
                z.link,
                z.forgottenPassword,
                i == null ? void 0 : i.forgottenLink
              ),
              children: (P == null ? void 0 : P.passwordForgotten) || "Forgotten your password?"
            }
          ),
          /* @__PURE__ */ b(
            Bt,
            {
              variant: "primary",
              disabled: l || m || E,
              className: i == null ? void 0 : i.submitButton,
              type: "submit",
              children: E ? (P == null ? void 0 : P.loggingIn) || "Logging in..." : (P == null ? void 0 : P.login) || "Log in"
            }
          ),
          S ? /* @__PURE__ */ b(Zr, { copy: p, error: S }) : null
        ]
      }
    ),
    /* @__PURE__ */ b("hr", { className: z.hr }),
    /* @__PURE__ */ Q(
      "div",
      {
        className: se(z.switchMethod, i == null ? void 0 : i.switchMethod),
        "data-testid": "link-to-login-link",
        children: [
          (P == null ? void 0 : P.switchLoginMethodPre) || "Or",
          " ",
          /* @__PURE__ */ b(
            "button",
            {
              className: z.link,
              onClick: n,
              "data-ocularid": "switchMethod",
              children: (P == null ? void 0 : P.switchLoginMethod) || "email me a login link"
            }
          ),
          " ",
          (P == null ? void 0 : P.switchLoginMethodPost) || "instead."
        ]
      }
    )
  ] });
};
var Eu = function(t) {
  return mu(t) && !gu(t);
};
function mu(e) {
  return !!e && typeof e == "object";
}
function gu(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || Au(e);
}
var Ou = typeof Symbol == "function" && Symbol.for, Su = Ou ? Symbol.for("react.element") : 60103;
function Au(e) {
  return e.$$typeof === Su;
}
function pu(e) {
  return Array.isArray(e) ? [] : {};
}
function Wt(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? pt(pu(e), e, t) : e;
}
function Tu(e, t, n) {
  return e.concat(t).map(function(r) {
    return Wt(r, n);
  });
}
function Pu(e, t, n) {
  var r = {};
  return n.isMergeableObject(e) && Object.keys(e).forEach(function(i) {
    r[i] = Wt(e[i], n);
  }), Object.keys(t).forEach(function(i) {
    !n.isMergeableObject(t[i]) || !e[i] ? r[i] = Wt(t[i], n) : r[i] = pt(e[i], t[i], n);
  }), r;
}
function pt(e, t, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || Tu, n.isMergeableObject = n.isMergeableObject || Eu;
  var r = Array.isArray(t), i = Array.isArray(e), o = r === i;
  return o ? r ? n.arrayMerge(e, t, n) : Pu(e, t, n) : Wt(t, n);
}
pt.all = function(t, n) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(r, i) {
    return pt(r, i, n);
  }, {});
};
var yn = pt, xr = typeof global == "object" && global && global.Object === Object && global, Iu = typeof self == "object" && self && self.Object === Object && self, Ee = xr || Iu || Function("return this")(), Ne = Ee.Symbol, ei = Object.prototype, yu = ei.hasOwnProperty, Ru = ei.toString, mt = Ne ? Ne.toStringTag : void 0;
function Cu(e) {
  var t = yu.call(e, mt), n = e[mt];
  try {
    e[mt] = void 0;
    var r = !0;
  } catch {
  }
  var i = Ru.call(e);
  return r && (t ? e[mt] = n : delete e[mt]), i;
}
var Nu = Object.prototype, Lu = Nu.toString;
function Fu(e) {
  return Lu.call(e);
}
var vu = "[object Null]", wu = "[object Undefined]", ir = Ne ? Ne.toStringTag : void 0;
function Ve(e) {
  return e == null ? e === void 0 ? wu : vu : ir && ir in Object(e) ? Cu(e) : Fu(e);
}
function ti(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Yn = ti(Object.getPrototypeOf, Object);
function qe(e) {
  return e != null && typeof e == "object";
}
var bu = "[object Object]", Gu = Function.prototype, Yu = Object.prototype, ni = Gu.toString, Du = Yu.hasOwnProperty, $u = ni.call(Object);
function ar(e) {
  if (!qe(e) || Ve(e) != bu)
    return !1;
  var t = Yn(e);
  if (t === null)
    return !0;
  var n = Du.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && ni.call(n) == $u;
}
function Mu() {
  this.__data__ = [], this.size = 0;
}
function ri(e, t) {
  return e === t || e !== e && t !== t;
}
function Xt(e, t) {
  for (var n = e.length; n--; )
    if (ri(e[n][0], t))
      return n;
  return -1;
}
var Ku = Array.prototype, Uu = Ku.splice;
function ku(e) {
  var t = this.__data__, n = Xt(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Uu.call(t, n, 1), --this.size, !0;
}
function Bu(e) {
  var t = this.__data__, n = Xt(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function ju(e) {
  return Xt(this.__data__, e) > -1;
}
function Wu(e, t) {
  var n = this.__data__, r = Xt(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function Ae(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ae.prototype.clear = Mu;
Ae.prototype.delete = ku;
Ae.prototype.get = Bu;
Ae.prototype.has = ju;
Ae.prototype.set = Wu;
function Vu() {
  this.__data__ = new Ae(), this.size = 0;
}
function qu(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function Hu(e) {
  return this.__data__.get(e);
}
function Ju(e) {
  return this.__data__.has(e);
}
function yt(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Xu = "[object AsyncFunction]", zu = "[object Function]", Qu = "[object GeneratorFunction]", Zu = "[object Proxy]";
function ii(e) {
  if (!yt(e))
    return !1;
  var t = Ve(e);
  return t == zu || t == Qu || t == Xu || t == Zu;
}
var dn = Ee["__core-js_shared__"], or = function() {
  var e = /[^.]+$/.exec(dn && dn.keys && dn.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function xu(e) {
  return !!or && or in e;
}
var es = Function.prototype, ts = es.toString;
function He(e) {
  if (e != null) {
    try {
      return ts.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ns = /[\\^$.*+?()[\]{}|]/g, rs = /^\[object .+?Constructor\]$/, is = Function.prototype, as = Object.prototype, os = is.toString, cs = as.hasOwnProperty, us = RegExp(
  "^" + os.call(cs).replace(ns, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ss(e) {
  if (!yt(e) || xu(e))
    return !1;
  var t = ii(e) ? us : rs;
  return t.test(He(e));
}
function ls(e, t) {
  return e == null ? void 0 : e[t];
}
function Je(e, t) {
  var n = ls(e, t);
  return ss(n) ? n : void 0;
}
var Tt = Je(Ee, "Map"), Pt = Je(Object, "create");
function fs() {
  this.__data__ = Pt ? Pt(null) : {}, this.size = 0;
}
function ds(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var hs = "__lodash_hash_undefined__", _s = Object.prototype, Es = _s.hasOwnProperty;
function ms(e) {
  var t = this.__data__;
  if (Pt) {
    var n = t[e];
    return n === hs ? void 0 : n;
  }
  return Es.call(t, e) ? t[e] : void 0;
}
var gs = Object.prototype, Os = gs.hasOwnProperty;
function Ss(e) {
  var t = this.__data__;
  return Pt ? t[e] !== void 0 : Os.call(t, e);
}
var As = "__lodash_hash_undefined__";
function ps(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Pt && t === void 0 ? As : t, this;
}
function We(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
We.prototype.clear = fs;
We.prototype.delete = ds;
We.prototype.get = ms;
We.prototype.has = Ss;
We.prototype.set = ps;
function Ts() {
  this.size = 0, this.__data__ = {
    hash: new We(),
    map: new (Tt || Ae)(),
    string: new We()
  };
}
function Ps(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function zt(e, t) {
  var n = e.__data__;
  return Ps(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Is(e) {
  var t = zt(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function ys(e) {
  return zt(this, e).get(e);
}
function Rs(e) {
  return zt(this, e).has(e);
}
function Cs(e, t) {
  var n = zt(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function Fe(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Fe.prototype.clear = Ts;
Fe.prototype.delete = Is;
Fe.prototype.get = ys;
Fe.prototype.has = Rs;
Fe.prototype.set = Cs;
var Ns = 200;
function Ls(e, t) {
  var n = this.__data__;
  if (n instanceof Ae) {
    var r = n.__data__;
    if (!Tt || r.length < Ns - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Fe(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function st(e) {
  var t = this.__data__ = new Ae(e);
  this.size = t.size;
}
st.prototype.clear = Vu;
st.prototype.delete = qu;
st.prototype.get = Hu;
st.prototype.has = Ju;
st.prototype.set = Ls;
function Fs(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var cr = function() {
  try {
    var e = Je(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function ai(e, t, n) {
  t == "__proto__" && cr ? cr(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var vs = Object.prototype, ws = vs.hasOwnProperty;
function oi(e, t, n) {
  var r = e[t];
  (!(ws.call(e, t) && ri(r, n)) || n === void 0 && !(t in e)) && ai(e, t, n);
}
function Qt(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, c = t.length; ++o < c; ) {
    var l = t[o], s = void 0;
    s === void 0 && (s = e[l]), i ? ai(n, l, s) : oi(n, l, s);
  }
  return n;
}
function bs(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var Gs = "[object Arguments]";
function ur(e) {
  return qe(e) && Ve(e) == Gs;
}
var ci = Object.prototype, Ys = ci.hasOwnProperty, Ds = ci.propertyIsEnumerable, $s = ur(/* @__PURE__ */ function() {
  return arguments;
}()) ? ur : function(e) {
  return qe(e) && Ys.call(e, "callee") && !Ds.call(e, "callee");
}, Rt = Array.isArray;
function Ms() {
  return !1;
}
var ui = typeof exports == "object" && exports && !exports.nodeType && exports, sr = ui && typeof module == "object" && module && !module.nodeType && module, Ks = sr && sr.exports === ui, lr = Ks ? Ee.Buffer : void 0, Us = lr ? lr.isBuffer : void 0, si = Us || Ms, ks = 9007199254740991, Bs = /^(?:0|[1-9]\d*)$/;
function js(e, t) {
  var n = typeof e;
  return t = t ?? ks, !!t && (n == "number" || n != "symbol" && Bs.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Ws = 9007199254740991;
function li(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ws;
}
var Vs = "[object Arguments]", qs = "[object Array]", Hs = "[object Boolean]", Js = "[object Date]", Xs = "[object Error]", zs = "[object Function]", Qs = "[object Map]", Zs = "[object Number]", xs = "[object Object]", el = "[object RegExp]", tl = "[object Set]", nl = "[object String]", rl = "[object WeakMap]", il = "[object ArrayBuffer]", al = "[object DataView]", ol = "[object Float32Array]", cl = "[object Float64Array]", ul = "[object Int8Array]", sl = "[object Int16Array]", ll = "[object Int32Array]", fl = "[object Uint8Array]", dl = "[object Uint8ClampedArray]", hl = "[object Uint16Array]", _l = "[object Uint32Array]", B = {};
B[ol] = B[cl] = B[ul] = B[sl] = B[ll] = B[fl] = B[dl] = B[hl] = B[_l] = !0;
B[Vs] = B[qs] = B[il] = B[Hs] = B[al] = B[Js] = B[Xs] = B[zs] = B[Qs] = B[Zs] = B[xs] = B[el] = B[tl] = B[nl] = B[rl] = !1;
function El(e) {
  return qe(e) && li(e.length) && !!B[Ve(e)];
}
function Dn(e) {
  return function(t) {
    return e(t);
  };
}
var fi = typeof exports == "object" && exports && !exports.nodeType && exports, St = fi && typeof module == "object" && module && !module.nodeType && module, ml = St && St.exports === fi, hn = ml && xr.process, ut = function() {
  try {
    var e = St && St.require && St.require("util").types;
    return e || hn && hn.binding && hn.binding("util");
  } catch {
  }
}(), fr = ut && ut.isTypedArray, gl = fr ? Dn(fr) : El, Ol = Object.prototype, Sl = Ol.hasOwnProperty;
function di(e, t) {
  var n = Rt(e), r = !n && $s(e), i = !n && !r && si(e), o = !n && !r && !i && gl(e), c = n || r || i || o, l = c ? bs(e.length, String) : [], s = l.length;
  for (var f in e)
    (t || Sl.call(e, f)) && !(c && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    js(f, s))) && l.push(f);
  return l;
}
var Al = Object.prototype;
function $n(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Al;
  return e === n;
}
var pl = ti(Object.keys, Object), Tl = Object.prototype, Pl = Tl.hasOwnProperty;
function Il(e) {
  if (!$n(e))
    return pl(e);
  var t = [];
  for (var n in Object(e))
    Pl.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function hi(e) {
  return e != null && li(e.length) && !ii(e);
}
function Mn(e) {
  return hi(e) ? di(e) : Il(e);
}
function yl(e, t) {
  return e && Qt(t, Mn(t), e);
}
function Rl(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var Cl = Object.prototype, Nl = Cl.hasOwnProperty;
function Ll(e) {
  if (!yt(e))
    return Rl(e);
  var t = $n(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !Nl.call(e, r)) || n.push(r);
  return n;
}
function Kn(e) {
  return hi(e) ? di(e, !0) : Ll(e);
}
function Fl(e, t) {
  return e && Qt(t, Kn(t), e);
}
var _i = typeof exports == "object" && exports && !exports.nodeType && exports, dr = _i && typeof module == "object" && module && !module.nodeType && module, vl = dr && dr.exports === _i, hr = vl ? Ee.Buffer : void 0, _r = hr ? hr.allocUnsafe : void 0;
function wl(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = _r ? _r(n) : new e.constructor(n);
  return e.copy(r), r;
}
function Ei(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
function bl(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var c = e[n];
    t(c, n, e) && (o[i++] = c);
  }
  return o;
}
function mi() {
  return [];
}
var Gl = Object.prototype, Yl = Gl.propertyIsEnumerable, Er = Object.getOwnPropertySymbols, Un = Er ? function(e) {
  return e == null ? [] : (e = Object(e), bl(Er(e), function(t) {
    return Yl.call(e, t);
  }));
} : mi;
function Dl(e, t) {
  return Qt(e, Un(e), t);
}
function gi(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var $l = Object.getOwnPropertySymbols, Oi = $l ? function(e) {
  for (var t = []; e; )
    gi(t, Un(e)), e = Yn(e);
  return t;
} : mi;
function Ml(e, t) {
  return Qt(e, Oi(e), t);
}
function Si(e, t, n) {
  var r = t(e);
  return Rt(e) ? r : gi(r, n(e));
}
function Kl(e) {
  return Si(e, Mn, Un);
}
function Ul(e) {
  return Si(e, Kn, Oi);
}
var Rn = Je(Ee, "DataView"), Cn = Je(Ee, "Promise"), Nn = Je(Ee, "Set"), Ln = Je(Ee, "WeakMap"), mr = "[object Map]", kl = "[object Object]", gr = "[object Promise]", Or = "[object Set]", Sr = "[object WeakMap]", Ar = "[object DataView]", Bl = He(Rn), jl = He(Tt), Wl = He(Cn), Vl = He(Nn), ql = He(Ln), ge = Ve;
(Rn && ge(new Rn(new ArrayBuffer(1))) != Ar || Tt && ge(new Tt()) != mr || Cn && ge(Cn.resolve()) != gr || Nn && ge(new Nn()) != Or || Ln && ge(new Ln()) != Sr) && (ge = function(e) {
  var t = Ve(e), n = t == kl ? e.constructor : void 0, r = n ? He(n) : "";
  if (r)
    switch (r) {
      case Bl:
        return Ar;
      case jl:
        return mr;
      case Wl:
        return gr;
      case Vl:
        return Or;
      case ql:
        return Sr;
    }
  return t;
});
var Hl = Object.prototype, Jl = Hl.hasOwnProperty;
function Xl(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Jl.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var pr = Ee.Uint8Array;
function kn(e) {
  var t = new e.constructor(e.byteLength);
  return new pr(t).set(new pr(e)), t;
}
function zl(e, t) {
  var n = t ? kn(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Ql = /\w*$/;
function Zl(e) {
  var t = new e.constructor(e.source, Ql.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Tr = Ne ? Ne.prototype : void 0, Pr = Tr ? Tr.valueOf : void 0;
function xl(e) {
  return Pr ? Object(Pr.call(e)) : {};
}
function ef(e, t) {
  var n = t ? kn(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var tf = "[object Boolean]", nf = "[object Date]", rf = "[object Map]", af = "[object Number]", of = "[object RegExp]", cf = "[object Set]", uf = "[object String]", sf = "[object Symbol]", lf = "[object ArrayBuffer]", ff = "[object DataView]", df = "[object Float32Array]", hf = "[object Float64Array]", _f = "[object Int8Array]", Ef = "[object Int16Array]", mf = "[object Int32Array]", gf = "[object Uint8Array]", Of = "[object Uint8ClampedArray]", Sf = "[object Uint16Array]", Af = "[object Uint32Array]";
function pf(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case lf:
      return kn(e);
    case tf:
    case nf:
      return new r(+e);
    case ff:
      return zl(e, n);
    case df:
    case hf:
    case _f:
    case Ef:
    case mf:
    case gf:
    case Of:
    case Sf:
    case Af:
      return ef(e, n);
    case rf:
      return new r();
    case af:
    case uf:
      return new r(e);
    case of:
      return Zl(e);
    case cf:
      return new r();
    case sf:
      return xl(e);
  }
}
var Ir = Object.create, Tf = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!yt(t))
      return {};
    if (Ir)
      return Ir(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Pf(e) {
  return typeof e.constructor == "function" && !$n(e) ? Tf(Yn(e)) : {};
}
var If = "[object Map]";
function yf(e) {
  return qe(e) && ge(e) == If;
}
var yr = ut && ut.isMap, Rf = yr ? Dn(yr) : yf, Cf = "[object Set]";
function Nf(e) {
  return qe(e) && ge(e) == Cf;
}
var Rr = ut && ut.isSet, Lf = Rr ? Dn(Rr) : Nf, Ff = 1, vf = 2, wf = 4, Ai = "[object Arguments]", bf = "[object Array]", Gf = "[object Boolean]", Yf = "[object Date]", Df = "[object Error]", pi = "[object Function]", $f = "[object GeneratorFunction]", Mf = "[object Map]", Kf = "[object Number]", Ti = "[object Object]", Uf = "[object RegExp]", kf = "[object Set]", Bf = "[object String]", jf = "[object Symbol]", Wf = "[object WeakMap]", Vf = "[object ArrayBuffer]", qf = "[object DataView]", Hf = "[object Float32Array]", Jf = "[object Float64Array]", Xf = "[object Int8Array]", zf = "[object Int16Array]", Qf = "[object Int32Array]", Zf = "[object Uint8Array]", xf = "[object Uint8ClampedArray]", ed = "[object Uint16Array]", td = "[object Uint32Array]", k = {};
k[Ai] = k[bf] = k[Vf] = k[qf] = k[Gf] = k[Yf] = k[Hf] = k[Jf] = k[Xf] = k[zf] = k[Qf] = k[Mf] = k[Kf] = k[Ti] = k[Uf] = k[kf] = k[Bf] = k[jf] = k[Zf] = k[xf] = k[ed] = k[td] = !0;
k[Df] = k[pi] = k[Wf] = !1;
function At(e, t, n, r, i, o) {
  var c, l = t & Ff, s = t & vf, f = t & wf;
  if (c !== void 0)
    return c;
  if (!yt(e))
    return e;
  var h = Rt(e);
  if (h) {
    if (c = Xl(e), !l)
      return Ei(e, c);
  } else {
    var O = ge(e), d = O == pi || O == $f;
    if (si(e))
      return wl(e, l);
    if (O == Ti || O == Ai || d && !i) {
      if (c = s || d ? {} : Pf(e), !l)
        return s ? Ml(e, Fl(c, e)) : Dl(e, yl(c, e));
    } else {
      if (!k[O])
        return i ? e : {};
      c = pf(e, O, l);
    }
  }
  o || (o = new st());
  var m = o.get(e);
  if (m)
    return m;
  o.set(e, c), Lf(e) ? e.forEach(function(I) {
    c.add(At(I, t, n, I, e, o));
  }) : Rf(e) && e.forEach(function(I, E) {
    c.set(E, At(I, t, n, E, e, o));
  });
  var _ = f ? s ? Ul : Kl : s ? Kn : Mn, T = h ? void 0 : _(e);
  return Fs(T || e, function(I, E) {
    T && (E = I, I = e[E]), oi(c, E, At(I, t, n, E, e, o));
  }), c;
}
var nd = 1, rd = 4;
function Ft(e) {
  return At(e, nd | rd);
}
var _n, Cr;
function id() {
  if (Cr) return _n;
  Cr = 1;
  var e = Array.isArray, t = Object.keys, n = Object.prototype.hasOwnProperty, r = typeof Element < "u";
  function i(o, c) {
    if (o === c) return !0;
    if (o && c && typeof o == "object" && typeof c == "object") {
      var l = e(o), s = e(c), f, h, O;
      if (l && s) {
        if (h = o.length, h != c.length) return !1;
        for (f = h; f-- !== 0; )
          if (!i(o[f], c[f])) return !1;
        return !0;
      }
      if (l != s) return !1;
      var d = o instanceof Date, m = c instanceof Date;
      if (d != m) return !1;
      if (d && m) return o.getTime() == c.getTime();
      var _ = o instanceof RegExp, T = c instanceof RegExp;
      if (_ != T) return !1;
      if (_ && T) return o.toString() == c.toString();
      var I = t(o);
      if (h = I.length, h !== t(c).length)
        return !1;
      for (f = h; f-- !== 0; )
        if (!n.call(c, I[f])) return !1;
      if (r && o instanceof Element && c instanceof Element)
        return o === c;
      for (f = h; f-- !== 0; )
        if (O = I[f], !(O === "_owner" && o.$$typeof) && !i(o[O], c[O]))
          return !1;
      return !0;
    }
    return o !== o && c !== c;
  }
  return _n = function(c, l) {
    try {
      return i(c, l);
    } catch (s) {
      if (s.message && s.message.match(/stack|recursion/i) || s.number === -2146828260)
        return console.warn("Warning: react-fast-compare does not handle circular references.", s.name, s.message), !1;
      throw s;
    }
  }, _n;
}
var ad = id();
const $e = /* @__PURE__ */ Qr(ad);
var od = process.env.NODE_ENV === "production";
function q(e, t) {
  if (!od) {
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
var cd = 4;
function Nr(e) {
  return At(e, cd);
}
function Pi(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var ud = "[object Symbol]";
function Bn(e) {
  return typeof e == "symbol" || qe(e) && Ve(e) == ud;
}
var sd = "Expected a function";
function jn(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(sd);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var c = e.apply(this, r);
    return n.cache = o.set(i, c) || o, c;
  };
  return n.cache = new (jn.Cache || Fe)(), n;
}
jn.Cache = Fe;
var ld = 500;
function fd(e) {
  var t = jn(e, function(r) {
    return n.size === ld && n.clear(), r;
  }), n = t.cache;
  return t;
}
var dd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hd = /\\(\\)?/g, _d = fd(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(dd, function(n, r, i, o) {
    t.push(i ? o.replace(hd, "$1") : r || n);
  }), t;
});
function Ed(e) {
  if (typeof e == "string" || Bn(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Lr = Ne ? Ne.prototype : void 0, Fr = Lr ? Lr.toString : void 0;
function Ii(e) {
  if (typeof e == "string")
    return e;
  if (Rt(e))
    return Pi(e, Ii) + "";
  if (Bn(e))
    return Fr ? Fr.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function md(e) {
  return e == null ? "" : Ii(e);
}
function yi(e) {
  return Rt(e) ? Pi(e, Ed) : Bn(e) ? [e] : Ei(_d(md(e)));
}
var vt = { exports: {} }, $ = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vr;
function gd() {
  if (vr) return $;
  vr = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, O = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, T = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
  function C(p) {
    if (typeof p == "object" && p !== null) {
      var R = p.$$typeof;
      switch (R) {
        case t:
          switch (p = p.type, p) {
            case s:
            case f:
            case r:
            case o:
            case i:
            case O:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case l:
                case h:
                case _:
                case m:
                case c:
                  return p;
                default:
                  return R;
              }
          }
        case n:
          return R;
      }
    }
  }
  function P(p) {
    return C(p) === f;
  }
  return $.AsyncMode = s, $.ConcurrentMode = f, $.ContextConsumer = l, $.ContextProvider = c, $.Element = t, $.ForwardRef = h, $.Fragment = r, $.Lazy = _, $.Memo = m, $.Portal = n, $.Profiler = o, $.StrictMode = i, $.Suspense = O, $.isAsyncMode = function(p) {
    return P(p) || C(p) === s;
  }, $.isConcurrentMode = P, $.isContextConsumer = function(p) {
    return C(p) === l;
  }, $.isContextProvider = function(p) {
    return C(p) === c;
  }, $.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, $.isForwardRef = function(p) {
    return C(p) === h;
  }, $.isFragment = function(p) {
    return C(p) === r;
  }, $.isLazy = function(p) {
    return C(p) === _;
  }, $.isMemo = function(p) {
    return C(p) === m;
  }, $.isPortal = function(p) {
    return C(p) === n;
  }, $.isProfiler = function(p) {
    return C(p) === o;
  }, $.isStrictMode = function(p) {
    return C(p) === i;
  }, $.isSuspense = function(p) {
    return C(p) === O;
  }, $.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === f || p === o || p === i || p === O || p === d || typeof p == "object" && p !== null && (p.$$typeof === _ || p.$$typeof === m || p.$$typeof === c || p.$$typeof === l || p.$$typeof === h || p.$$typeof === I || p.$$typeof === E || p.$$typeof === S || p.$$typeof === T);
  }, $.typeOf = C, $;
}
var M = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wr;
function Od() {
  return wr || (wr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, O = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, T = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
    function C(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === r || v === f || v === o || v === i || v === O || v === d || typeof v == "object" && v !== null && (v.$$typeof === _ || v.$$typeof === m || v.$$typeof === c || v.$$typeof === l || v.$$typeof === h || v.$$typeof === I || v.$$typeof === E || v.$$typeof === S || v.$$typeof === T);
    }
    function P(v) {
      if (typeof v == "object" && v !== null) {
        var Ie = v.$$typeof;
        switch (Ie) {
          case t:
            var ye = v.type;
            switch (ye) {
              case s:
              case f:
              case r:
              case o:
              case i:
              case O:
                return ye;
              default:
                var it = ye && ye.$$typeof;
                switch (it) {
                  case l:
                  case h:
                  case _:
                  case m:
                  case c:
                    return it;
                  default:
                    return Ie;
                }
            }
          case n:
            return Ie;
        }
      }
    }
    var p = s, R = f, L = l, U = c, Y = t, H = h, K = r, ne = _, J = m, oe = n, Qe = o, ft = i, dt = O, ve = !1;
    function Ze(v) {
      return ve || (ve = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), we(v) || P(v) === s;
    }
    function we(v) {
      return P(v) === f;
    }
    function Pe(v) {
      return P(v) === l;
    }
    function fe(v) {
      return P(v) === c;
    }
    function xe(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function be(v) {
      return P(v) === h;
    }
    function de(v) {
      return P(v) === r;
    }
    function et(v) {
      return P(v) === _;
    }
    function Ge(v) {
      return P(v) === m;
    }
    function tt(v) {
      return P(v) === n;
    }
    function nt(v) {
      return P(v) === o;
    }
    function rt(v) {
      return P(v) === i;
    }
    function Ye(v) {
      return P(v) === O;
    }
    M.AsyncMode = p, M.ConcurrentMode = R, M.ContextConsumer = L, M.ContextProvider = U, M.Element = Y, M.ForwardRef = H, M.Fragment = K, M.Lazy = ne, M.Memo = J, M.Portal = oe, M.Profiler = Qe, M.StrictMode = ft, M.Suspense = dt, M.isAsyncMode = Ze, M.isConcurrentMode = we, M.isContextConsumer = Pe, M.isContextProvider = fe, M.isElement = xe, M.isForwardRef = be, M.isFragment = de, M.isLazy = et, M.isMemo = Ge, M.isPortal = tt, M.isProfiler = nt, M.isStrictMode = rt, M.isSuspense = Ye, M.isValidElementType = C, M.typeOf = P;
  }()), M;
}
var br;
function Sd() {
  return br || (br = 1, process.env.NODE_ENV === "production" ? vt.exports = gd() : vt.exports = Od()), vt.exports;
}
var En, Gr;
function Ad() {
  if (Gr) return En;
  Gr = 1;
  var e = Sd(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = r, o[e.Memo] = i;
  function c(_) {
    return e.isMemo(_) ? i : o[_.$$typeof] || t;
  }
  var l = Object.defineProperty, s = Object.getOwnPropertyNames, f = Object.getOwnPropertySymbols, h = Object.getOwnPropertyDescriptor, O = Object.getPrototypeOf, d = Object.prototype;
  function m(_, T, I) {
    if (typeof T != "string") {
      if (d) {
        var E = O(T);
        E && E !== d && m(_, E, I);
      }
      var S = s(T);
      f && (S = S.concat(f(T)));
      for (var C = c(_), P = c(T), p = 0; p < S.length; ++p) {
        var R = S[p];
        if (!n[R] && !(I && I[R]) && !(P && P[R]) && !(C && C[R])) {
          var L = h(T, R);
          try {
            l(_, R, L);
          } catch {
          }
        }
      }
    }
    return _;
  }
  return En = m, En;
}
Ad();
function j() {
  return j = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j.apply(this, arguments);
}
function ot(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Zt = /* @__PURE__ */ qc(void 0);
Zt.displayName = "FormikContext";
var pd = Zt.Provider;
Zt.Consumer;
function Wn() {
  var e = Hc(Zt);
  return e || (process.env.NODE_ENV !== "production" ? q(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : q()), e;
}
var Z = function(t) {
  return typeof t == "function";
}, Ct = function(t) {
  return t !== null && typeof t == "object";
}, Td = function(t) {
  return String(Math.floor(Number(t))) === t;
}, mn = function(t) {
  return Object.prototype.toString.call(t) === "[object String]";
}, Ri = function(t) {
  return Jr.count(t) === 0;
}, gn = function(t) {
  return Ct(t) && Z(t.then);
};
function Pd(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function ie(e, t, n, r) {
  r === void 0 && (r = 0);
  for (var i = yi(t); e && r < i.length; )
    e = e[i[r++]];
  return r !== i.length && !e || e === void 0 ? n : e;
}
function Ue(e, t, n) {
  for (var r = Nr(e), i = r, o = 0, c = yi(t); o < c.length - 1; o++) {
    var l = c[o], s = ie(e, c.slice(0, o + 1));
    if (s && (Ct(s) || Array.isArray(s)))
      i = i[l] = Nr(s);
    else {
      var f = c[o + 1];
      i = i[l] = Td(f) && Number(f) >= 0 ? [] : {};
    }
  }
  return (o === 0 ? e : i)[c[o]] === n ? e : (n === void 0 ? delete i[c[o]] : i[c[o]] = n, o === 0 && n === void 0 && delete r[c[o]], r);
}
function Ci(e, t, n, r) {
  n === void 0 && (n = /* @__PURE__ */ new WeakMap()), r === void 0 && (r = {});
  for (var i = 0, o = Object.keys(e); i < o.length; i++) {
    var c = o[i], l = e[c];
    Ct(l) ? n.get(l) || (n.set(l, !0), r[c] = Array.isArray(l) ? [] : {}, Ci(l, t, n, r[c])) : r[c] = t;
  }
  return r;
}
function Id(e, t) {
  switch (t.type) {
    case "SET_VALUES":
      return j({}, e, {
        values: t.payload
      });
    case "SET_TOUCHED":
      return j({}, e, {
        touched: t.payload
      });
    case "SET_ERRORS":
      return $e(e.errors, t.payload) ? e : j({}, e, {
        errors: t.payload
      });
    case "SET_STATUS":
      return j({}, e, {
        status: t.payload
      });
    case "SET_ISSUBMITTING":
      return j({}, e, {
        isSubmitting: t.payload
      });
    case "SET_ISVALIDATING":
      return j({}, e, {
        isValidating: t.payload
      });
    case "SET_FIELD_VALUE":
      return j({}, e, {
        values: Ue(e.values, t.payload.field, t.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return j({}, e, {
        touched: Ue(e.touched, t.payload.field, t.payload.value)
      });
    case "SET_FIELD_ERROR":
      return j({}, e, {
        errors: Ue(e.errors, t.payload.field, t.payload.value)
      });
    case "RESET_FORM":
      return j({}, e, t.payload);
    case "SET_FORMIK_STATE":
      return t.payload(e);
    case "SUBMIT_ATTEMPT":
      return j({}, e, {
        touched: Ci(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return j({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return j({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var De = {}, wt = {};
function yd(e) {
  var t = e.validateOnChange, n = t === void 0 ? !0 : t, r = e.validateOnBlur, i = r === void 0 ? !0 : r, o = e.validateOnMount, c = o === void 0 ? !1 : o, l = e.isInitialValid, s = e.enableReinitialize, f = s === void 0 ? !1 : s, h = e.onSubmit, O = ot(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), d = j({
    validateOnChange: n,
    validateOnBlur: i,
    validateOnMount: c,
    onSubmit: h
  }, O), m = Re(d.initialValues), _ = Re(d.initialErrors || De), T = Re(d.initialTouched || wt), I = Re(d.initialStatus), E = Re(!1), S = Re({});
  process.env.NODE_ENV !== "production" && ae(function() {
    typeof l > "u" || (process.env.NODE_ENV !== "production" ? q(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : q());
  }, []), ae(function() {
    return E.current = !0, function() {
      E.current = !1;
    };
  }, []);
  var C = te(0), P = C[1], p = Re({
    values: Ft(d.initialValues),
    errors: Ft(d.initialErrors) || De,
    touched: Ft(d.initialTouched) || wt,
    status: Ft(d.initialStatus),
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), R = p.current, L = W(function(A) {
    var N = p.current;
    p.current = Id(N, A), N !== p.current && P(function(F) {
      return F + 1;
    });
  }, []), U = W(function(A, N) {
    return new Promise(function(F, w) {
      var G = d.validate(A, N);
      G == null ? F(De) : gn(G) ? G.then(function(D) {
        F(D || De);
      }, function(D) {
        process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", D), w(D);
      }) : F(G);
    });
  }, [d.validate]), Y = W(function(A, N) {
    var F = d.validationSchema, w = Z(F) ? F(N) : F, G = N && w.validateAt ? w.validateAt(N, A) : Nd(A, w);
    return new Promise(function(D, V) {
      G.then(function() {
        D(De);
      }, function(ce) {
        ce.name === "ValidationError" ? D(Cd(ce)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", ce), V(ce));
      });
    });
  }, [d.validationSchema]), H = W(function(A, N) {
    return new Promise(function(F) {
      return F(S.current[A].validate(N));
    });
  }, []), K = W(function(A) {
    var N = Object.keys(S.current).filter(function(w) {
      return Z(S.current[w].validate);
    }), F = N.length > 0 ? N.map(function(w) {
      return H(w, ie(A, w));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(F).then(function(w) {
      return w.reduce(function(G, D, V) {
        return D === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || D && (G = Ue(G, N[V], D)), G;
      }, {});
    });
  }, [H]), ne = W(function(A) {
    return Promise.all([K(A), d.validationSchema ? Y(A) : {}, d.validate ? U(A) : {}]).then(function(N) {
      var F = N[0], w = N[1], G = N[2], D = yn.all([F, w, G], {
        arrayMerge: Ld
      });
      return D;
    });
  }, [d.validate, d.validationSchema, K, U, Y]), J = ue(function(A) {
    return A === void 0 && (A = R.values), L({
      type: "SET_ISVALIDATING",
      payload: !0
    }), ne(A).then(function(N) {
      return E.current && (L({
        type: "SET_ISVALIDATING",
        payload: !1
      }), L({
        type: "SET_ERRORS",
        payload: N
      })), N;
    });
  });
  ae(function() {
    c && E.current === !0 && $e(m.current, d.initialValues) && J(m.current);
  }, [c, J]);
  var oe = W(function(A) {
    var N = A && A.values ? A.values : m.current, F = A && A.errors ? A.errors : _.current ? _.current : d.initialErrors || {}, w = A && A.touched ? A.touched : T.current ? T.current : d.initialTouched || {}, G = A && A.status ? A.status : I.current ? I.current : d.initialStatus;
    m.current = N, _.current = F, T.current = w, I.current = G;
    var D = function() {
      L({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!A && !!A.isSubmitting,
          errors: F,
          touched: w,
          status: G,
          values: N,
          isValidating: !!A && !!A.isValidating,
          submitCount: A && A.submitCount && typeof A.submitCount == "number" ? A.submitCount : 0
        }
      });
    };
    if (d.onReset) {
      var V = d.onReset(R.values, Ie);
      gn(V) ? V.then(D) : D();
    } else
      D();
  }, [d.initialErrors, d.initialStatus, d.initialTouched, d.onReset]);
  ae(function() {
    E.current === !0 && !$e(m.current, d.initialValues) && f && (m.current = d.initialValues, oe(), c && J(m.current));
  }, [f, d.initialValues, oe, c, J]), ae(function() {
    f && E.current === !0 && !$e(_.current, d.initialErrors) && (_.current = d.initialErrors || De, L({
      type: "SET_ERRORS",
      payload: d.initialErrors || De
    }));
  }, [f, d.initialErrors]), ae(function() {
    f && E.current === !0 && !$e(T.current, d.initialTouched) && (T.current = d.initialTouched || wt, L({
      type: "SET_TOUCHED",
      payload: d.initialTouched || wt
    }));
  }, [f, d.initialTouched]), ae(function() {
    f && E.current === !0 && !$e(I.current, d.initialStatus) && (I.current = d.initialStatus, L({
      type: "SET_STATUS",
      payload: d.initialStatus
    }));
  }, [f, d.initialStatus, d.initialTouched]);
  var Qe = ue(function(A) {
    if (S.current[A] && Z(S.current[A].validate)) {
      var N = ie(R.values, A), F = S.current[A].validate(N);
      return gn(F) ? (L({
        type: "SET_ISVALIDATING",
        payload: !0
      }), F.then(function(w) {
        return w;
      }).then(function(w) {
        L({
          type: "SET_FIELD_ERROR",
          payload: {
            field: A,
            value: w
          }
        }), L({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (L({
        type: "SET_FIELD_ERROR",
        payload: {
          field: A,
          value: F
        }
      }), Promise.resolve(F));
    } else if (d.validationSchema)
      return L({
        type: "SET_ISVALIDATING",
        payload: !0
      }), Y(R.values, A).then(function(w) {
        return w;
      }).then(function(w) {
        L({
          type: "SET_FIELD_ERROR",
          payload: {
            field: A,
            value: ie(w, A)
          }
        }), L({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), ft = W(function(A, N) {
    var F = N.validate;
    S.current[A] = {
      validate: F
    };
  }, []), dt = W(function(A) {
    delete S.current[A];
  }, []), ve = ue(function(A, N) {
    L({
      type: "SET_TOUCHED",
      payload: A
    });
    var F = N === void 0 ? i : N;
    return F ? J(R.values) : Promise.resolve();
  }), Ze = W(function(A) {
    L({
      type: "SET_ERRORS",
      payload: A
    });
  }, []), we = ue(function(A, N) {
    var F = Z(A) ? A(R.values) : A;
    L({
      type: "SET_VALUES",
      payload: F
    });
    var w = N === void 0 ? n : N;
    return w ? J(F) : Promise.resolve();
  }), Pe = W(function(A, N) {
    L({
      type: "SET_FIELD_ERROR",
      payload: {
        field: A,
        value: N
      }
    });
  }, []), fe = ue(function(A, N, F) {
    L({
      type: "SET_FIELD_VALUE",
      payload: {
        field: A,
        value: N
      }
    });
    var w = F === void 0 ? n : F;
    return w ? J(Ue(R.values, A, N)) : Promise.resolve();
  }), xe = W(function(A, N) {
    var F = N, w = A, G;
    if (!mn(A)) {
      A.persist && A.persist();
      var D = A.target ? A.target : A.currentTarget, V = D.type, ce = D.name, _t = D.id, Et = D.value, un = D.checked, sn = D.outerHTML, Lt = D.options, ln = D.multiple;
      F = N || ce || _t, !F && process.env.NODE_ENV !== "production" && Yr({
        htmlContent: sn,
        documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
        handlerName: "handleChange"
      }), w = /number|range/.test(V) ? (G = parseFloat(Et), isNaN(G) ? "" : G) : /checkbox/.test(V) ? vd(ie(R.values, F), un, Et) : Lt && ln ? Fd(Lt) : Et;
    }
    F && fe(F, w);
  }, [fe, R.values]), be = ue(function(A) {
    if (mn(A))
      return function(N) {
        return xe(N, A);
      };
    xe(A);
  }), de = ue(function(A, N, F) {
    N === void 0 && (N = !0), L({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: A,
        value: N
      }
    });
    var w = F === void 0 ? i : F;
    return w ? J(R.values) : Promise.resolve();
  }), et = W(function(A, N) {
    A.persist && A.persist();
    var F = A.target, w = F.name, G = F.id, D = F.outerHTML, V = N || w || G;
    !V && process.env.NODE_ENV !== "production" && Yr({
      htmlContent: D,
      documentationAnchorLink: "handleblur-e-any--void",
      handlerName: "handleBlur"
    }), de(V, !0);
  }, [de]), Ge = ue(function(A) {
    if (mn(A))
      return function(N) {
        return et(N, A);
      };
    et(A);
  }), tt = W(function(A) {
    Z(A) ? L({
      type: "SET_FORMIK_STATE",
      payload: A
    }) : L({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return A;
      }
    });
  }, []), nt = W(function(A) {
    L({
      type: "SET_STATUS",
      payload: A
    });
  }, []), rt = W(function(A) {
    L({
      type: "SET_ISSUBMITTING",
      payload: A
    });
  }, []), Ye = ue(function() {
    return L({
      type: "SUBMIT_ATTEMPT"
    }), J().then(function(A) {
      var N = A instanceof Error, F = !N && Object.keys(A).length === 0;
      if (F) {
        var w;
        try {
          if (w = ye(), w === void 0)
            return;
        } catch (G) {
          throw G;
        }
        return Promise.resolve(w).then(function(G) {
          return E.current && L({
            type: "SUBMIT_SUCCESS"
          }), G;
        }).catch(function(G) {
          if (E.current)
            throw L({
              type: "SUBMIT_FAILURE"
            }), G;
        });
      } else if (E.current && (L({
        type: "SUBMIT_FAILURE"
      }), N))
        throw A;
    });
  }), v = ue(function(A) {
    if (A && A.preventDefault && Z(A.preventDefault) && A.preventDefault(), A && A.stopPropagation && Z(A.stopPropagation) && A.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
      var N = Pd();
      N !== null && N instanceof HTMLButtonElement && (N.attributes && N.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? q(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : q()));
    }
    Ye().catch(function(F) {
      console.warn("Warning: An unhandled error was caught from submitForm()", F);
    });
  }), Ie = {
    resetForm: oe,
    validateForm: J,
    validateField: Qe,
    setErrors: Ze,
    setFieldError: Pe,
    setFieldTouched: de,
    setFieldValue: fe,
    setStatus: nt,
    setSubmitting: rt,
    setTouched: ve,
    setValues: we,
    setFormikState: tt,
    submitForm: Ye
  }, ye = ue(function() {
    return h(R.values, Ie);
  }), it = ue(function(A) {
    A && A.preventDefault && Z(A.preventDefault) && A.preventDefault(), A && A.stopPropagation && Z(A.stopPropagation) && A.stopPropagation(), oe();
  }), nn = W(function(A) {
    return {
      value: ie(R.values, A),
      error: ie(R.errors, A),
      touched: !!ie(R.touched, A),
      initialValue: ie(m.current, A),
      initialTouched: !!ie(T.current, A),
      initialError: ie(_.current, A)
    };
  }, [R.errors, R.touched, R.values]), rn = W(function(A) {
    return {
      setValue: function(F, w) {
        return fe(A, F, w);
      },
      setTouched: function(F, w) {
        return de(A, F, w);
      },
      setError: function(F) {
        return Pe(A, F);
      }
    };
  }, [fe, de, Pe]), an = W(function(A) {
    var N = Ct(A), F = N ? A.name : A, w = ie(R.values, F), G = {
      name: F,
      value: w,
      onChange: be,
      onBlur: Ge
    };
    if (N) {
      var D = A.type, V = A.value, ce = A.as, _t = A.multiple;
      D === "checkbox" ? V === void 0 ? G.checked = !!w : (G.checked = !!(Array.isArray(w) && ~w.indexOf(V)), G.value = V) : D === "radio" ? (G.checked = w === V, G.value = V) : ce === "select" && _t && (G.value = G.value || [], G.multiple = !0);
    }
    return G;
  }, [Ge, be, R.values]), ht = In(function() {
    return !$e(m.current, R.values);
  }, [m.current, R.values]), on = In(function() {
    return typeof l < "u" ? ht ? R.errors && Object.keys(R.errors).length === 0 : l !== !1 && Z(l) ? l(d) : l : R.errors && Object.keys(R.errors).length === 0;
  }, [l, ht, R.errors, d]), cn = j({}, R, {
    initialValues: m.current,
    initialErrors: _.current,
    initialTouched: T.current,
    initialStatus: I.current,
    handleBlur: Ge,
    handleChange: be,
    handleReset: it,
    handleSubmit: v,
    resetForm: oe,
    setErrors: Ze,
    setFormikState: tt,
    setFieldTouched: de,
    setFieldValue: fe,
    setFieldError: Pe,
    setStatus: nt,
    setSubmitting: rt,
    setTouched: ve,
    setValues: we,
    submitForm: Ye,
    validateForm: J,
    validateField: Qe,
    isValid: on,
    dirty: ht,
    unregisterField: dt,
    registerField: ft,
    getFieldProps: an,
    getFieldMeta: nn,
    getFieldHelpers: rn,
    validateOnBlur: i,
    validateOnChange: n,
    validateOnMount: c
  });
  return cn;
}
function Rd(e) {
  var t = yd(e), n = e.component, r = e.children, i = e.render, o = e.innerRef;
  return Vc(o, function() {
    return t;
  }), process.env.NODE_ENV !== "production" && ae(function() {
    e.render && (process.env.NODE_ENV !== "production" ? q(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : q());
  }, []), Me(pd, {
    value: t
  }, n ? Me(n, t) : i ? i(t) : r ? Z(r) ? r(t) : Ri(r) ? null : Jr.only(r) : null);
}
function Yr(e) {
  var t = e.htmlContent, n = e.documentationAnchorLink, r = e.handlerName;
  console.warn("Warning: Formik called `" + r + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + t + `
    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#` + n + `
  `);
}
function Cd(e) {
  var t = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return Ue(t, e.path, e.message);
    for (var i = e.inner, n = Array.isArray(i), r = 0, i = n ? i : i[Symbol.iterator](); ; ) {
      var o;
      if (n) {
        if (r >= i.length) break;
        o = i[r++];
      } else {
        if (r = i.next(), r.done) break;
        o = r.value;
      }
      var c = o;
      ie(t, c.path) || (t = Ue(t, c.path, c.message));
    }
  }
  return t;
}
function Nd(e, t, n, r) {
  n === void 0 && (n = !1);
  var i = Fn(e);
  return t[n ? "validateSync" : "validate"](i, {
    abortEarly: !1,
    context: i
  });
}
function Fn(e) {
  var t = Array.isArray(e) ? [] : {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      var r = String(n);
      Array.isArray(e[r]) === !0 ? t[r] = e[r].map(function(i) {
        return Array.isArray(i) === !0 || ar(i) ? Fn(i) : i !== "" ? i : void 0;
      }) : ar(e[r]) ? t[r] = Fn(e[r]) : t[r] = e[r] !== "" ? e[r] : void 0;
    }
  return t;
}
function Ld(e, t, n) {
  var r = e.slice();
  return t.forEach(function(o, c) {
    if (typeof r[c] > "u") {
      var l = n.clone !== !1, s = l && n.isMergeableObject(o);
      r[c] = s ? yn(Array.isArray(o) ? [] : {}, o, n) : o;
    } else n.isMergeableObject(o) ? r[c] = yn(e[c], o, n) : e.indexOf(o) === -1 && r.push(o);
  }), r;
}
function Fd(e) {
  return Array.from(e).filter(function(t) {
    return t.selected;
  }).map(function(t) {
    return t.value;
  });
}
function vd(e, t, n) {
  if (typeof e == "boolean")
    return !!t;
  var r = [], i = !1, o = -1;
  if (Array.isArray(e))
    r = e, o = e.indexOf(n), i = o >= 0;
  else if (!n || n == "true" || n == "false")
    return !!t;
  return t && n && !i ? r.concat(n) : i ? r.slice(0, o).concat(r.slice(o + 1)) : r;
}
var wd = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Jc : ae;
function ue(e) {
  var t = Re(e);
  return wd(function() {
    t.current = e;
  }), W(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current.apply(void 0, r);
  }, []);
}
function bd(e) {
  var t = Wn(), n = t.getFieldProps, r = t.getFieldMeta, i = t.getFieldHelpers, o = t.registerField, c = t.unregisterField, l = Ct(e), s = l ? e : {
    name: e
  }, f = s.name, h = s.validate;
  ae(function() {
    return f && o(f, {
      validate: h
    }), function() {
      f && c(f);
    };
  }, [o, c, f, h]), process.env.NODE_ENV !== "production" && (t || (process.env.NODE_ENV !== "production" ? q(!1, "useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component") : q())), f || (process.env.NODE_ENV !== "production" ? q(!1, "Invalid field name. Either pass `useField` a string or an object containing a `name` key.") : q());
  var O = In(function() {
    return i(f);
  }, [i, f]);
  return [n(s), r(f), O];
}
function Gd(e) {
  var t = e.validate, n = e.name, r = e.render, i = e.children, o = e.as, c = e.component, l = e.className, s = ot(e, ["validate", "name", "render", "children", "as", "component", "className"]), f = Wn(), h = ot(f, ["validate", "validationSchema"]);
  process.env.NODE_ENV !== "production" && ae(function() {
    r && (process.env.NODE_ENV !== "production" ? q(!1, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + n + '" render={({field, form}) => ...} /> with <Field name="' + n + '">{({field, form, meta}) => ...}</Field>') : q()), o && i && Z(i) && (process.env.NODE_ENV !== "production" ? q(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : q()), c && i && Z(i) && (process.env.NODE_ENV !== "production" ? q(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : q()), r && i && !Ri(i) && (process.env.NODE_ENV !== "production" ? q(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : q());
  }, []);
  var O = h.registerField, d = h.unregisterField;
  ae(function() {
    return O(n, {
      validate: t
    }), function() {
      d(n);
    };
  }, [O, d, n, t]);
  var m = h.getFieldProps(j({
    name: n
  }, s)), _ = h.getFieldMeta(n), T = {
    field: m,
    form: h
  };
  if (r)
    return r(j({}, T, {
      meta: _
    }));
  if (Z(i))
    return i(j({}, T, {
      meta: _
    }));
  if (c) {
    if (typeof c == "string") {
      var I = s.innerRef, E = ot(s, ["innerRef"]);
      return Me(c, j({
        ref: I
      }, m, E, {
        className: l
      }), i);
    }
    return Me(c, j({
      field: m,
      form: h
    }, s, {
      className: l
    }), i);
  }
  var S = o || "input";
  if (typeof S == "string") {
    var C = s.innerRef, P = ot(s, ["innerRef"]);
    return Me(S, j({
      ref: C
    }, m, P, {
      className: l
    }), i);
  }
  return Me(S, j({}, m, s, {
    className: l
  }), i);
}
var Yd = /* @__PURE__ */ Xc(function(e, t) {
  var n = e.action, r = ot(e, ["action"]), i = n ?? "#", o = Wn(), c = o.handleReset, l = o.handleSubmit;
  return Me("form", j({
    onSubmit: l,
    ref: t,
    onReset: c,
    action: i
  }, r));
});
Yd.displayName = "Form";
const Dd = "_notice_1lqkd_1", $d = "_padlock_1lqkd_10", Md = "_lightNoticeText_1lqkd_16", On = {
  notice: Dd,
  padlock: $d,
  lightNoticeText: Md
}, Kd = "data:image/svg+xml,%3csvg%20viewBox='0%200%2018%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.3334%208.99999C17.3334%204.39832%2013.6026%200.666656%209.00008%200.666656C4.39758%200.666656%200.666748%204.39832%200.666748%208.99999C0.666748%2013.6025%204.39758%2017.3333%209.00008%2017.3333C13.6026%2017.3333%2017.3334%2013.6025%2017.3334%208.99999ZM15.6667%208.99999C15.6667%2010.7681%2014.9644%2012.4638%2013.7141%2013.714C12.4639%2014.9643%2010.7682%2015.6667%209.00008%2015.6667C7.23197%2015.6667%205.53628%2014.9643%204.28604%2013.714C3.03579%2012.4638%202.33341%2010.7681%202.33341%208.99999C2.33341%207.23188%203.03579%205.53619%204.28604%204.28594C5.53628%203.0357%207.23197%202.33332%209.00008%202.33332C10.7682%202.33332%2012.4639%203.0357%2013.7141%204.28594C14.9644%205.53619%2015.6667%207.23188%2015.6667%208.99999ZM10.2501%205.24999C10.2501%204.91847%2010.1184%204.60053%209.88397%204.36611C9.64954%204.13169%209.3316%203.99999%209.00008%203.99999C8.66856%203.99999%208.35062%204.13169%208.1162%204.36611C7.88178%204.60053%207.75008%204.91847%207.75008%205.24999C7.75008%205.58151%207.88178%205.89945%208.1162%206.13387C8.35062%206.36829%208.66856%206.49999%209.00008%206.49999C9.3316%206.49999%209.64954%206.36829%209.88397%206.13387C10.1184%205.89945%2010.2501%205.58151%2010.2501%205.24999ZM8.16675%2013.2708C8.16508%2013.7567%208.44175%2014%208.99841%2014C9.55508%2014%209.83342%2013.7567%209.83342%2013.2708V8.89582C9.83342%208.40999%209.55425%208.16666%208.99675%208.16666C8.43925%208.16666%208.16258%208.40999%208.16675%208.89582V13.2708Z'%20fill='%23437089'/%3e%3c/svg%3e", Ud = "data:image/svg+xml,%3csvg%20viewBox='0%200%2014%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M2%206.50163L2.00167%204.83496C2%202.05579%203.66667%200.666626%207%200.666626C10.3333%200.666626%2012%202.05579%2012%204.83496V6.50163C13.1108%206.50163%2013.6667%207.05746%2013.6667%208.16829V15.6683C13.6667%2016.7791%2013.1108%2017.335%2012%2017.335H2.00167C0.889169%2017.335%200.333336%2016.7791%200.333336%2015.6683V8.19163C0.333336%207.06579%200.889169%206.50246%202%206.50246V6.50163ZM2%2015.6683H12V8.15329H2V15.6683ZM6.16667%2013.1683V10.6683C6.16667%2010.1125%206.44417%209.83496%207%209.83496C7.55584%209.83496%207.83334%2010.1125%207.83334%2010.6683V13.1683C7.83334%2013.7241%207.55584%2014.0016%207%2014.0016C6.44417%2014.0016%206.16667%2013.7241%206.16667%2013.1683ZM10.3358%206.50163C10.3358%204.00163%2010.3358%202.33496%207%202.33496C3.66417%202.33496%203.66667%204.00163%203.66667%206.50163H10.3358Z'%20fill='%23437089'/%3e%3c/svg%3e", kd = ({
  type: e,
  children: t
}) => /* @__PURE__ */ Q("div", { className: On.notice, children: [
  /* @__PURE__ */ b(
    "img",
    {
      className: On.padlock,
      src: e === "safety" ? Ud : Kd,
      width: "16",
      height: "auto",
      alt: ""
    }
  ),
  /* @__PURE__ */ b("p", { className: On.lightNoticeText, children: t })
] });
var gt = {}, Dr;
function Bd() {
  if (Dr) return gt;
  Dr = 1, Object.defineProperty(gt, "__esModule", { value: !0 }), gt.parse = c, gt.serialize = f;
  const e = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/, t = /^[\u0021-\u003A\u003C-\u007E]*$/, n = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, r = /^[\u0020-\u003A\u003D-\u007E]*$/, i = Object.prototype.toString, o = /* @__PURE__ */ (() => {
    const d = function() {
    };
    return d.prototype = /* @__PURE__ */ Object.create(null), d;
  })();
  function c(d, m) {
    const _ = new o(), T = d.length;
    if (T < 2)
      return _;
    const I = (m == null ? void 0 : m.decode) || h;
    let E = 0;
    do {
      const S = d.indexOf("=", E);
      if (S === -1)
        break;
      const C = d.indexOf(";", E), P = C === -1 ? T : C;
      if (S > P) {
        E = d.lastIndexOf(";", S - 1) + 1;
        continue;
      }
      const p = l(d, E, S), R = s(d, S, p), L = d.slice(p, R);
      if (_[L] === void 0) {
        let U = l(d, S + 1, P), Y = s(d, P, U);
        const H = I(d.slice(U, Y));
        _[L] = H;
      }
      E = P + 1;
    } while (E < T);
    return _;
  }
  function l(d, m, _) {
    do {
      const T = d.charCodeAt(m);
      if (T !== 32 && T !== 9)
        return m;
    } while (++m < _);
    return _;
  }
  function s(d, m, _) {
    for (; m > _; ) {
      const T = d.charCodeAt(--m);
      if (T !== 32 && T !== 9)
        return m + 1;
    }
    return _;
  }
  function f(d, m, _) {
    const T = (_ == null ? void 0 : _.encode) || encodeURIComponent;
    if (!e.test(d))
      throw new TypeError(`argument name is invalid: ${d}`);
    const I = T(m);
    if (!t.test(I))
      throw new TypeError(`argument val is invalid: ${m}`);
    let E = d + "=" + I;
    if (!_)
      return E;
    if (_.maxAge !== void 0) {
      if (!Number.isInteger(_.maxAge))
        throw new TypeError(`option maxAge is invalid: ${_.maxAge}`);
      E += "; Max-Age=" + _.maxAge;
    }
    if (_.domain) {
      if (!n.test(_.domain))
        throw new TypeError(`option domain is invalid: ${_.domain}`);
      E += "; Domain=" + _.domain;
    }
    if (_.path) {
      if (!r.test(_.path))
        throw new TypeError(`option path is invalid: ${_.path}`);
      E += "; Path=" + _.path;
    }
    if (_.expires) {
      if (!O(_.expires) || !Number.isFinite(_.expires.valueOf()))
        throw new TypeError(`option expires is invalid: ${_.expires}`);
      E += "; Expires=" + _.expires.toUTCString();
    }
    if (_.httpOnly && (E += "; HttpOnly"), _.secure && (E += "; Secure"), _.partitioned && (E += "; Partitioned"), _.priority)
      switch (typeof _.priority == "string" ? _.priority.toLowerCase() : void 0) {
        case "low":
          E += "; Priority=Low";
          break;
        case "medium":
          E += "; Priority=Medium";
          break;
        case "high":
          E += "; Priority=High";
          break;
        default:
          throw new TypeError(`option priority is invalid: ${_.priority}`);
      }
    if (_.sameSite)
      switch (typeof _.sameSite == "string" ? _.sameSite.toLowerCase() : _.sameSite) {
        case !0:
        case "strict":
          E += "; SameSite=Strict";
          break;
        case "lax":
          E += "; SameSite=Lax";
          break;
        case "none":
          E += "; SameSite=None";
          break;
        default:
          throw new TypeError(`option sameSite is invalid: ${_.sameSite}`);
      }
    return E;
  }
  function h(d) {
    if (d.indexOf("%") === -1)
      return d;
    try {
      return decodeURIComponent(d);
    } catch {
      return d;
    }
  }
  function O(d) {
    return i.call(d) === "[object Date]";
  }
  return gt;
}
Bd();
/**
 * react-router v7.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function X(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function Se(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function vn({
  pathname: e = "/",
  search: t = "",
  hash: n = ""
}) {
  return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), n && n !== "#" && (e += n.charAt(0) === "#" ? n : "#" + n), e;
}
function Vn(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substring(n), e = e.substring(0, n));
    let r = e.indexOf("?");
    r >= 0 && (t.search = e.substring(r), e = e.substring(0, r)), e && (t.pathname = e);
  }
  return t;
}
function Ni(e, t, n = "/") {
  return jd(e, t, n, !1);
}
function jd(e, t, n, r) {
  let i = typeof t == "string" ? Vn(t) : t, o = Le(i.pathname || "/", n);
  if (o == null)
    return null;
  let c = Li(e);
  Wd(c);
  let l = null;
  for (let s = 0; l == null && s < c.length; ++s) {
    let f = th(o);
    l = xd(
      c[s],
      f,
      r
    );
  }
  return l;
}
function Li(e, t = [], n = [], r = "") {
  let i = (o, c, l) => {
    let s = {
      relativePath: l === void 0 ? o.path || "" : l,
      caseSensitive: o.caseSensitive === !0,
      childrenIndex: c,
      route: o
    };
    s.relativePath.startsWith("/") && (X(
      s.relativePath.startsWith(r),
      `Absolute route path "${s.relativePath}" nested under path "${r}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`
    ), s.relativePath = s.relativePath.slice(r.length));
    let f = Oe([r, s.relativePath]), h = n.concat(s);
    o.children && o.children.length > 0 && (X(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      o.index !== !0,
      `Index routes must not have child routes. Please remove all child routes from route path "${f}".`
    ), Li(o.children, t, h, f)), !(o.path == null && !o.index) && t.push({
      path: f,
      score: Qd(f, o.index),
      routesMeta: h
    });
  };
  return e.forEach((o, c) => {
    var l;
    if (o.path === "" || !((l = o.path) != null && l.includes("?")))
      i(o, c);
    else
      for (let s of Fi(o.path))
        i(o, c, s);
  }), t;
}
function Fi(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [n, ...r] = t, i = n.endsWith("?"), o = n.replace(/\?$/, "");
  if (r.length === 0)
    return i ? [o, ""] : [o];
  let c = Fi(r.join("/")), l = [];
  return l.push(
    ...c.map(
      (s) => s === "" ? o : [o, s].join("/")
    )
  ), i && l.push(...c), l.map(
    (s) => e.startsWith("/") && s === "" ? "/" : s
  );
}
function Wd(e) {
  e.sort(
    (t, n) => t.score !== n.score ? n.score - t.score : Zd(
      t.routesMeta.map((r) => r.childrenIndex),
      n.routesMeta.map((r) => r.childrenIndex)
    )
  );
}
var Vd = /^:[\w-]+$/, qd = 3, Hd = 2, Jd = 1, Xd = 10, zd = -2, $r = (e) => e === "*";
function Qd(e, t) {
  let n = e.split("/"), r = n.length;
  return n.some($r) && (r += zd), t && (r += Hd), n.filter((i) => !$r(i)).reduce(
    (i, o) => i + (Vd.test(o) ? qd : o === "" ? Jd : Xd),
    r
  );
}
function Zd(e, t) {
  return e.length === t.length && e.slice(0, -1).every((r, i) => r === t[i]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function xd(e, t, n = !1) {
  let { routesMeta: r } = e, i = {}, o = "/", c = [];
  for (let l = 0; l < r.length; ++l) {
    let s = r[l], f = l === r.length - 1, h = o === "/" ? t : t.slice(o.length) || "/", O = Vt(
      { path: s.relativePath, caseSensitive: s.caseSensitive, end: f },
      h
    ), d = s.route;
    if (!O && f && n && !r[r.length - 1].route.index && (O = Vt(
      {
        path: s.relativePath,
        caseSensitive: s.caseSensitive,
        end: !1
      },
      h
    )), !O)
      return null;
    Object.assign(i, O.params), c.push({
      // TODO: Can this as be avoided?
      params: i,
      pathname: Oe([o, O.pathname]),
      pathnameBase: ah(
        Oe([o, O.pathnameBase])
      ),
      route: d
    }), O.pathnameBase !== "/" && (o = Oe([o, O.pathnameBase]));
  }
  return c;
}
function Vt(e, t) {
  typeof e == "string" && (e = { path: e, caseSensitive: !1, end: !0 });
  let [n, r] = eh(
    e.path,
    e.caseSensitive,
    e.end
  ), i = t.match(n);
  if (!i) return null;
  let o = i[0], c = o.replace(/(.)\/+$/, "$1"), l = i.slice(1);
  return {
    params: r.reduce(
      (f, { paramName: h, isOptional: O }, d) => {
        if (h === "*") {
          let _ = l[d] || "";
          c = o.slice(0, o.length - _.length).replace(/(.)\/+$/, "$1");
        }
        const m = l[d];
        return O && !m ? f[h] = void 0 : f[h] = (m || "").replace(/%2F/g, "/"), f;
      },
      {}
    ),
    pathname: o,
    pathnameBase: c,
    pattern: e
  };
}
function eh(e, t = !1, n = !0) {
  Se(
    e === "*" || !e.endsWith("*") || e.endsWith("/*"),
    `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`
  );
  let r = [], i = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(
    /\/:([\w-]+)(\?)?/g,
    (c, l, s) => (r.push({ paramName: l, isOptional: s != null }), s ? "/?([^\\/]+)?" : "/([^\\/]+)")
  );
  return e.endsWith("*") ? (r.push({ paramName: "*" }), i += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? i += "\\/*$" : e !== "" && e !== "/" && (i += "(?:(?=\\/|$))"), [new RegExp(i, t ? void 0 : "i"), r];
}
function th(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return Se(
      !1,
      `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`
    ), e;
  }
}
function Le(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, r = e.charAt(n);
  return r && r !== "/" ? null : e.slice(n) || "/";
}
function nh(e, t = "/") {
  let {
    pathname: n,
    search: r = "",
    hash: i = ""
  } = typeof e == "string" ? Vn(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : rh(n, t) : t,
    search: oh(r),
    hash: ch(i)
  };
}
function rh(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((i) => {
    i === ".." ? n.length > 1 && n.pop() : i !== "." && n.push(i);
  }), n.length > 1 ? n.join("/") : "/";
}
function Sn(e, t, n, r) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(
    r
  )}].  Please separate it out to the \`to.${n}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function ih(e) {
  return e.filter(
    (t, n) => n === 0 || t.route.path && t.route.path.length > 0
  );
}
function vi(e) {
  let t = ih(e);
  return t.map(
    (n, r) => r === t.length - 1 ? n.pathname : n.pathnameBase
  );
}
function wi(e, t, n, r = !1) {
  let i;
  typeof e == "string" ? i = Vn(e) : (i = { ...e }, X(
    !i.pathname || !i.pathname.includes("?"),
    Sn("?", "pathname", "search", i)
  ), X(
    !i.pathname || !i.pathname.includes("#"),
    Sn("#", "pathname", "hash", i)
  ), X(
    !i.search || !i.search.includes("#"),
    Sn("#", "search", "hash", i)
  ));
  let o = e === "" || i.pathname === "", c = o ? "/" : i.pathname, l;
  if (c == null)
    l = n;
  else {
    let O = t.length - 1;
    if (!r && c.startsWith("..")) {
      let d = c.split("/");
      for (; d[0] === ".."; )
        d.shift(), O -= 1;
      i.pathname = d.join("/");
    }
    l = O >= 0 ? t[O] : "/";
  }
  let s = nh(i, l), f = c && c !== "/" && c.endsWith("/"), h = (o || c === ".") && n.endsWith("/");
  return !s.pathname.endsWith("/") && (f || h) && (s.pathname += "/"), s;
}
var Oe = (e) => e.join("/").replace(/\/\/+/g, "/"), ah = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), oh = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, ch = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function uh(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
var bi = [
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
];
new Set(
  bi
);
var sh = [
  "GET",
  ...bi
];
new Set(sh);
var lt = y.createContext(null);
lt.displayName = "DataRouter";
var xt = y.createContext(null);
xt.displayName = "DataRouterState";
var Gi = y.createContext({
  isTransitioning: !1
});
Gi.displayName = "ViewTransition";
var lh = y.createContext(
  /* @__PURE__ */ new Map()
);
lh.displayName = "Fetchers";
var fh = y.createContext(null);
fh.displayName = "Await";
var pe = y.createContext(
  null
);
pe.displayName = "Navigation";
var qn = y.createContext(
  null
);
qn.displayName = "Location";
var Te = y.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
Te.displayName = "Route";
var Hn = y.createContext(null);
Hn.displayName = "RouteError";
function dh(e, { relative: t } = {}) {
  X(
    en(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let { basename: n, navigator: r } = y.useContext(pe), { hash: i, pathname: o, search: c } = Nt(e, { relative: t }), l = o;
  return n !== "/" && (l = o === "/" ? n : Oe([n, o])), r.createHref({ pathname: l, search: c, hash: i });
}
function en() {
  return y.useContext(qn) != null;
}
function Xe() {
  return X(
    en(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), y.useContext(qn).location;
}
var Yi = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function Di(e) {
  y.useContext(pe).static || y.useLayoutEffect(e);
}
function hh() {
  let { isDataRoute: e } = y.useContext(Te);
  return e ? Rh() : _h();
}
function _h() {
  X(
    en(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let e = y.useContext(lt), { basename: t, navigator: n } = y.useContext(pe), { matches: r } = y.useContext(Te), { pathname: i } = Xe(), o = JSON.stringify(vi(r)), c = y.useRef(!1);
  return Di(() => {
    c.current = !0;
  }), y.useCallback(
    (s, f = {}) => {
      if (Se(c.current, Yi), !c.current) return;
      if (typeof s == "number") {
        n.go(s);
        return;
      }
      let h = wi(
        s,
        JSON.parse(o),
        i,
        f.relative === "path"
      );
      e == null && t !== "/" && (h.pathname = h.pathname === "/" ? t : Oe([t, h.pathname])), (f.replace ? n.replace : n.push)(
        h,
        f.state,
        f
      );
    },
    [
      t,
      n,
      o,
      i,
      e
    ]
  );
}
y.createContext(null);
function Nt(e, { relative: t } = {}) {
  let { matches: n } = y.useContext(Te), { pathname: r } = Xe(), i = JSON.stringify(vi(n));
  return y.useMemo(
    () => wi(
      e,
      JSON.parse(i),
      r,
      t === "path"
    ),
    [e, i, r, t]
  );
}
function Eh(e, t, n, r) {
  X(
    en(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let { navigator: i, static: o } = y.useContext(pe), { matches: c } = y.useContext(Te), l = c[c.length - 1], s = l ? l.params : {}, f = l ? l.pathname : "/", h = l ? l.pathnameBase : "/", O = l && l.route;
  {
    let S = O && O.path || "";
    $i(
      f,
      !O || S.endsWith("*") || S.endsWith("*?"),
      `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${f}" (under <Route path="${S}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${S}"> to <Route path="${S === "/" ? "*" : `${S}/*`}">.`
    );
  }
  let d = Xe(), m;
  m = d;
  let _ = m.pathname || "/", T = _;
  if (h !== "/") {
    let S = h.replace(/^\//, "").split("/");
    T = "/" + _.replace(/^\//, "").split("/").slice(S.length).join("/");
  }
  let I = !o && n && n.matches && n.matches.length > 0 ? n.matches : Ni(e, { pathname: T });
  return Se(
    O || I != null,
    `No routes matched location "${m.pathname}${m.search}${m.hash}" `
  ), Se(
    I == null || I[I.length - 1].route.element !== void 0 || I[I.length - 1].route.Component !== void 0 || I[I.length - 1].route.lazy !== void 0,
    `Matched leaf route at location "${m.pathname}${m.search}${m.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`
  ), Ah(
    I && I.map(
      (S) => Object.assign({}, S, {
        params: Object.assign({}, s, S.params),
        pathname: Oe([
          h,
          // Re-encode pathnames that were decoded inside matchRoutes
          i.encodeLocation ? i.encodeLocation(S.pathname).pathname : S.pathname
        ]),
        pathnameBase: S.pathnameBase === "/" ? h : Oe([
          h,
          // Re-encode pathnames that were decoded inside matchRoutes
          i.encodeLocation ? i.encodeLocation(S.pathnameBase).pathname : S.pathnameBase
        ])
      })
    ),
    c,
    n,
    r
  );
}
function mh() {
  let e = yh(), t = uh(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), n = e instanceof Error ? e.stack : null, r = "rgba(200,200,200, 0.5)", i = { padding: "0.5rem", backgroundColor: r }, o = { padding: "2px 4px", backgroundColor: r }, c = null;
  return console.error(
    "Error handled by React Router default ErrorBoundary:",
    e
  ), c = /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ y.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ y.createElement("code", { style: o }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ y.createElement("code", { style: o }, "errorElement"), " prop on your route.")), /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ y.createElement("h3", { style: { fontStyle: "italic" } }, t), n ? /* @__PURE__ */ y.createElement("pre", { style: i }, n) : null, c);
}
var gh = /* @__PURE__ */ y.createElement(mh, null), Oh = class extends y.Component {
  constructor(e) {
    super(e), this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  static getDerivedStateFromProps(e, t) {
    return t.location !== e.location || t.revalidation !== "idle" && e.revalidation === "idle" ? {
      error: e.error,
      location: e.location,
      revalidation: e.revalidation
    } : {
      error: e.error !== void 0 ? e.error : t.error,
      location: t.location,
      revalidation: e.revalidation || t.revalidation
    };
  }
  componentDidCatch(e, t) {
    console.error(
      "React Router caught the following error during render",
      e,
      t
    );
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ y.createElement(Te.Provider, { value: this.props.routeContext }, /* @__PURE__ */ y.createElement(
      Hn.Provider,
      {
        value: this.state.error,
        children: this.props.component
      }
    )) : this.props.children;
  }
};
function Sh({ routeContext: e, match: t, children: n }) {
  let r = y.useContext(lt);
  return r && r.static && r.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (r.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ y.createElement(Te.Provider, { value: e }, n);
}
function Ah(e, t = [], n = null, r = null) {
  if (e == null) {
    if (!n)
      return null;
    if (n.errors)
      e = n.matches;
    else if (t.length === 0 && !n.initialized && n.matches.length > 0)
      e = n.matches;
    else
      return null;
  }
  let i = e, o = n == null ? void 0 : n.errors;
  if (o != null) {
    let s = i.findIndex(
      (f) => f.route.id && (o == null ? void 0 : o[f.route.id]) !== void 0
    );
    X(
      s >= 0,
      `Could not find a matching route for errors on route IDs: ${Object.keys(
        o
      ).join(",")}`
    ), i = i.slice(
      0,
      Math.min(i.length, s + 1)
    );
  }
  let c = !1, l = -1;
  if (n)
    for (let s = 0; s < i.length; s++) {
      let f = i[s];
      if ((f.route.HydrateFallback || f.route.hydrateFallbackElement) && (l = s), f.route.id) {
        let { loaderData: h, errors: O } = n, d = f.route.loader && !h.hasOwnProperty(f.route.id) && (!O || O[f.route.id] === void 0);
        if (f.route.lazy || d) {
          c = !0, l >= 0 ? i = i.slice(0, l + 1) : i = [i[0]];
          break;
        }
      }
    }
  return i.reduceRight((s, f, h) => {
    let O, d = !1, m = null, _ = null;
    n && (O = o && f.route.id ? o[f.route.id] : void 0, m = f.route.errorElement || gh, c && (l < 0 && h === 0 ? ($i(
      "route-fallback",
      !1,
      "No `HydrateFallback` element provided to render during initial hydration"
    ), d = !0, _ = null) : l === h && (d = !0, _ = f.route.hydrateFallbackElement || null)));
    let T = t.concat(i.slice(0, h + 1)), I = () => {
      let E;
      return O ? E = m : d ? E = _ : f.route.Component ? E = /* @__PURE__ */ y.createElement(f.route.Component, null) : f.route.element ? E = f.route.element : E = s, /* @__PURE__ */ y.createElement(
        Sh,
        {
          match: f,
          routeContext: {
            outlet: s,
            matches: T,
            isDataRoute: n != null
          },
          children: E
        }
      );
    };
    return n && (f.route.ErrorBoundary || f.route.errorElement || h === 0) ? /* @__PURE__ */ y.createElement(
      Oh,
      {
        location: n.location,
        revalidation: n.revalidation,
        component: m,
        error: O,
        children: I(),
        routeContext: { outlet: null, matches: T, isDataRoute: !0 }
      }
    ) : I();
  }, null);
}
function Jn(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function ph(e) {
  let t = y.useContext(lt);
  return X(t, Jn(e)), t;
}
function Th(e) {
  let t = y.useContext(xt);
  return X(t, Jn(e)), t;
}
function Ph(e) {
  let t = y.useContext(Te);
  return X(t, Jn(e)), t;
}
function Xn(e) {
  let t = Ph(e), n = t.matches[t.matches.length - 1];
  return X(
    n.route.id,
    `${e} can only be used on routes that contain a unique "id"`
  ), n.route.id;
}
function Ih() {
  return Xn(
    "useRouteId"
    /* UseRouteId */
  );
}
function yh() {
  var r;
  let e = y.useContext(Hn), t = Th(
    "useRouteError"
    /* UseRouteError */
  ), n = Xn(
    "useRouteError"
    /* UseRouteError */
  );
  return e !== void 0 ? e : (r = t.errors) == null ? void 0 : r[n];
}
function Rh() {
  let { router: e } = ph(
    "useNavigate"
    /* UseNavigateStable */
  ), t = Xn(
    "useNavigate"
    /* UseNavigateStable */
  ), n = y.useRef(!1);
  return Di(() => {
    n.current = !0;
  }), y.useCallback(
    async (i, o = {}) => {
      Se(n.current, Yi), n.current && (typeof i == "number" ? e.navigate(i) : await e.navigate(i, { fromRouteId: t, ...o }));
    },
    [e, t]
  );
}
var Mr = {};
function $i(e, t, n) {
  !t && !Mr[e] && (Mr[e] = !0, Se(!1, n));
}
y.memo(Ch);
function Ch({
  routes: e,
  future: t,
  state: n
}) {
  return Eh(e, void 0, n, t);
}
var $t = "get", Mt = "application/x-www-form-urlencoded";
function tn(e) {
  return e != null && typeof e.tagName == "string";
}
function Nh(e) {
  return tn(e) && e.tagName.toLowerCase() === "button";
}
function Lh(e) {
  return tn(e) && e.tagName.toLowerCase() === "form";
}
function Fh(e) {
  return tn(e) && e.tagName.toLowerCase() === "input";
}
function vh(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function wh(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !vh(e);
}
var bt = null;
function bh() {
  if (bt === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), bt = !1;
    } catch {
      bt = !0;
    }
  return bt;
}
var Gh = /* @__PURE__ */ new Set([
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "text/plain"
]);
function An(e) {
  return e != null && !Gh.has(e) ? (Se(
    !1,
    `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${Mt}"`
  ), null) : e;
}
function Yh(e, t) {
  let n, r, i, o, c;
  if (Lh(e)) {
    let l = e.getAttribute("action");
    r = l ? Le(l, t) : null, n = e.getAttribute("method") || $t, i = An(e.getAttribute("enctype")) || Mt, o = new FormData(e);
  } else if (Nh(e) || Fh(e) && (e.type === "submit" || e.type === "image")) {
    let l = e.form;
    if (l == null)
      throw new Error(
        'Cannot submit a <button> or <input type="submit"> without a <form>'
      );
    let s = e.getAttribute("formaction") || l.getAttribute("action");
    if (r = s ? Le(s, t) : null, n = e.getAttribute("formmethod") || l.getAttribute("method") || $t, i = An(e.getAttribute("formenctype")) || An(l.getAttribute("enctype")) || Mt, o = new FormData(l, e), !bh()) {
      let { name: f, type: h, value: O } = e;
      if (h === "image") {
        let d = f ? `${f}.` : "";
        o.append(`${d}x`, "0"), o.append(`${d}y`, "0");
      } else f && o.append(f, O);
    }
  } else {
    if (tn(e))
      throw new Error(
        'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
      );
    n = $t, r = null, i = Mt, c = e;
  }
  return o && i === "text/plain" && (c = o, o = void 0), { action: r, method: n.toLowerCase(), encType: i, formData: o, body: c };
}
function zn(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
async function Dh(e, t) {
  if (e.id in t)
    return t[e.id];
  try {
    let n = await import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      e.module
    );
    return t[e.id] = n, n;
  } catch (n) {
    return console.error(
      `Error loading route module \`${e.module}\`, reloading page...`
    ), console.error(n), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
    });
  }
}
function $h(e) {
  return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
async function Mh(e, t, n) {
  let r = await Promise.all(
    e.map(async (i) => {
      let o = t.routes[i.route.id];
      if (o) {
        let c = await Dh(o, n);
        return c.links ? c.links() : [];
      }
      return [];
    })
  );
  return Bh(
    r.flat(1).filter($h).filter((i) => i.rel === "stylesheet" || i.rel === "preload").map(
      (i) => i.rel === "stylesheet" ? { ...i, rel: "prefetch", as: "style" } : { ...i, rel: "prefetch" }
    )
  );
}
function Kr(e, t, n, r, i, o) {
  let c = (s, f) => n[f] ? s.route.id !== n[f].route.id : !0, l = (s, f) => {
    var h;
    return (
      // param change, /users/123 -> /users/456
      n[f].pathname !== s.pathname || // splat param changed, which is not present in match.path
      // e.g. /files/images/avatar.jpg -> files/finances.xls
      ((h = n[f].route.path) == null ? void 0 : h.endsWith("*")) && n[f].params["*"] !== s.params["*"]
    );
  };
  return o === "assets" ? t.filter(
    (s, f) => c(s, f) || l(s, f)
  ) : o === "data" ? t.filter((s, f) => {
    var O;
    let h = r.routes[s.route.id];
    if (!h || !h.hasLoader)
      return !1;
    if (c(s, f) || l(s, f))
      return !0;
    if (s.route.shouldRevalidate) {
      let d = s.route.shouldRevalidate({
        currentUrl: new URL(
          i.pathname + i.search + i.hash,
          window.origin
        ),
        currentParams: ((O = n[0]) == null ? void 0 : O.params) || {},
        nextUrl: new URL(e, window.origin),
        nextParams: s.params,
        defaultShouldRevalidate: !0
      });
      if (typeof d == "boolean")
        return d;
    }
    return !0;
  }) : [];
}
function Kh(e, t, { includeHydrateFallback: n } = {}) {
  return Uh(
    e.map((r) => {
      let i = t.routes[r.route.id];
      if (!i) return [];
      let o = [i.module];
      return i.clientActionModule && (o = o.concat(i.clientActionModule)), i.clientLoaderModule && (o = o.concat(i.clientLoaderModule)), n && i.hydrateFallbackModule && (o = o.concat(i.hydrateFallbackModule)), i.imports && (o = o.concat(i.imports)), o;
    }).flat(1)
  );
}
function Uh(e) {
  return [...new Set(e)];
}
function kh(e) {
  let t = {}, n = Object.keys(e).sort();
  for (let r of n)
    t[r] = e[r];
  return t;
}
function Bh(e, t) {
  let n = /* @__PURE__ */ new Set();
  return new Set(t), e.reduce((r, i) => {
    let o = JSON.stringify(kh(i));
    return n.has(o) || (n.add(o), r.push({ key: o, link: i })), r;
  }, []);
}
function jh(e, t) {
  let n = typeof e == "string" ? new URL(
    e,
    // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window > "u" ? "server://singlefetch/" : window.location.origin
  ) : e;
  return n.pathname === "/" ? n.pathname = "_root.data" : t && Le(n.pathname, t) === "/" ? n.pathname = `${t.replace(/\/$/, "")}/_root.data` : n.pathname = `${n.pathname.replace(/\/$/, "")}.data`, n;
}
function Mi() {
  let e = y.useContext(lt);
  return zn(
    e,
    "You must render this element inside a <DataRouterContext.Provider> element"
  ), e;
}
function Wh() {
  let e = y.useContext(xt);
  return zn(
    e,
    "You must render this element inside a <DataRouterStateContext.Provider> element"
  ), e;
}
var Qn = y.createContext(void 0);
Qn.displayName = "FrameworkContext";
function Ki() {
  let e = y.useContext(Qn);
  return zn(
    e,
    "You must render this element inside a <HydratedRouter> element"
  ), e;
}
function Vh(e, t) {
  let n = y.useContext(Qn), [r, i] = y.useState(!1), [o, c] = y.useState(!1), { onFocus: l, onBlur: s, onMouseEnter: f, onMouseLeave: h, onTouchStart: O } = t, d = y.useRef(null);
  y.useEffect(() => {
    if (e === "render" && c(!0), e === "viewport") {
      let T = (E) => {
        E.forEach((S) => {
          c(S.isIntersecting);
        });
      }, I = new IntersectionObserver(T, { threshold: 0.5 });
      return d.current && I.observe(d.current), () => {
        I.disconnect();
      };
    }
  }, [e]), y.useEffect(() => {
    if (r) {
      let T = setTimeout(() => {
        c(!0);
      }, 100);
      return () => {
        clearTimeout(T);
      };
    }
  }, [r]);
  let m = () => {
    i(!0);
  }, _ = () => {
    i(!1), c(!1);
  };
  return n ? e !== "intent" ? [o, d, {}] : [
    o,
    d,
    {
      onFocus: Ot(l, m),
      onBlur: Ot(s, _),
      onMouseEnter: Ot(f, m),
      onMouseLeave: Ot(h, _),
      onTouchStart: Ot(O, m)
    }
  ] : [!1, d, {}];
}
function Ot(e, t) {
  return (n) => {
    e && e(n), n.defaultPrevented || t(n);
  };
}
function qh({
  page: e,
  ...t
}) {
  let { router: n } = Mi(), r = y.useMemo(
    () => Ni(n.routes, e, n.basename),
    [n.routes, e, n.basename]
  );
  return r ? /* @__PURE__ */ y.createElement(Jh, { page: e, matches: r, ...t }) : null;
}
function Hh(e) {
  let { manifest: t, routeModules: n } = Ki(), [r, i] = y.useState([]);
  return y.useEffect(() => {
    let o = !1;
    return Mh(e, t, n).then(
      (c) => {
        o || i(c);
      }
    ), () => {
      o = !0;
    };
  }, [e, t, n]), r;
}
function Jh({
  page: e,
  matches: t,
  ...n
}) {
  let r = Xe(), { manifest: i, routeModules: o } = Ki(), { basename: c } = Mi(), { loaderData: l, matches: s } = Wh(), f = y.useMemo(
    () => Kr(
      e,
      t,
      s,
      i,
      r,
      "data"
    ),
    [e, t, s, i, r]
  ), h = y.useMemo(
    () => Kr(
      e,
      t,
      s,
      i,
      r,
      "assets"
    ),
    [e, t, s, i, r]
  ), O = y.useMemo(() => {
    if (e === r.pathname + r.search + r.hash)
      return [];
    let _ = /* @__PURE__ */ new Set(), T = !1;
    if (t.forEach((E) => {
      var C;
      let S = i.routes[E.route.id];
      !S || !S.hasLoader || (!f.some((P) => P.route.id === E.route.id) && E.route.id in l && ((C = o[E.route.id]) != null && C.shouldRevalidate) || S.hasClientLoader ? T = !0 : _.add(E.route.id));
    }), _.size === 0)
      return [];
    let I = jh(e, c);
    return T && _.size > 0 && I.searchParams.set(
      "_routes",
      t.filter((E) => _.has(E.route.id)).map((E) => E.route.id).join(",")
    ), [I.pathname + I.search];
  }, [
    c,
    l,
    r,
    i,
    f,
    t,
    e,
    o
  ]), d = y.useMemo(
    () => Kh(h, i),
    [h, i]
  ), m = Hh(h);
  return /* @__PURE__ */ y.createElement(y.Fragment, null, O.map((_) => /* @__PURE__ */ y.createElement("link", { key: _, rel: "prefetch", as: "fetch", href: _, ...n })), d.map((_) => /* @__PURE__ */ y.createElement("link", { key: _, rel: "modulepreload", href: _, ...n })), m.map(({ key: _, link: T }) => (
    // these don't spread `linkProps` because they are full link descriptors
    // already with their own props
    /* @__PURE__ */ y.createElement("link", { key: _, ...T })
  )));
}
function Xh(...e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
var Ui = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
try {
  Ui && (window.__reactRouterVersion = "7.5.0");
} catch {
}
var ki = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Zn = y.forwardRef(
  function({
    onClick: t,
    discover: n = "render",
    prefetch: r = "none",
    relative: i,
    reloadDocument: o,
    replace: c,
    state: l,
    target: s,
    to: f,
    preventScrollReset: h,
    viewTransition: O,
    ...d
  }, m) {
    let { basename: _ } = y.useContext(pe), T = typeof f == "string" && ki.test(f), I, E = !1;
    if (typeof f == "string" && T && (I = f, Ui))
      try {
        let Y = new URL(window.location.href), H = f.startsWith("//") ? new URL(Y.protocol + f) : new URL(f), K = Le(H.pathname, _);
        H.origin === Y.origin && K != null ? f = K + H.search + H.hash : E = !0;
      } catch {
        Se(
          !1,
          `<Link to="${f}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`
        );
      }
    let S = dh(f, { relative: i }), [C, P, p] = Vh(
      r,
      d
    ), R = xh(f, {
      replace: c,
      state: l,
      target: s,
      preventScrollReset: h,
      relative: i,
      viewTransition: O
    });
    function L(Y) {
      t && t(Y), Y.defaultPrevented || R(Y);
    }
    let U = (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      /* @__PURE__ */ y.createElement(
        "a",
        {
          ...d,
          ...p,
          href: I || S,
          onClick: E || o ? t : L,
          ref: Xh(m, P),
          target: s,
          "data-discover": !T && n === "render" ? "true" : void 0
        }
      )
    );
    return C && !T ? /* @__PURE__ */ y.createElement(y.Fragment, null, U, /* @__PURE__ */ y.createElement(qh, { page: S })) : U;
  }
);
Zn.displayName = "Link";
var zh = y.forwardRef(
  function({
    "aria-current": t = "page",
    caseSensitive: n = !1,
    className: r = "",
    end: i = !1,
    style: o,
    to: c,
    viewTransition: l,
    children: s,
    ...f
  }, h) {
    let O = Nt(c, { relative: f.relative }), d = Xe(), m = y.useContext(xt), { navigator: _, basename: T } = y.useContext(pe), I = m != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    i_(O) && l === !0, E = _.encodeLocation ? _.encodeLocation(O).pathname : O.pathname, S = d.pathname, C = m && m.navigation && m.navigation.location ? m.navigation.location.pathname : null;
    n || (S = S.toLowerCase(), C = C ? C.toLowerCase() : null, E = E.toLowerCase()), C && T && (C = Le(C, T) || C);
    const P = E !== "/" && E.endsWith("/") ? E.length - 1 : E.length;
    let p = S === E || !i && S.startsWith(E) && S.charAt(P) === "/", R = C != null && (C === E || !i && C.startsWith(E) && C.charAt(E.length) === "/"), L = {
      isActive: p,
      isPending: R,
      isTransitioning: I
    }, U = p ? t : void 0, Y;
    typeof r == "function" ? Y = r(L) : Y = [
      r,
      p ? "active" : null,
      R ? "pending" : null,
      I ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let H = typeof o == "function" ? o(L) : o;
    return /* @__PURE__ */ y.createElement(
      Zn,
      {
        ...f,
        "aria-current": U,
        className: Y,
        ref: h,
        style: H,
        to: c,
        viewTransition: l
      },
      typeof s == "function" ? s(L) : s
    );
  }
);
zh.displayName = "NavLink";
var Qh = y.forwardRef(
  ({
    discover: e = "render",
    fetcherKey: t,
    navigate: n,
    reloadDocument: r,
    replace: i,
    state: o,
    method: c = $t,
    action: l,
    onSubmit: s,
    relative: f,
    preventScrollReset: h,
    viewTransition: O,
    ...d
  }, m) => {
    let _ = n_(), T = r_(l, { relative: f }), I = c.toLowerCase() === "get" ? "get" : "post", E = typeof l == "string" && ki.test(l), S = (C) => {
      if (s && s(C), C.defaultPrevented) return;
      C.preventDefault();
      let P = C.nativeEvent.submitter, p = (P == null ? void 0 : P.getAttribute("formmethod")) || c;
      _(P || C.currentTarget, {
        fetcherKey: t,
        method: p,
        navigate: n,
        replace: i,
        state: o,
        relative: f,
        preventScrollReset: h,
        viewTransition: O
      });
    };
    return /* @__PURE__ */ y.createElement(
      "form",
      {
        ref: m,
        method: I,
        action: T,
        onSubmit: r ? s : S,
        ...d,
        "data-discover": !E && e === "render" ? "true" : void 0
      }
    );
  }
);
Qh.displayName = "Form";
function Zh(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function Bi(e) {
  let t = y.useContext(lt);
  return X(t, Zh(e)), t;
}
function xh(e, {
  target: t,
  replace: n,
  state: r,
  preventScrollReset: i,
  relative: o,
  viewTransition: c
} = {}) {
  let l = hh(), s = Xe(), f = Nt(e, { relative: o });
  return y.useCallback(
    (h) => {
      if (wh(h, t)) {
        h.preventDefault();
        let O = n !== void 0 ? n : vn(s) === vn(f);
        l(e, {
          replace: O,
          state: r,
          preventScrollReset: i,
          relative: o,
          viewTransition: c
        });
      }
    },
    [
      s,
      l,
      f,
      n,
      r,
      t,
      e,
      i,
      o,
      c
    ]
  );
}
var e_ = 0, t_ = () => `__${String(++e_)}__`;
function n_() {
  let { router: e } = Bi(
    "useSubmit"
    /* UseSubmit */
  ), { basename: t } = y.useContext(pe), n = Ih();
  return y.useCallback(
    async (r, i = {}) => {
      let { action: o, method: c, encType: l, formData: s, body: f } = Yh(
        r,
        t
      );
      if (i.navigate === !1) {
        let h = i.fetcherKey || t_();
        await e.fetch(h, n, i.action || o, {
          preventScrollReset: i.preventScrollReset,
          formData: s,
          body: f,
          formMethod: i.method || c,
          formEncType: i.encType || l,
          flushSync: i.flushSync
        });
      } else
        await e.navigate(i.action || o, {
          preventScrollReset: i.preventScrollReset,
          formData: s,
          body: f,
          formMethod: i.method || c,
          formEncType: i.encType || l,
          replace: i.replace,
          state: i.state,
          fromRouteId: n,
          flushSync: i.flushSync,
          viewTransition: i.viewTransition
        });
    },
    [e, t, n]
  );
}
function r_(e, { relative: t } = {}) {
  let { basename: n } = y.useContext(pe), r = y.useContext(Te);
  X(r, "useFormAction must be used inside a RouteContext");
  let [i] = r.matches.slice(-1), o = { ...Nt(e || ".", { relative: t }) }, c = Xe();
  if (e == null) {
    o.search = c.search;
    let l = new URLSearchParams(o.search), s = l.getAll("index");
    if (s.some((h) => h === "")) {
      l.delete("index"), s.filter((O) => O).forEach((O) => l.append("index", O));
      let h = l.toString();
      o.search = h ? `?${h}` : "";
    }
  }
  return (!e || e === ".") && i.route.index && (o.search = o.search ? o.search.replace(/^\?/, "?index&") : "?index"), n !== "/" && (o.pathname = o.pathname === "/" ? n : Oe([n, o.pathname])), vn(o);
}
function i_(e, t = {}) {
  let n = y.useContext(Gi);
  X(
    n != null,
    "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
  );
  let { basename: r } = Bi(
    "useViewTransitionState"
    /* useViewTransitionState */
  ), i = Nt(e, { relative: t.relative });
  if (!n.isTransitioning)
    return !1;
  let o = Le(n.currentLocation.pathname, r) || n.currentLocation.pathname, c = Le(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return Vt(i.pathname, c) != null || Vt(i.pathname, o) != null;
}
new TextEncoder();
var pn, Ur;
function a_() {
  if (Ur) return pn;
  Ur = 1;
  function e(E) {
    this._maxSize = E, this.clear();
  }
  e.prototype.clear = function() {
    this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
  }, e.prototype.get = function(E) {
    return this._values[E];
  }, e.prototype.set = function(E, S) {
    return this._size >= this._maxSize && this.clear(), E in this._values || this._size++, this._values[E] = S;
  };
  var t = /[^.^\]^[]+|(?=\[\]|\.\.)/g, n = /^\d+$/, r = /^\d/, i = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, o = /^\s*(['"]?)(.*?)(\1)\s*$/, c = 512, l = new e(c), s = new e(c), f = new e(c);
  pn = {
    Cache: e,
    split: O,
    normalizePath: h,
    setter: function(E) {
      var S = h(E);
      return s.get(E) || s.set(E, function(P, p) {
        for (var R = 0, L = S.length, U = P; R < L - 1; ) {
          var Y = S[R];
          if (Y === "__proto__" || Y === "constructor" || Y === "prototype")
            return P;
          U = U[S[R++]];
        }
        U[S[R]] = p;
      });
    },
    getter: function(E, S) {
      var C = h(E);
      return f.get(E) || f.set(E, function(p) {
        for (var R = 0, L = C.length; R < L; )
          if (p != null || !S) p = p[C[R++]];
          else return;
        return p;
      });
    },
    join: function(E) {
      return E.reduce(function(S, C) {
        return S + (m(C) || n.test(C) ? "[" + C + "]" : (S ? "." : "") + C);
      }, "");
    },
    forEach: function(E, S, C) {
      d(Array.isArray(E) ? E : O(E), S, C);
    }
  };
  function h(E) {
    return l.get(E) || l.set(
      E,
      O(E).map(function(S) {
        return S.replace(o, "$2");
      })
    );
  }
  function O(E) {
    return E.match(t) || [""];
  }
  function d(E, S, C) {
    var P = E.length, p, R, L, U;
    for (R = 0; R < P; R++)
      p = E[R], p && (I(p) && (p = '"' + p + '"'), U = m(p), L = !U && /^\d+$/.test(p), S.call(C, p, U, L, R, E));
  }
  function m(E) {
    return typeof E == "string" && E && ["'", '"'].indexOf(E.charAt(0)) !== -1;
  }
  function _(E) {
    return E.match(r) && !E.match(n);
  }
  function T(E) {
    return i.test(E);
  }
  function I(E) {
    return !m(E) && (_(E) || T(E));
  }
  return pn;
}
var ke = a_(), Tn, kr;
function o_() {
  if (kr) return Tn;
  kr = 1;
  const e = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, t = (h) => h.match(e) || [], n = (h) => h[0].toUpperCase() + h.slice(1), r = (h, O) => t(h).join(O).toLowerCase(), i = (h) => t(h).reduce(
    (O, d) => `${O}${O ? d[0].toUpperCase() + d.slice(1).toLowerCase() : d.toLowerCase()}`,
    ""
  );
  return Tn = {
    words: t,
    upperFirst: n,
    camelCase: i,
    pascalCase: (h) => n(i(h)),
    snakeCase: (h) => r(h, "_"),
    kebabCase: (h) => r(h, "-"),
    sentenceCase: (h) => n(r(h, " ")),
    titleCase: (h) => t(h).map(n).join(" ")
  }, Tn;
}
var Pn = o_(), Gt = { exports: {} }, Br;
function c_() {
  if (Br) return Gt.exports;
  Br = 1, Gt.exports = function(i) {
    return e(t(i), i);
  }, Gt.exports.array = e;
  function e(i, o) {
    var c = i.length, l = new Array(c), s = {}, f = c, h = n(o), O = r(i);
    for (o.forEach(function(m) {
      if (!O.has(m[0]) || !O.has(m[1]))
        throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }); f--; )
      s[f] || d(i[f], f, /* @__PURE__ */ new Set());
    return l;
    function d(m, _, T) {
      if (T.has(m)) {
        var I;
        try {
          I = ", node was:" + JSON.stringify(m);
        } catch {
          I = "";
        }
        throw new Error("Cyclic dependency" + I);
      }
      if (!O.has(m))
        throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(m));
      if (!s[_]) {
        s[_] = !0;
        var E = h.get(m) || /* @__PURE__ */ new Set();
        if (E = Array.from(E), _ = E.length) {
          T.add(m);
          do {
            var S = E[--_];
            d(S, O.get(S), T);
          } while (_);
          T.delete(m);
        }
        l[--c] = m;
      }
    }
  }
  function t(i) {
    for (var o = /* @__PURE__ */ new Set(), c = 0, l = i.length; c < l; c++) {
      var s = i[c];
      o.add(s[0]), o.add(s[1]);
    }
    return Array.from(o);
  }
  function n(i) {
    for (var o = /* @__PURE__ */ new Map(), c = 0, l = i.length; c < l; c++) {
      var s = i[c];
      o.has(s[0]) || o.set(s[0], /* @__PURE__ */ new Set()), o.has(s[1]) || o.set(s[1], /* @__PURE__ */ new Set()), o.get(s[0]).add(s[1]);
    }
    return o;
  }
  function r(i) {
    for (var o = /* @__PURE__ */ new Map(), c = 0, l = i.length; c < l; c++)
      o.set(i[c], c);
    return o;
  }
  return Gt.exports;
}
var u_ = c_();
const s_ = /* @__PURE__ */ Qr(u_), l_ = Object.prototype.toString, f_ = Error.prototype.toString, d_ = RegExp.prototype.toString, h_ = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", __ = /^Symbol\((.*)\)(.*)$/;
function E_(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function jr(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const n = typeof e;
  if (n === "number") return E_(e);
  if (n === "string") return t ? `"${e}"` : e;
  if (n === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (n === "symbol") return h_.call(e).replace(__, "Symbol($1)");
  const r = l_.call(e).slice(8, -1);
  return r === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : r === "Error" || e instanceof Error ? "[" + f_.call(e) + "]" : r === "RegExp" ? d_.call(e) : null;
}
function Ce(e, t) {
  let n = jr(e, t);
  return n !== null ? n : JSON.stringify(e, function(r, i) {
    let o = jr(this[r], t);
    return o !== null ? o : i;
  }, 2);
}
function ji(e) {
  return e == null ? [] : [].concat(e);
}
let Wi, Vi, qi, m_ = /\$\{\s*(\w+)\s*\}/g;
Wi = Symbol.toStringTag;
class Wr {
  constructor(t, n, r, i) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[Wi] = "Error", this.name = "ValidationError", this.value = n, this.path = r, this.type = i, this.errors = [], this.inner = [], ji(t).forEach((o) => {
      if (ee.isError(o)) {
        this.errors.push(...o.errors);
        const c = o.inner.length ? o.inner : [o];
        this.inner.push(...c);
      } else
        this.errors.push(o);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
Vi = Symbol.hasInstance;
qi = Symbol.toStringTag;
class ee extends Error {
  static formatError(t, n) {
    const r = n.label || n.path || "this";
    return n = Object.assign({}, n, {
      path: r,
      originalPath: n.path
    }), typeof t == "string" ? t.replace(m_, (i, o) => Ce(n[o])) : typeof t == "function" ? t(n) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, n, r, i, o) {
    const c = new Wr(t, n, r, i);
    if (o)
      return c;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[qi] = "Error", this.name = c.name, this.message = c.message, this.type = c.type, this.value = c.value, this.path = c.path, this.errors = c.errors, this.inner = c.inner, Error.captureStackTrace && Error.captureStackTrace(this, ee);
  }
  static [Vi](t) {
    return Wr[Symbol.hasInstance](t) || super[Symbol.hasInstance](t);
  }
}
let he = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: n,
    originalValue: r
  }) => {
    const i = r != null && r !== n ? ` (cast from the value \`${Ce(r, !0)}\`).` : ".";
    return t !== "mixed" ? `${e} must be a \`${t}\` type, but the final value was: \`${Ce(n, !0)}\`` + i : `${e} must match the configured type. The validated value was: \`${Ce(n, !0)}\`` + i;
  }
}, x = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, g_ = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, wn = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, O_ = {
  isValue: "${path} field must be ${value}"
}, Kt = {
  noUnknown: "${path} field has unspecified keys: ${unknown}",
  exact: "${path} object contains unknown properties: ${properties}"
}, S_ = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, A_ = {
  notType: (e) => {
    const {
      path: t,
      value: n,
      spec: r
    } = e, i = r.types.length;
    if (Array.isArray(n)) {
      if (n.length < i) return `${t} tuple value has too few items, expected a length of ${i} but got ${n.length} for value: \`${Ce(n, !0)}\``;
      if (n.length > i) return `${t} tuple value has too many items, expected a length of ${i} but got ${n.length} for value: \`${Ce(n, !0)}\``;
    }
    return ee.formatError(he.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: he,
  string: x,
  number: g_,
  date: wn,
  object: Kt,
  array: S_,
  boolean: O_,
  tuple: A_
});
const xn = (e) => e && e.__isYupSchema__;
class qt {
  static fromOptions(t, n) {
    if (!n.then && !n.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: r,
      then: i,
      otherwise: o
    } = n, c = typeof r == "function" ? r : (...l) => l.every((s) => s === r);
    return new qt(t, (l, s) => {
      var f;
      let h = c(...l) ? i : o;
      return (f = h == null ? void 0 : h(s)) != null ? f : s;
    });
  }
  constructor(t, n) {
    this.fn = void 0, this.refs = t, this.refs = t, this.fn = n;
  }
  resolve(t, n) {
    let r = this.refs.map((o) => (
      // TODO: ? operator here?
      o.getValue(n == null ? void 0 : n.value, n == null ? void 0 : n.parent, n == null ? void 0 : n.context)
    )), i = this.fn(r, t, n);
    if (i === void 0 || // @ts-ignore this can be base
    i === t)
      return t;
    if (!xn(i)) throw new TypeError("conditions must return a schema object");
    return i.resolve(n);
  }
}
const Yt = {
  context: "$",
  value: "."
};
class ze {
  constructor(t, n = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Yt.context, this.isValue = this.key[0] === Yt.value, this.isSibling = !this.isContext && !this.isValue;
    let r = this.isContext ? Yt.context : this.isValue ? Yt.value : "";
    this.path = this.key.slice(r.length), this.getter = this.path && ke.getter(this.path, !0), this.map = n.map;
  }
  getValue(t, n, r) {
    let i = this.isContext ? r : this.isValue ? t : n;
    return this.getter && (i = this.getter(i || {})), this.map && (i = this.map(i)), i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, n) {
    return this.getValue(t, n == null ? void 0 : n.parent, n == null ? void 0 : n.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
ze.prototype.__isYupRef = !0;
const Ke = (e) => e == null;
function at(e) {
  function t({
    value: n,
    path: r = "",
    options: i,
    originalValue: o,
    schema: c
  }, l, s) {
    const {
      name: f,
      test: h,
      params: O,
      message: d,
      skipAbsent: m
    } = e;
    let {
      parent: _,
      context: T,
      abortEarly: I = c.spec.abortEarly,
      disableStackTrace: E = c.spec.disableStackTrace
    } = i;
    function S(K) {
      return ze.isRef(K) ? K.getValue(n, _, T) : K;
    }
    function C(K = {}) {
      const ne = Object.assign({
        value: n,
        originalValue: o,
        label: c.spec.label,
        path: K.path || r,
        spec: c.spec,
        disableStackTrace: K.disableStackTrace || E
      }, O, K.params);
      for (const oe of Object.keys(ne)) ne[oe] = S(ne[oe]);
      const J = new ee(ee.formatError(K.message || d, ne), n, ne.path, K.type || f, ne.disableStackTrace);
      return J.params = ne, J;
    }
    const P = I ? l : s;
    let p = {
      path: r,
      parent: _,
      type: f,
      from: i.from,
      createError: C,
      resolve: S,
      options: i,
      originalValue: o,
      schema: c
    };
    const R = (K) => {
      ee.isError(K) ? P(K) : K ? s(null) : P(C());
    }, L = (K) => {
      ee.isError(K) ? P(K) : l(K);
    };
    if (m && Ke(n))
      return R(!0);
    let Y;
    try {
      var H;
      if (Y = h.call(p, n, p), typeof ((H = Y) == null ? void 0 : H.then) == "function") {
        if (i.sync)
          throw new Error(`Validation test of type: "${p.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(Y).then(R, L);
      }
    } catch (K) {
      L(K);
      return;
    }
    R(Y);
  }
  return t.OPTIONS = e, t;
}
function p_(e, t, n, r = n) {
  let i, o, c;
  return t ? (ke.forEach(t, (l, s, f) => {
    let h = s ? l.slice(1, l.length - 1) : l;
    e = e.resolve({
      context: r,
      parent: i,
      value: n
    });
    let O = e.type === "tuple", d = f ? parseInt(h, 10) : 0;
    if (e.innerType || O) {
      if (O && !f) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${c}" must contain an index to the tuple element, e.g. "${c}[0]"`);
      if (n && d >= n.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${l}, in the path: ${t}. because there is no value at that index. `);
      i = n, n = n && n[d], e = O ? e.spec.types[d] : e.innerType;
    }
    if (!f) {
      if (!e.fields || !e.fields[h]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${c} which is a type: "${e.type}")`);
      i = n, n = n && n[h], e = e.fields[h];
    }
    o = h, c = s ? "[" + l + "]" : "." + l;
  }), {
    schema: e,
    parent: i,
    parentPath: o
  }) : {
    parent: i,
    parentPath: t,
    schema: e
  };
}
class Ht extends Set {
  describe() {
    const t = [];
    for (const n of this.values())
      t.push(ze.isRef(n) ? n.describe() : n);
    return t;
  }
  resolveAll(t) {
    let n = [];
    for (const r of this.values())
      n.push(t(r));
    return n;
  }
  clone() {
    return new Ht(this.values());
  }
  merge(t, n) {
    const r = this.clone();
    return t.forEach((i) => r.add(i)), n.forEach((i) => r.delete(i)), r;
  }
}
function ct(e, t = /* @__PURE__ */ new Map()) {
  if (xn(e) || !e || typeof e != "object") return e;
  if (t.has(e)) return t.get(e);
  let n;
  if (e instanceof Date)
    n = new Date(e.getTime()), t.set(e, n);
  else if (e instanceof RegExp)
    n = new RegExp(e), t.set(e, n);
  else if (Array.isArray(e)) {
    n = new Array(e.length), t.set(e, n);
    for (let r = 0; r < e.length; r++) n[r] = ct(e[r], t);
  } else if (e instanceof Map) {
    n = /* @__PURE__ */ new Map(), t.set(e, n);
    for (const [r, i] of e.entries()) n.set(r, ct(i, t));
  } else if (e instanceof Set) {
    n = /* @__PURE__ */ new Set(), t.set(e, n);
    for (const r of e) n.add(ct(r, t));
  } else if (e instanceof Object) {
    n = {}, t.set(e, n);
    for (const [r, i] of Object.entries(e)) n[r] = ct(i, t);
  } else
    throw Error(`Unable to clone ${e}`);
  return n;
}
class _e {
  constructor(t) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new Ht(), this._blacklist = new Ht(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(he.notType);
    }), this.type = t.type, this._typeCheck = t.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, t == null ? void 0 : t.spec), this.withMutation((n) => {
      n.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const n = Object.create(Object.getPrototypeOf(this));
    return n.type = this.type, n._typeCheck = this._typeCheck, n._whitelist = this._whitelist.clone(), n._blacklist = this._blacklist.clone(), n.internalTests = Object.assign({}, this.internalTests), n.exclusiveTests = Object.assign({}, this.exclusiveTests), n.deps = [...this.deps], n.conditions = [...this.conditions], n.tests = [...this.tests], n.transforms = [...this.transforms], n.spec = ct(Object.assign({}, this.spec, t)), n;
  }
  label(t) {
    let n = this.clone();
    return n.spec.label = t, n;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let n = this.clone();
    return n.spec.meta = Object.assign(n.spec.meta || {}, t[0]), n;
  }
  withMutation(t) {
    let n = this._mutate;
    this._mutate = !0;
    let r = t(this);
    return this._mutate = n, r;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let n = this, r = t.clone();
    const i = Object.assign({}, n.spec, r.spec);
    return r.spec = i, r.internalTests = Object.assign({}, n.internalTests, r.internalTests), r._whitelist = n._whitelist.merge(t._whitelist, t._blacklist), r._blacklist = n._blacklist.merge(t._blacklist, t._whitelist), r.tests = n.tests, r.exclusiveTests = n.exclusiveTests, r.withMutation((o) => {
      t.tests.forEach((c) => {
        o.test(c.OPTIONS);
      });
    }), r.transforms = [...n.transforms, ...r.transforms], r;
  }
  isType(t) {
    return t == null ? !!(this.spec.nullable && t === null || this.spec.optional && t === void 0) : this._typeCheck(t);
  }
  resolve(t) {
    let n = this;
    if (n.conditions.length) {
      let r = n.conditions;
      n = n.clone(), n.conditions = [], n = r.reduce((i, o) => o.resolve(i, t), n), n = n.resolve(t);
    }
    return n;
  }
  resolveOptions(t) {
    var n, r, i, o;
    return Object.assign({}, t, {
      from: t.from || [],
      strict: (n = t.strict) != null ? n : this.spec.strict,
      abortEarly: (r = t.abortEarly) != null ? r : this.spec.abortEarly,
      recursive: (i = t.recursive) != null ? i : this.spec.recursive,
      disableStackTrace: (o = t.disableStackTrace) != null ? o : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(t, n = {}) {
    let r = this.resolve(Object.assign({
      value: t
    }, n)), i = n.assert === "ignore-optionality", o = r._cast(t, n);
    if (n.assert !== !1 && !r.isType(o)) {
      if (i && Ke(o))
        return o;
      let c = Ce(t), l = Ce(o);
      throw new TypeError(`The value of ${n.path || "field"} could not be cast to a value that satisfies the schema type: "${r.type}". 

attempted value: ${c} 
` + (l !== c ? `result of cast: ${l}` : ""));
    }
    return o;
  }
  _cast(t, n) {
    let r = t === void 0 ? t : this.transforms.reduce((i, o) => o.call(this, i, t, this), t);
    return r === void 0 && (r = this.getDefault(n)), r;
  }
  _validate(t, n = {}, r, i) {
    let {
      path: o,
      originalValue: c = t,
      strict: l = this.spec.strict
    } = n, s = t;
    l || (s = this._cast(s, Object.assign({
      assert: !1
    }, n)));
    let f = [];
    for (let h of Object.values(this.internalTests))
      h && f.push(h);
    this.runTests({
      path: o,
      value: s,
      originalValue: c,
      options: n,
      tests: f
    }, r, (h) => {
      if (h.length)
        return i(h, s);
      this.runTests({
        path: o,
        value: s,
        originalValue: c,
        options: n,
        tests: this.tests
      }, r, i);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(t, n, r) {
    let i = !1, {
      tests: o,
      value: c,
      originalValue: l,
      path: s,
      options: f
    } = t, h = (T) => {
      i || (i = !0, n(T, c));
    }, O = (T) => {
      i || (i = !0, r(T, c));
    }, d = o.length, m = [];
    if (!d) return O([]);
    let _ = {
      value: c,
      originalValue: l,
      path: s,
      options: f,
      schema: this
    };
    for (let T = 0; T < o.length; T++) {
      const I = o[T];
      I(_, h, function(S) {
        S && (Array.isArray(S) ? m.push(...S) : m.push(S)), --d <= 0 && O(m);
      });
    }
  }
  asNestedTest({
    key: t,
    index: n,
    parent: r,
    parentPath: i,
    originalParent: o,
    options: c
  }) {
    const l = t ?? n;
    if (l == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const s = typeof l == "number";
    let f = r[l];
    const h = Object.assign({}, c, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: r,
      value: f,
      originalValue: o[l],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [s ? "index" : "key"]: l,
      path: s || l.includes(".") ? `${i || ""}[${s ? l : `"${l}"`}]` : (i ? `${i}.` : "") + t
    });
    return (O, d, m) => this.resolve(h)._validate(f, h, d, m);
  }
  validate(t, n) {
    var r;
    let i = this.resolve(Object.assign({}, n, {
      value: t
    })), o = (r = n == null ? void 0 : n.disableStackTrace) != null ? r : i.spec.disableStackTrace;
    return new Promise((c, l) => i._validate(t, n, (s, f) => {
      ee.isError(s) && (s.value = f), l(s);
    }, (s, f) => {
      s.length ? l(new ee(s, f, void 0, void 0, o)) : c(f);
    }));
  }
  validateSync(t, n) {
    var r;
    let i = this.resolve(Object.assign({}, n, {
      value: t
    })), o, c = (r = n == null ? void 0 : n.disableStackTrace) != null ? r : i.spec.disableStackTrace;
    return i._validate(t, Object.assign({}, n, {
      sync: !0
    }), (l, s) => {
      throw ee.isError(l) && (l.value = s), l;
    }, (l, s) => {
      if (l.length) throw new ee(l, t, void 0, void 0, c);
      o = s;
    }), o;
  }
  isValid(t, n) {
    return this.validate(t, n).then(() => !0, (r) => {
      if (ee.isError(r)) return !1;
      throw r;
    });
  }
  isValidSync(t, n) {
    try {
      return this.validateSync(t, n), !0;
    } catch (r) {
      if (ee.isError(r)) return !1;
      throw r;
    }
  }
  _getDefault(t) {
    let n = this.spec.default;
    return n == null ? n : typeof n == "function" ? n.call(this, t) : ct(n);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault(t);
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    return this.clone({
      strict: t
    });
  }
  nullability(t, n) {
    const r = this.clone({
      nullable: t
    });
    return r.internalTests.nullable = at({
      message: n,
      name: "nullable",
      test(i) {
        return i === null ? this.schema.spec.nullable : !0;
      }
    }), r;
  }
  optionality(t, n) {
    const r = this.clone({
      optional: t
    });
    return r.internalTests.optionality = at({
      message: n,
      name: "optionality",
      test(i) {
        return i === void 0 ? this.schema.spec.optional : !0;
      }
    }), r;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(t = he.defined) {
    return this.optionality(!1, t);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(t = he.notNull) {
    return this.nullability(!1, t);
  }
  required(t = he.required) {
    return this.clone().withMutation((n) => n.nonNullable(t).defined(t));
  }
  notRequired() {
    return this.clone().withMutation((t) => t.nullable().optional());
  }
  transform(t) {
    let n = this.clone();
    return n.transforms.push(t), n;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let n;
    if (t.length === 1 ? typeof t[0] == "function" ? n = {
      test: t[0]
    } : n = t[0] : t.length === 2 ? n = {
      name: t[0],
      test: t[1]
    } : n = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, n.message === void 0 && (n.message = he.default), typeof n.test != "function") throw new TypeError("`test` is a required parameters");
    let r = this.clone(), i = at(n), o = n.exclusive || n.name && r.exclusiveTests[n.name] === !0;
    if (n.exclusive && !n.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return n.name && (r.exclusiveTests[n.name] = !!n.exclusive), r.tests = r.tests.filter((c) => !(c.OPTIONS.name === n.name && (o || c.OPTIONS.test === i.OPTIONS.test))), r.tests.push(i), r;
  }
  when(t, n) {
    !Array.isArray(t) && typeof t != "string" && (n = t, t = ".");
    let r = this.clone(), i = ji(t).map((o) => new ze(o));
    return i.forEach((o) => {
      o.isSibling && r.deps.push(o.key);
    }), r.conditions.push(typeof n == "function" ? new qt(i, n) : qt.fromOptions(i, n)), r;
  }
  typeError(t) {
    let n = this.clone();
    return n.internalTests.typeError = at({
      message: t,
      name: "typeError",
      skipAbsent: !0,
      test(r) {
        return this.schema._typeCheck(r) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), n;
  }
  oneOf(t, n = he.oneOf) {
    let r = this.clone();
    return t.forEach((i) => {
      r._whitelist.add(i), r._blacklist.delete(i);
    }), r.internalTests.whiteList = at({
      message: n,
      name: "oneOf",
      skipAbsent: !0,
      test(i) {
        let o = this.schema._whitelist, c = o.resolveAll(this.resolve);
        return c.includes(i) ? !0 : this.createError({
          params: {
            values: Array.from(o).join(", "),
            resolved: c
          }
        });
      }
    }), r;
  }
  notOneOf(t, n = he.notOneOf) {
    let r = this.clone();
    return t.forEach((i) => {
      r._blacklist.add(i), r._whitelist.delete(i);
    }), r.internalTests.blacklist = at({
      message: n,
      name: "notOneOf",
      test(i) {
        let o = this.schema._blacklist, c = o.resolveAll(this.resolve);
        return c.includes(i) ? this.createError({
          params: {
            values: Array.from(o).join(", "),
            resolved: c
          }
        }) : !0;
      }
    }), r;
  }
  strip(t = !0) {
    let n = this.clone();
    return n.spec.strip = t, n;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(t) {
    const n = (t ? this.resolve(t) : this).clone(), {
      label: r,
      meta: i,
      optional: o,
      nullable: c
    } = n.spec;
    return {
      meta: i,
      label: r,
      optional: o,
      nullable: c,
      default: n.getDefault(t),
      type: n.type,
      oneOf: n._whitelist.describe(),
      notOneOf: n._blacklist.describe(),
      tests: n.tests.map((s) => ({
        name: s.OPTIONS.name,
        params: s.OPTIONS.params
      })).filter((s, f, h) => h.findIndex((O) => O.name === s.name) === f)
    };
  }
}
_e.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) _e.prototype[`${e}At`] = function(t, n, r = {}) {
  const {
    parent: i,
    parentPath: o,
    schema: c
  } = p_(this, t, n, r.context);
  return c[e](i && i[o], Object.assign({}, r, {
    parent: i,
    path: t
  }));
};
for (const e of ["equals", "is"]) _e.prototype[e] = _e.prototype.oneOf;
for (const e of ["not", "nope"]) _e.prototype[e] = _e.prototype.notOneOf;
const T_ = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function P_(e) {
  const t = bn(e);
  if (!t) return Date.parse ? Date.parse(e) : Number.NaN;
  if (t.z === void 0 && t.plusMinus === void 0)
    return new Date(t.year, t.month, t.day, t.hour, t.minute, t.second, t.millisecond).valueOf();
  let n = 0;
  return t.z !== "Z" && t.plusMinus !== void 0 && (n = t.hourOffset * 60 + t.minuteOffset, t.plusMinus === "+" && (n = 0 - n)), Date.UTC(t.year, t.month, t.day, t.hour, t.minute + n, t.second, t.millisecond);
}
function bn(e) {
  var t, n;
  const r = T_.exec(e);
  return r ? {
    year: me(r[1]),
    month: me(r[2], 1) - 1,
    day: me(r[3], 1),
    hour: me(r[4]),
    minute: me(r[5]),
    second: me(r[6]),
    millisecond: r[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      me(r[7].substring(0, 3))
    ) : 0,
    precision: (t = (n = r[7]) == null ? void 0 : n.length) != null ? t : void 0,
    z: r[8] || void 0,
    plusMinus: r[9] || void 0,
    hourOffset: me(r[10]),
    minuteOffset: me(r[11])
  } : null;
}
function me(e, t = 0) {
  return Number(e) || t;
}
let I_ = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), y_ = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), R_ = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, C_ = "^\\d{4}-\\d{2}-\\d{2}", N_ = "\\d{2}:\\d{2}:\\d{2}", L_ = "(([+-]\\d{2}(:?\\d{2})?)|Z)", F_ = new RegExp(`${C_}T${N_}(\\.\\d+)?${L_}$`), v_ = (e) => Ke(e) || e === e.trim(), w_ = {}.toString();
function Hi() {
  return new Ji();
}
class Ji extends _e {
  constructor() {
    super({
      type: "string",
      check(t) {
        return t instanceof String && (t = t.valueOf()), typeof t == "string";
      }
    }), this.withMutation(() => {
      this.transform((t, n, r) => {
        if (!r.spec.coerce || r.isType(t) || Array.isArray(t)) return t;
        const i = t != null && t.toString ? t.toString() : t;
        return i === w_ ? t : i;
      });
    });
  }
  required(t) {
    return super.required(t).withMutation((n) => n.test({
      message: t || he.required,
      name: "required",
      skipAbsent: !0,
      test: (r) => !!r.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((t) => (t.tests = t.tests.filter((n) => n.OPTIONS.name !== "required"), t));
  }
  length(t, n = x.length) {
    return this.test({
      message: n,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(r) {
        return r.length === this.resolve(t);
      }
    });
  }
  min(t, n = x.min) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(r) {
        return r.length >= this.resolve(t);
      }
    });
  }
  max(t, n = x.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: n,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(r) {
        return r.length <= this.resolve(t);
      }
    });
  }
  matches(t, n) {
    let r = !1, i, o;
    return n && (typeof n == "object" ? {
      excludeEmptyString: r = !1,
      message: i,
      name: o
    } = n : i = n), this.test({
      name: o || "matches",
      message: i || x.matches,
      params: {
        regex: t
      },
      skipAbsent: !0,
      test: (c) => c === "" && r || c.search(t) !== -1
    });
  }
  email(t = x.email) {
    return this.matches(I_, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = x.url) {
    return this.matches(y_, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = x.uuid) {
    return this.matches(R_, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  datetime(t) {
    let n = "", r, i;
    return t && (typeof t == "object" ? {
      message: n = "",
      allowOffset: r = !1,
      precision: i = void 0
    } = t : n = t), this.matches(F_, {
      name: "datetime",
      message: n || x.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: n || x.datetime_offset,
      params: {
        allowOffset: r
      },
      skipAbsent: !0,
      test: (o) => {
        if (!o || r) return !0;
        const c = bn(o);
        return c ? !!c.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: n || x.datetime_precision,
      params: {
        precision: i
      },
      skipAbsent: !0,
      test: (o) => {
        if (!o || i == null) return !0;
        const c = bn(o);
        return c ? c.precision === i : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = x.trim) {
    return this.transform((n) => n != null ? n.trim() : n).test({
      message: t,
      name: "trim",
      test: v_
    });
  }
  lowercase(t = x.lowercase) {
    return this.transform((n) => Ke(n) ? n : n.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (n) => Ke(n) || n === n.toLowerCase()
    });
  }
  uppercase(t = x.uppercase) {
    return this.transform((n) => Ke(n) ? n : n.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (n) => Ke(n) || n === n.toUpperCase()
    });
  }
}
Hi.prototype = Ji.prototype;
let b_ = /* @__PURE__ */ new Date(""), G_ = (e) => Object.prototype.toString.call(e) === "[object Date]";
class er extends _e {
  constructor() {
    super({
      type: "date",
      check(t) {
        return G_(t) && !isNaN(t.getTime());
      }
    }), this.withMutation(() => {
      this.transform((t, n, r) => !r.spec.coerce || r.isType(t) || t === null ? t : (t = P_(t), isNaN(t) ? er.INVALID_DATE : new Date(t)));
    });
  }
  prepareParam(t, n) {
    let r;
    if (ze.isRef(t))
      r = t;
    else {
      let i = this.cast(t);
      if (!this._typeCheck(i)) throw new TypeError(`\`${n}\` must be a Date or a value that can be \`cast()\` to a Date`);
      r = i;
    }
    return r;
  }
  min(t, n = wn.min) {
    let r = this.prepareParam(t, "min");
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(i) {
        return i >= this.resolve(r);
      }
    });
  }
  max(t, n = wn.max) {
    let r = this.prepareParam(t, "max");
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(i) {
        return i <= this.resolve(r);
      }
    });
  }
}
er.INVALID_DATE = b_;
function Y_(e, t = []) {
  let n = [], r = /* @__PURE__ */ new Set(), i = new Set(t.map(([c, l]) => `${c}-${l}`));
  function o(c, l) {
    let s = ke.split(c)[0];
    r.add(s), i.has(`${l}-${s}`) || n.push([l, s]);
  }
  for (const c of Object.keys(e)) {
    let l = e[c];
    r.add(c), ze.isRef(l) && l.isSibling ? o(l.path, c) : xn(l) && "deps" in l && l.deps.forEach((s) => o(s, c));
  }
  return s_.array(Array.from(r), n).reverse();
}
function Vr(e, t) {
  let n = 1 / 0;
  return e.some((r, i) => {
    var o;
    if ((o = t.path) != null && o.includes(r))
      return n = i, !0;
  }), n;
}
function Xi(e) {
  return (t, n) => Vr(e, t) - Vr(e, n);
}
const D_ = (e, t, n) => {
  if (typeof e != "string")
    return e;
  let r = e;
  try {
    r = JSON.parse(e);
  } catch {
  }
  return n.isType(r) ? r : e;
};
function Ut(e) {
  if ("fields" in e) {
    const t = {};
    for (const [n, r] of Object.entries(e.fields))
      t[n] = Ut(r);
    return e.setFields(t);
  }
  if (e.type === "array") {
    const t = e.optional();
    return t.innerType && (t.innerType = Ut(t.innerType)), t;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(Ut)
  }) : "optional" in e ? e.optional() : e;
}
const $_ = (e, t) => {
  const n = [...ke.normalizePath(t)];
  if (n.length === 1) return n[0] in e;
  let r = n.pop(), i = ke.getter(ke.join(n), !0)(e);
  return !!(i && r in i);
};
let qr = (e) => Object.prototype.toString.call(e) === "[object Object]";
function Hr(e, t) {
  let n = Object.keys(e.fields);
  return Object.keys(t).filter((r) => n.indexOf(r) === -1);
}
const M_ = Xi([]);
function zi(e) {
  return new Qi(e);
}
class Qi extends _e {
  constructor(t) {
    super({
      type: "object",
      check(n) {
        return qr(n) || typeof n == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = M_, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      t && this.shape(t);
    });
  }
  _cast(t, n = {}) {
    var r;
    let i = super._cast(t, n);
    if (i === void 0) return this.getDefault(n);
    if (!this._typeCheck(i)) return i;
    let o = this.fields, c = (r = n.stripUnknown) != null ? r : this.spec.noUnknown, l = [].concat(this._nodes, Object.keys(i).filter((O) => !this._nodes.includes(O))), s = {}, f = Object.assign({}, n, {
      parent: s,
      __validating: n.__validating || !1
    }), h = !1;
    for (const O of l) {
      let d = o[O], m = O in i;
      if (d) {
        let _, T = i[O];
        f.path = (n.path ? `${n.path}.` : "") + O, d = d.resolve({
          value: T,
          context: n.context,
          parent: s
        });
        let I = d instanceof _e ? d.spec : void 0, E = I == null ? void 0 : I.strict;
        if (I != null && I.strip) {
          h = h || O in i;
          continue;
        }
        _ = !n.__validating || !E ? (
          // TODO: use _cast, this is double resolving
          d.cast(i[O], f)
        ) : i[O], _ !== void 0 && (s[O] = _);
      } else m && !c && (s[O] = i[O]);
      (m !== O in s || s[O] !== i[O]) && (h = !0);
    }
    return h ? s : i;
  }
  _validate(t, n = {}, r, i) {
    let {
      from: o = [],
      originalValue: c = t,
      recursive: l = this.spec.recursive
    } = n;
    n.from = [{
      schema: this,
      value: c
    }, ...o], n.__validating = !0, n.originalValue = c, super._validate(t, n, r, (s, f) => {
      if (!l || !qr(f)) {
        i(s, f);
        return;
      }
      c = c || f;
      let h = [];
      for (let O of this._nodes) {
        let d = this.fields[O];
        !d || ze.isRef(d) || h.push(d.asNestedTest({
          options: n,
          key: O,
          parent: f,
          parentPath: n.path,
          originalParent: c
        }));
      }
      this.runTests({
        tests: h,
        value: f,
        originalValue: c,
        options: n
      }, r, (O) => {
        i(O.sort(this._sortErrors).concat(s), f);
      });
    });
  }
  clone(t) {
    const n = super.clone(t);
    return n.fields = Object.assign({}, this.fields), n._nodes = this._nodes, n._excludedEdges = this._excludedEdges, n._sortErrors = this._sortErrors, n;
  }
  concat(t) {
    let n = super.concat(t), r = n.fields;
    for (let [i, o] of Object.entries(this.fields)) {
      const c = r[i];
      r[i] = c === void 0 ? o : c;
    }
    return n.withMutation((i) => (
      // XXX: excludes here is wrong
      i.setFields(r, [...this._excludedEdges, ...t._excludedEdges])
    ));
  }
  _getDefault(t) {
    if ("default" in this.spec)
      return super._getDefault(t);
    if (!this._nodes.length)
      return;
    let n = {};
    return this._nodes.forEach((r) => {
      var i;
      const o = this.fields[r];
      let c = t;
      (i = c) != null && i.value && (c = Object.assign({}, c, {
        parent: c.value,
        value: c.value[r]
      })), n[r] = o && "getDefault" in o ? o.getDefault(c) : void 0;
    }), n;
  }
  setFields(t, n) {
    let r = this.clone();
    return r.fields = t, r._nodes = Y_(t, n), r._sortErrors = Xi(Object.keys(t)), n && (r._excludedEdges = n), r;
  }
  shape(t, n = []) {
    return this.clone().withMutation((r) => {
      let i = r._excludedEdges;
      return n.length && (Array.isArray(n[0]) || (n = [n]), i = [...r._excludedEdges, ...n]), r.setFields(Object.assign(r.fields, t), i);
    });
  }
  partial() {
    const t = {};
    for (const [n, r] of Object.entries(this.fields))
      t[n] = "optional" in r && r.optional instanceof Function ? r.optional() : r;
    return this.setFields(t);
  }
  deepPartial() {
    return Ut(this);
  }
  pick(t) {
    const n = {};
    for (const r of t)
      this.fields[r] && (n[r] = this.fields[r]);
    return this.setFields(n, this._excludedEdges.filter(([r, i]) => t.includes(r) && t.includes(i)));
  }
  omit(t) {
    const n = [];
    for (const r of Object.keys(this.fields))
      t.includes(r) || n.push(r);
    return this.pick(n);
  }
  from(t, n, r) {
    let i = ke.getter(t, !0);
    return this.transform((o) => {
      if (!o) return o;
      let c = o;
      return $_(o, t) && (c = Object.assign({}, o), r || delete c[t], c[n] = i(o)), c;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(D_);
  }
  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(t) {
    return this.test({
      name: "exact",
      exclusive: !0,
      message: t || Kt.exact,
      test(n) {
        if (n == null) return !0;
        const r = Hr(this.schema, n);
        return r.length === 0 || this.createError({
          params: {
            properties: r.join(", ")
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: !0
    });
  }
  noUnknown(t = !0, n = Kt.noUnknown) {
    typeof t != "boolean" && (n = t, t = !0);
    let r = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: n,
      test(i) {
        if (i == null) return !0;
        const o = Hr(this.schema, i);
        return !t || o.length === 0 || this.createError({
          params: {
            unknown: o.join(", ")
          }
        });
      }
    });
    return r.spec.noUnknown = t, r;
  }
  unknown(t = !0, n = Kt.noUnknown) {
    return this.noUnknown(!t, n);
  }
  transformKeys(t) {
    return this.transform((n) => {
      if (!n) return n;
      const r = {};
      for (const i of Object.keys(n)) r[t(i)] = n[i];
      return r;
    });
  }
  camelCase() {
    return this.transformKeys(Pn.camelCase);
  }
  snakeCase() {
    return this.transformKeys(Pn.snakeCase);
  }
  constantCase() {
    return this.transformKeys((t) => Pn.snakeCase(t).toUpperCase());
  }
  describe(t) {
    const n = (t ? this.resolve(t) : this).clone(), r = super.describe(t);
    r.fields = {};
    for (const [o, c] of Object.entries(n.fields)) {
      var i;
      let l = t;
      (i = l) != null && i.value && (l = Object.assign({}, l, {
        parent: l.value,
        value: l.value[o]
      })), r.fields[o] = c.describe(l);
    }
    return r;
  }
}
zi.prototype = Qi.prototype;
const K_ = ({ authKey: e }) => {
  const t = W(
    ({ body: c }) => Be.fetchPostTwoFactorAuthenticate({
      authenticationToken: e,
      body: c
    }),
    [e]
  ), {
    post: n,
    isLoading: r,
    error: i
  } = je(t), o = i ? Gn(i.message) : null;
  return {
    isLoading: r,
    error: o,
    post: n
  };
}, U_ = ({ authKey: e }) => {
  const t = W(
    ({ body: c }) => Be.fetchPostTwoFactorSetup({
      authenticationToken: e,
      body: c
    }),
    [e]
  ), { post: n, isLoading: r, error: i } = je(t), o = i ? Gn(i.message) : null;
  return {
    isLoading: r,
    error: o,
    post: n
  };
}, k_ = (e) => {
  const t = window.location.search, n = new URLSearchParams(t), r = e || n.get("k");
  return (r === null || r === "") && (window.location.href = "/login"), {
    multifactorAuthKey: r
  };
}, B_ = "_link_r7nxi_58", j_ = "_authenticatorCodeSetup_r7nxi_101", W_ = "_validationError_r7nxi_226", Jt = {
  link: B_,
  authenticatorCodeSetup: j_,
  validationError: W_
}, V_ = ({
  onSuccess: e,
  type: t,
  authToken: n,
  children: r
}) => {
  const { multifactorAuthKey: i } = k_(n), { post: o } = je(Be.fetchPostIwocapayNotifications), { post: c } = K_({
    authKey: i
  }), { post: l } = U_({
    authKey: i
  }), [s, f] = te(null), h = W(async (O) => {
    try {
      if (t === "log in") {
        const { data: d } = await c({
          data: {
            otp: O.otpCode,
            remember_device: O.remember_device || !1
          }
        });
        "state_key" in d && e(d.state_key);
      }
      if (t === "sign up") {
        const { data: d } = await l({
          data: {
            otp: O.otpCode
          }
        });
        "state_key" in d && e(d.state_key);
      }
    } catch (d) {
      const m = Gn(d.message);
      if ((m == null ? void 0 : m.code) === "InvalidOTP") {
        f({
          ...m,
          message: "Your one time passcode is incorrect.",
          loginButton: !1
        }), o({
          data: {
            type: "2fa-otp-invalid",
            attributes: { authToken: i }
          }
        });
        return;
      }
      if ((m == null ? void 0 : m.code) === "TokenExpired") {
        f({
          ...m,
          message: "Your login session has expired. Please log in again.",
          loginButton: !0
        });
        return;
      }
      if ((m == null ? void 0 : m.code) === "TwoFactorSetupAlreadyCompleted") {
        f({
          ...m,
          message: "You have already completed setup. Please log in.",
          loginButton: !0
        });
        return;
      }
      f({
        ...m,
        message: "An error occured, Please log in again.",
        loginButton: !0
      });
    }
  }, []);
  return /* @__PURE__ */ b(It, { children: /* @__PURE__ */ b(
    Rd,
    {
      initialValues: { otpCode: "", remember_device: !1 },
      onSubmit: h,
      validationSchema: H_,
      validateOnMount: !0,
      enableReinitialize: !0,
      children: ({ handleSubmit: O }) => /* @__PURE__ */ Q("form", { onSubmit: O, children: [
        r(() => {
          s && f(null);
        }),
        s && /* @__PURE__ */ b("p", { className: Jt.validationError, children: s.message }),
        (s == null ? void 0 : s.loginButton) && /* @__PURE__ */ b(Zn, { to: "/login", className: Jt.link, children: /* @__PURE__ */ b("p", { children: "Click here to log in" }) })
      ] })
    }
  ) });
}, q_ = ({
  name: e,
  styles: t,
  copy: n,
  ...r
}) => {
  const [i, { error: o, touched: c }] = bd(e);
  return /* @__PURE__ */ Q(It, { children: [
    /* @__PURE__ */ b(
      kt,
      {
        wrapperClassName: t == null ? void 0 : t.inputWrapper,
        className: se(
          Jt.authenticatorCodeSetup,
          t == null ? void 0 : t.input
        ),
        placeholder: (n == null ? void 0 : n.placeholder) || "Enter 6-digit authenticator code",
        ...r,
        ...i
      }
    ),
    o && c && /* @__PURE__ */ b("p", { className: Jt.validationError, children: o })
  ] });
}, H_ = () => zi().shape({
  otpCode: Hi().required("Your authenticator code is required").matches(/^[0-9]+$/, "Your authenticator code must contain only digits").length(6, "Your authenticator code must contain 6 digits")
}), J_ = ({
  authToken: e,
  onSuccessfulLogin: t,
  copy: n,
  styles: r
}) => /* @__PURE__ */ Q("div", { className: r == null ? void 0 : r.container, children: [
  /* @__PURE__ */ b("h2", { children: (n == null ? void 0 : n.title) || "Please confirm it's you" }),
  /* @__PURE__ */ b(kd, { type: "safety", children: /* @__PURE__ */ b("b", { children: (n == null ? void 0 : n.info) || "You need to confirm it's you using your authenticator app." }) }),
  /* @__PURE__ */ b("p", { children: (n == null ? void 0 : n.label) || "Enter the 6-digit code" }),
  /* @__PURE__ */ b(
    V_,
    {
      type: "log in",
      onSuccess: (i) => t == null ? void 0 : t(i),
      authToken: e,
      children: (i) => /* @__PURE__ */ Q(It, { children: [
        /* @__PURE__ */ b(
          q_,
          {
            onClick: i,
            name: "otpCode",
            styles: r,
            copy: n
          }
        ),
        /* @__PURE__ */ Q("div", { className: z.trust, children: [
          /* @__PURE__ */ b(Gd, { type: "checkbox", name: "remember_device" }),
          " ",
          (n == null ? void 0 : n.trustDevice) || "Trust this device",
          /* @__PURE__ */ b("div", { children: /* @__PURE__ */ b(
            zc,
            {
              content: (n == null ? void 0 : n.tooltip) || `Trusting this device will remember this device for 30 days.

After that you will need to enter a new authenticator code when you next log in.`
            }
          ) })
        ] }),
        /* @__PURE__ */ b(Bt, { className: r == null ? void 0 : r.submitButton, type: "submit", children: (n == null ? void 0 : n.confirm) || "Confirm" })
      ] })
    }
  ),
  /* @__PURE__ */ b("hr", {}),
  /* @__PURE__ */ b("p", { children: (n == null ? void 0 : n.help) || "Cant find your authenticator code? Please check you’re on the right phone." }),
  /* @__PURE__ */ Q("p", { children: [
    (n == null ? void 0 : n.help2) || "If you haven’t set up authentication yet ",
    /* @__PURE__ */ b("a", { href: "/login/two-factor/setup", children: (n == null ? void 0 : n.setUp) || "set it up now." })
  ] })
] });
export {
  x_ as Login,
  _u as PasswordLogin,
  hu as PasswordlessLogin,
  J_ as TwoFactorLogin
};
//# sourceMappingURL=index.es.js.map
